/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AWSDate: { input: any; output: any };
  AWSDateTime: { input: any; output: any };
  AWSEmail: { input: any; output: any };
  AWSIPAddress: { input: any; output: any };
  AWSJSON: { input: any; output: any };
  AWSPhone: { input: any; output: any };
  AWSTime: { input: any; output: any };
  AWSTimestamp: { input: any; output: any };
  AWSURL: { input: any; output: any };
};

export type AfConfigActiveFeature = {
  __typename?: 'AFConfigActiveFeature';
  membershipFeatureId: Scalars['String']['output'];
  overrideContent?: Maybe<Scalars['String']['output']>;
  overrideTooltip?: Maybe<Scalars['String']['output']>;
};

export type AfConfigBranding = {
  __typename?: 'AFConfigBranding';
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  pageBlock1Color?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type AfConfigFeature = {
  __typename?: 'AFConfigFeature';
  defaultContent?: Maybe<Scalars['String']['output']>;
  defaultTooltip?: Maybe<Scalars['String']['output']>;
  membershipFeatureId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type AfConfigOptions = {
  __typename?: 'AFConfigOptions';
  branding?: Maybe<AfConfigBranding>;
  callForPricingPhone?: Maybe<Scalars['String']['output']>;
  contactSupportLink?: Maybe<Scalars['String']['output']>;
  faqQuestions?: Maybe<Array<Maybe<AfConfigOptionsFaqQuestion>>>;
  isSetupMode?: Maybe<Scalars['Boolean']['output']>;
  mostPopularProductId?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  productOrder?: Maybe<Array<Scalars['String']['output']>>;
  requireTosBeforePlans?: Maybe<Scalars['Boolean']['output']>;
  setupCheckoutText?: Maybe<Scalars['String']['output']>;
  showAnnualPrices?: Maybe<Scalars['Boolean']['output']>;
  showContactSupport?: Maybe<Scalars['Boolean']['output']>;
  showFaq?: Maybe<Scalars['Boolean']['output']>;
  showMonthlyPrices?: Maybe<Scalars['Boolean']['output']>;
  showSkipPriceSelection?: Maybe<Scalars['Boolean']['output']>;
  termsOfServiceUrl?: Maybe<Scalars['String']['output']>;
};

export type AfConfigOptionsFaqQuestion = {
  __typename?: 'AFConfigOptionsFaqQuestion';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type AfConfigProduct = {
  __typename?: 'AFConfigProduct';
  activeFeatures?: Maybe<Array<Maybe<AfConfigActiveFeature>>>;
  callForPricing?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  platformSlaId?: Maybe<Scalars['String']['output']>;
  prices: AfConfigProductPrices;
};

export type AfConfigProductPrice = {
  __typename?: 'AFConfigProductPrice';
  amountCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  stripePriceId: Scalars['String']['output'];
};

export type AfConfigProductPrices = {
  __typename?: 'AFConfigProductPrices';
  annual?: Maybe<AfConfigProductPrice>;
  monthly: AfConfigProductPrice;
};

export type ActivationFlowBrandingInput = {
  backgroundImageUrl?: InputMaybe<Scalars['String']['input']>;
  bannerColor?: InputMaybe<Scalars['String']['input']>;
  pageBlock1Color?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type ActivationFlowConfig = {
  __typename?: 'ActivationFlowConfig';
  activationFlowConfigId: Scalars['String']['output'];
  brand?: Maybe<Brand>;
  brandId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  prices?: Maybe<Array<Maybe<PartnerProductPrice>>>;
  updatedAt: Scalars['String']['output'];
};

export type ActivationFlowConfigDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActivationFlowConfigDataInput = {
  activationFlowConfigId?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivationFlowConfigDataResponse = {
  __typename?: 'ActivationFlowConfigDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivationFlowConfig>>>;
};

export type ActivationFlowConfigSearchResponse = {
  __typename?: 'ActivationFlowConfigSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivationFlowConfig>>>;
};

export type ActivationFlowConfigToPrice = {
  __typename?: 'ActivationFlowConfigToPrice';
  activationFlowConfig?: Maybe<ActivationFlowConfig>;
  activationFlowConfigId: Scalars['String']['output'];
  activationFlowConfigToPriceId: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  options: Scalars['String']['output'];
  partnerProductPriceId: Scalars['String']['output'];
  price?: Maybe<PartnerProductPrice>;
  sortGroup?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
};

export type ActivationFlowConfigToPriceDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActivationFlowConfigToPriceDataInput = {
  activationFlowConfigId?: InputMaybe<Scalars['String']['input']>;
  activationFlowConfigToPriceId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  options?: InputMaybe<Scalars['String']['input']>;
  partnerProductPriceId?: InputMaybe<Scalars['String']['input']>;
  sortGroup?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivationFlowConfigToPriceDataResponse = {
  __typename?: 'ActivationFlowConfigToPriceDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivationFlowConfigToPrice>>>;
};

export type ActivationFlowConfigToPriceSearchResponse = {
  __typename?: 'ActivationFlowConfigToPriceSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivationFlowConfigToPrice>>>;
};

export type ActivationFlowOptionsInput = {
  branding?: InputMaybe<ActivationFlowBrandingInput>;
  contactSupportLink?: InputMaybe<Scalars['String']['input']>;
  faqQuestions: Array<FaqQuestionInput>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  requireTosBeforePlans: Scalars['Boolean']['input'];
  setupCheckoutText?: InputMaybe<Scalars['String']['input']>;
  showAnnualPrices: Scalars['Boolean']['input'];
  showContactSupport: Scalars['Boolean']['input'];
  showFaq: Scalars['Boolean']['input'];
  showMonthlyPrices: Scalars['Boolean']['input'];
  showSkipPriceSelection: Scalars['Boolean']['input'];
  termsOfServiceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveChannelsInput = {
  externalIdentifier: Scalars['String']['input'];
  internalIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveMembershipFeature = {
  __typename?: 'ActiveMembershipFeature';
  activeMembershipFeatureId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  membershipFeature?: Maybe<MembershipFeature>;
  membershipFeatureId?: Maybe<Scalars['String']['output']>;
  overrideContent?: Maybe<Scalars['String']['output']>;
  overrideTooltip?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  partnerProduct?: Maybe<PartnerProduct>;
  partnerProductId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ActiveMembershipFeatureDataInput = {
  activeMembershipFeatureId?: InputMaybe<Scalars['String']['input']>;
  membershipFeatureId?: InputMaybe<Scalars['String']['input']>;
  overrideContent?: InputMaybe<Scalars['String']['input']>;
  overrideTooltip?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
};

export type ActiveMembershipFeatureDataResponse = {
  __typename?: 'ActiveMembershipFeatureDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActiveMembershipFeature>>>;
};

export type ActiveMembershipFeatureSearchResponse = {
  __typename?: 'ActiveMembershipFeatureSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActiveMembershipFeature>>>;
};

export type Activity = {
  __typename?: 'Activity';
  activityId: Scalars['String']['output'];
  activityReferences?: Maybe<Array<Maybe<ActivityReference>>>;
  activityTextTemplate?: Maybe<ActivityTextTemplate>;
  activityTextTemplateId?: Maybe<Scalars['Int']['output']>;
  activityType?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<ActivityReference>;
  actorId?: Maybe<Scalars['String']['output']>;
  actorUid?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<Activity>>>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customTextTemplate?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  eventTs?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  parent?: Maybe<Activity>;
  parentActorUid?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ActivityDataInput = {
  activityId?: InputMaybe<Scalars['String']['input']>;
  activityTextTemplateId?: InputMaybe<Scalars['Int']['input']>;
  activityType?: InputMaybe<Scalars['String']['input']>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  actorUid?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  customTextTemplate?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  eventTs?: InputMaybe<Scalars['String']['input']>;
  parentActorUid?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityDataResponse = {
  __typename?: 'ActivityDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Activity>>>;
};

export type ActivityFeed = {
  __typename?: 'ActivityFeed';
  activityType: Scalars['String']['output'];
  actor: ActivityFeedActor;
  actorUid?: Maybe<Scalars['String']['output']>;
  changes: Array<Maybe<ActivityFeedChanges>>;
  entity: Scalars['String']['output'];
  id: Scalars['String']['output'];
  parentActorUid?: Maybe<Scalars['String']['output']>;
  partnerId: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type ActivityFeedActor = {
  __typename?: 'ActivityFeedActor';
  name: Scalars['String']['output'];
};

export type ActivityFeedChanges = {
  __typename?: 'ActivityFeedChanges';
  customType?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previousValue?: Maybe<Scalars['String']['output']>;
  skip?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityFeedEntityEvents = {
  entityName: Scalars['String']['input'];
  operation?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityReference = {
  __typename?: 'ActivityReference';
  activity?: Maybe<Activity>;
  activityId: Scalars['String']['output'];
  activityReferenceId: Scalars['String']['output'];
  actorForActivity?: Maybe<Array<Maybe<Activity>>>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  isRoot?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  referenceIdentity?: Maybe<Scalars['String']['output']>;
  referenceIndex?: Maybe<Scalars['Int']['output']>;
  referenceName?: Maybe<Scalars['String']['output']>;
  referenceType: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  templateEntityId?: Maybe<Scalars['String']['output']>;
};

export type ActivityReferenceDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActivityReferenceDataInput = {
  activityId?: InputMaybe<Scalars['String']['input']>;
  activityReferenceId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  referenceIdentity?: InputMaybe<Scalars['String']['input']>;
  referenceIndex?: InputMaybe<Scalars['Int']['input']>;
  referenceName?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  templateEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityReferenceDataResponse = {
  __typename?: 'ActivityReferenceDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivityReference>>>;
};

export type ActivityReferenceSearchResponse = {
  __typename?: 'ActivityReferenceSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivityReference>>>;
};

export type ActivitySearchResponse = {
  __typename?: 'ActivitySearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Activity>>>;
};

export type ActivityTextTemplate = {
  __typename?: 'ActivityTextTemplate';
  action?: Maybe<Scalars['String']['output']>;
  activityRecordsViaActivityTextTemplateIdActivityTextTemplateId?: Maybe<
    Array<Maybe<Activity>>
  >;
  activityTextTemplateId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  textTemplate: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ActivityTextTemplateDataInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  activityTextTemplateId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  textTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityTextTemplateDataResponse = {
  __typename?: 'ActivityTextTemplateDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivityTextTemplate>>>;
};

export type ActivityTextTemplateSearchResponse = {
  __typename?: 'ActivityTextTemplateSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ActivityTextTemplate>>>;
};

export type AddCgCustomDomainInput = {
  hostname: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type AddCgCustomDomainResponse = {
  __typename?: 'AddCgCustomDomainResponse';
  cnameTarget: Scalars['String']['output'];
  hostname: Scalars['String']['output'];
  partnerCustomDomainId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AddPartnerCgCustomDomainInput = {
  hostname: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type Address = {
  __typename?: 'Address';
  accountOwner?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  addressId: Scalars['String']['output'];
  addressSubscriptions?: Maybe<Array<Maybe<AddressSubscription>>>;
  addressSummaryRecordsViaAddressIdAddressId?: Maybe<Array<Maybe<AddressSummary>>>;
  associatedConversations?: Maybe<Array<Maybe<Conversation>>>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  callTranscriptions?: Maybe<Array<Maybe<CallTranscription>>>;
  ccCardExp?: Maybe<Scalars['String']['output']>;
  ccCardType?: Maybe<Scalars['String']['output']>;
  ccLast4?: Maybe<Scalars['String']['output']>;
  chargifySubId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientActivatedMembership?: Maybe<Scalars['String']['output']>;
  clientSelectedMembership?: Maybe<Scalars['String']['output']>;
  clients?: Maybe<Array<Maybe<Client>>>;
  country?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Scalars['String']['output']>;
  cppExpDate?: Maybe<Scalars['String']['output']>;
  cppLength?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  creditCardProvided?: Maybe<Scalars['String']['output']>;
  customAttributes?: Maybe<Scalars['String']['output']>;
  day0ZdTicketId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  emailInterval?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<AddressFile>>>;
  hvacIntegration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  integrationDrivers?: Maybe<Array<Maybe<IntegrationDriver>>>;
  isMonitored?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  lastEmailSendDate?: Maybe<Scalars['String']['output']>;
  lastEmailSent?: Maybe<Scalars['String']['output']>;
  membershipClientActivatedMembership?: Maybe<Membership>;
  membershipClientSelectedMembership?: Maybe<Membership>;
  membershipSalesNotes?: Maybe<Scalars['String']['output']>;
  nextEmailSendDate?: Maybe<Scalars['String']['output']>;
  orgNotes?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  pdDealId?: Maybe<Scalars['String']['output']>;
  pdOrgId?: Maybe<Scalars['String']['output']>;
  pdOwnerId?: Maybe<Scalars['String']['output']>;
  platformSla?: Maybe<PlatformSla>;
  platformSlaId?: Maybe<Scalars['String']['output']>;
  platformUser?: Maybe<PlatformUser>;
  preSoldMemberships?: Maybe<Array<Maybe<PreSoldMembership>>>;
  primaryClient?: Maybe<Client>;
  primaryClientId?: Maybe<Scalars['String']['output']>;
  primaryProjectId?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Array<Maybe<Project>>>;
  rsmNotes?: Maybe<Scalars['String']['output']>;
  selectedPricePointId?: Maybe<Scalars['String']['output']>;
  site3rdPartyNetworkProvider?: Maybe<Scalars['String']['output']>;
  siteAccessControlSystemSmartLocks?: Maybe<Scalars['String']['output']>;
  siteAudioSystemType?: Maybe<Scalars['String']['output']>;
  siteCameraSystemBrand?: Maybe<Scalars['String']['output']>;
  siteCameraSystemType?: Maybe<Scalars['String']['output']>;
  siteControlSystemBrand?: Maybe<Scalars['String']['output']>;
  siteHvacBrand?: Maybe<Scalars['String']['output']>;
  siteIntercom?: Maybe<Scalars['String']['output']>;
  siteInternetService?: Maybe<Scalars['String']['output']>;
  siteLightingSystemBrand?: Maybe<Scalars['String']['output']>;
  siteLightingSystemType?: Maybe<Scalars['String']['output']>;
  siteNetworkLocation?: Maybe<Scalars['String']['output']>;
  sitePhoneSystemBrand?: Maybe<Scalars['String']['output']>;
  sitePhoneSystemType?: Maybe<Scalars['String']['output']>;
  sitePrimaryAudioInterface?: Maybe<Scalars['String']['output']>;
  sitePrimaryEquipmentLocation?: Maybe<Scalars['String']['output']>;
  siteRemoteSystemsManagement?: Maybe<Scalars['String']['output']>;
  siteRsmUrl?: Maybe<Scalars['String']['output']>;
  siteSecondaryRemoteSystemsManagement?: Maybe<Scalars['String']['output']>;
  siteSecondaryRsmUrl?: Maybe<Scalars['String']['output']>;
  siteSecuritySystemBrand?: Maybe<Scalars['String']['output']>;
  siteSecuritySystemIntegrated?: Maybe<Scalars['String']['output']>;
  siteShadeBrand?: Maybe<Scalars['String']['output']>;
  siteShadeInterface?: Maybe<Scalars['String']['output']>;
  siteShadeType?: Maybe<Scalars['String']['output']>;
  siteStreamingPlatform?: Maybe<Scalars['String']['output']>;
  siteSystemsSupported?: Maybe<Scalars['String']['output']>;
  siteTertiaryRemoteSystemsManagement?: Maybe<Scalars['String']['output']>;
  siteTertiaryRsmUrl?: Maybe<Scalars['String']['output']>;
  siteTvServiceProvider?: Maybe<Scalars['String']['output']>;
  siteType?: Maybe<Scalars['String']['output']>;
  siteVideoDistributionBrand?: Maybe<Scalars['String']['output']>;
  siteVideoDoorbell?: Maybe<Scalars['String']['output']>;
  siteVideoSystemType?: Maybe<Scalars['String']['output']>;
  siteWiredNetworkBrand?: Maybe<Scalars['String']['output']>;
  siteWirelessNetworkBrand?: Maybe<Scalars['String']['output']>;
  sla?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptionCreatedAt?: Maybe<Scalars['String']['output']>;
  tosAccepted?: Maybe<Scalars['String']['output']>;
  tosSubmissionDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  zdOrgId?: Maybe<Scalars['Float']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AddressDataInput = {
  accountOwner?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  ccCardExp?: InputMaybe<Scalars['String']['input']>;
  ccCardType?: InputMaybe<Scalars['String']['input']>;
  ccLast4?: InputMaybe<Scalars['String']['input']>;
  chargifySubId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientActivatedMembership?: InputMaybe<Scalars['String']['input']>;
  clientSelectedMembership?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  cppExpDate?: InputMaybe<Scalars['String']['input']>;
  cppLength?: InputMaybe<Scalars['String']['input']>;
  creditCardProvided?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Scalars['String']['input']>;
  day0ZdTicketId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  emailInterval?: InputMaybe<Scalars['String']['input']>;
  hvacIntegration?: InputMaybe<Scalars['String']['input']>;
  isMonitored?: InputMaybe<Scalars['Boolean']['input']>;
  lastEmailSendDate?: InputMaybe<Scalars['String']['input']>;
  lastEmailSent?: InputMaybe<Scalars['String']['input']>;
  membershipSalesNotes?: InputMaybe<Scalars['String']['input']>;
  nextEmailSendDate?: InputMaybe<Scalars['String']['input']>;
  orgNotes?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  pdDealId?: InputMaybe<Scalars['String']['input']>;
  pdOrgId?: InputMaybe<Scalars['String']['input']>;
  pdOwnerId?: InputMaybe<Scalars['String']['input']>;
  platformSlaId?: InputMaybe<Scalars['String']['input']>;
  primaryClientId?: InputMaybe<Scalars['String']['input']>;
  primaryProjectId?: InputMaybe<Scalars['String']['input']>;
  rsmNotes?: InputMaybe<Scalars['String']['input']>;
  selectedPricePointId?: InputMaybe<Scalars['String']['input']>;
  site3rdPartyNetworkProvider?: InputMaybe<Scalars['String']['input']>;
  siteAccessControlSystemSmartLocks?: InputMaybe<Scalars['String']['input']>;
  siteAudioSystemType?: InputMaybe<Scalars['String']['input']>;
  siteCameraSystemBrand?: InputMaybe<Scalars['String']['input']>;
  siteCameraSystemType?: InputMaybe<Scalars['String']['input']>;
  siteControlSystemBrand?: InputMaybe<Scalars['String']['input']>;
  siteHvacBrand?: InputMaybe<Scalars['String']['input']>;
  siteIntercom?: InputMaybe<Scalars['String']['input']>;
  siteInternetService?: InputMaybe<Scalars['String']['input']>;
  siteLightingSystemBrand?: InputMaybe<Scalars['String']['input']>;
  siteLightingSystemType?: InputMaybe<Scalars['String']['input']>;
  siteNetworkLocation?: InputMaybe<Scalars['String']['input']>;
  sitePhoneSystemBrand?: InputMaybe<Scalars['String']['input']>;
  sitePhoneSystemType?: InputMaybe<Scalars['String']['input']>;
  sitePrimaryAudioInterface?: InputMaybe<Scalars['String']['input']>;
  sitePrimaryEquipmentLocation?: InputMaybe<Scalars['String']['input']>;
  siteRemoteSystemsManagement?: InputMaybe<Scalars['String']['input']>;
  siteRsmUrl?: InputMaybe<Scalars['String']['input']>;
  siteSecondaryRemoteSystemsManagement?: InputMaybe<Scalars['String']['input']>;
  siteSecondaryRsmUrl?: InputMaybe<Scalars['String']['input']>;
  siteSecuritySystemBrand?: InputMaybe<Scalars['String']['input']>;
  siteSecuritySystemIntegrated?: InputMaybe<Scalars['String']['input']>;
  siteShadeBrand?: InputMaybe<Scalars['String']['input']>;
  siteShadeInterface?: InputMaybe<Scalars['String']['input']>;
  siteShadeType?: InputMaybe<Scalars['String']['input']>;
  siteStreamingPlatform?: InputMaybe<Scalars['String']['input']>;
  siteSystemsSupported?: InputMaybe<Scalars['String']['input']>;
  siteTertiaryRemoteSystemsManagement?: InputMaybe<Scalars['String']['input']>;
  siteTertiaryRsmUrl?: InputMaybe<Scalars['String']['input']>;
  siteTvServiceProvider?: InputMaybe<Scalars['String']['input']>;
  siteType?: InputMaybe<Scalars['String']['input']>;
  siteVideoDistributionBrand?: InputMaybe<Scalars['String']['input']>;
  siteVideoDoorbell?: InputMaybe<Scalars['String']['input']>;
  siteVideoSystemType?: InputMaybe<Scalars['String']['input']>;
  siteWiredNetworkBrand?: InputMaybe<Scalars['String']['input']>;
  siteWirelessNetworkBrand?: InputMaybe<Scalars['String']['input']>;
  sla?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  subscriptionCreatedAt?: InputMaybe<Scalars['String']['input']>;
  tosAccepted?: InputMaybe<Scalars['String']['input']>;
  tosSubmissionDate?: InputMaybe<Scalars['String']['input']>;
  zdOrgId?: InputMaybe<Scalars['Float']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressDataResponse = {
  __typename?: 'AddressDataResponse';
  metadata: MetaDataWithSearch;
  records?: Maybe<Array<Maybe<Address>>>;
};

export type AddressFile = {
  __typename?: 'AddressFile';
  address?: Maybe<Address>;
  addressFileId: Scalars['String']['output'];
  addressId: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  pinnedAt?: Maybe<Scalars['String']['output']>;
  size: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
  uploadedByUser?: Maybe<PlatformUser>;
};

export type AddressFileDataInput = {
  addressFileId?: InputMaybe<Scalars['String']['input']>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  pinnedAt?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
};

export type AddressFileDataResponse = {
  __typename?: 'AddressFileDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AddressFile>>>;
};

export type AddressFileSearchResponse = {
  __typename?: 'AddressFileSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AddressFile>>>;
};

export type AddressSearchResponse = {
  __typename?: 'AddressSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Address>>>;
};

export type AddressSubscription = {
  __typename?: 'AddressSubscription';
  address?: Maybe<Address>;
  addressId: Scalars['String']['output'];
  addressSubscriptionId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerProduct?: Maybe<PartnerProduct>;
  partnerProductId?: Maybe<Scalars['String']['output']>;
  pausedUntil?: Maybe<Scalars['String']['output']>;
  phase: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AddressSubscriptionDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  addressSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  pausedUntil?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSubscriptionDataResponse = {
  __typename?: 'AddressSubscriptionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AddressSubscription>>>;
};

export type AddressSubscriptionSearchResponse = {
  __typename?: 'AddressSubscriptionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AddressSubscription>>>;
};

export type AddressSummary = {
  __typename?: 'AddressSummary';
  addressId: Scalars['String']['output'];
  addressSummaryId: Scalars['String']['output'];
  addressViaAddressIdAddressId?: Maybe<Address>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  intermediateSummary: Scalars['String']['output'];
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partnerId: Scalars['Int']['output'];
  partnerViaPartnerIdPartnerId?: Maybe<Partner>;
  shortSummary: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AddressSummaryDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AddressSummaryDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  addressSummaryId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  intermediateSummary?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  shortSummary?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSummaryDataResponse = {
  __typename?: 'AddressSummaryDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AddressSummary>>>;
};

export type AddressSummarySearchResponse = {
  __typename?: 'AddressSummarySearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AddressSummary>>>;
};

export type AiAgentConversation = {
  __typename?: 'AiAgentConversation';
  agentConfig?: Maybe<Scalars['String']['output']>;
  aiAgentConversationId: Scalars['String']['output'];
  aiAgentModelCalls?: Maybe<Array<Maybe<AiAgentModelCall>>>;
  aiAgentRuns?: Maybe<Array<Maybe<AiAgentRun>>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  historyActorId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  operatorInstructions?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  providerConfig: Scalars['String']['output'];
  sidekickAiAgentConversations?: Maybe<Array<Maybe<SidekickAiAgentConversation>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userInstructions?: Maybe<Scalars['String']['output']>;
};

export type AiAgentConversationDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AiAgentConversationDataInput = {
  agentConfig?: InputMaybe<Scalars['String']['input']>;
  aiAgentConversationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  historyActorId?: InputMaybe<Scalars['String']['input']>;
  operatorInstructions?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  providerConfig?: InputMaybe<Scalars['String']['input']>;
  userInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type AiAgentConversationDataResponse = {
  __typename?: 'AiAgentConversationDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentConversation>>>;
};

export type AiAgentConversationSearchResponse = {
  __typename?: 'AiAgentConversationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentConversation>>>;
};

export type AiAgentInvocationRequest = {
  __typename?: 'AiAgentInvocationRequest';
  body: Scalars['String']['output'];
  headers: Array<AiAgentRequestHeader>;
  method: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AiAgentModelCall = {
  __typename?: 'AiAgentModelCall';
  aiAgentConversation?: Maybe<AiAgentConversation>;
  aiAgentConversationId: Scalars['String']['output'];
  aiAgentModelCallId: Scalars['String']['output'];
  aiAgentRun?: Maybe<AiAgentRun>;
  aiAgentRunId: Scalars['String']['output'];
  aiAgentToolCalls?: Maybe<Array<Maybe<AiAgentToolCall>>>;
  cacheReadInputTokens?: Maybe<Scalars['Int']['output']>;
  cacheWriteInputTokens?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  finishReason: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  nonCachedInputTokens?: Maybe<Scalars['Int']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  providerResponseId?: Maybe<Scalars['String']['output']>;
  rawUsage?: Maybe<Scalars['String']['output']>;
  requestModel: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AiAgentModelCallDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AiAgentModelCallDataInput = {
  aiAgentConversationId?: InputMaybe<Scalars['String']['input']>;
  aiAgentModelCallId?: InputMaybe<Scalars['String']['input']>;
  aiAgentRunId?: InputMaybe<Scalars['String']['input']>;
  cacheReadInputTokens?: InputMaybe<Scalars['Int']['input']>;
  cacheWriteInputTokens?: InputMaybe<Scalars['Int']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  finishReason?: InputMaybe<Scalars['String']['input']>;
  inputTokens?: InputMaybe<Scalars['Int']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  outputTokens?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  providerResponseId?: InputMaybe<Scalars['String']['input']>;
  rawUsage?: InputMaybe<Scalars['String']['input']>;
  requestModel?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
};

export type AiAgentModelCallDataResponse = {
  __typename?: 'AiAgentModelCallDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentModelCall>>>;
};

export type AiAgentModelCallSearchResponse = {
  __typename?: 'AiAgentModelCallSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentModelCall>>>;
};

export type AiAgentRequestHeader = {
  __typename?: 'AiAgentRequestHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AiAgentRun = {
  __typename?: 'AiAgentRun';
  aiAgentConversation?: Maybe<AiAgentConversation>;
  aiAgentConversationId: Scalars['String']['output'];
  aiAgentModelCalls?: Maybe<Array<Maybe<AiAgentModelCall>>>;
  aiAgentRunId: Scalars['String']['output'];
  aiAgentToolCalls?: Maybe<Array<Maybe<AiAgentToolCall>>>;
  createdAt: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AiAgentRunDataInput = {
  aiAgentConversationId?: InputMaybe<Scalars['String']['input']>;
  aiAgentRunId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type AiAgentRunDataResponse = {
  __typename?: 'AiAgentRunDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentRun>>>;
};

export type AiAgentRunSearchResponse = {
  __typename?: 'AiAgentRunSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentRun>>>;
};

export type AiAgentToolCall = {
  __typename?: 'AiAgentToolCall';
  aiAgentModelCall?: Maybe<AiAgentModelCall>;
  aiAgentModelCallId: Scalars['String']['output'];
  aiAgentRun?: Maybe<AiAgentRun>;
  aiAgentRunId: Scalars['String']['output'];
  aiAgentToolCallId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  providerToolCallId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusDetail?: Maybe<Scalars['String']['output']>;
  toolName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AiAgentToolCallDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AiAgentToolCallDataInput = {
  aiAgentModelCallId?: InputMaybe<Scalars['String']['input']>;
  aiAgentRunId?: InputMaybe<Scalars['String']['input']>;
  aiAgentToolCallId?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  providerToolCallId?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusDetail?: InputMaybe<Scalars['String']['input']>;
  toolName?: InputMaybe<Scalars['String']['input']>;
};

export type AiAgentToolCallDataResponse = {
  __typename?: 'AiAgentToolCallDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentToolCall>>>;
};

export type AiAgentToolCallSearchResponse = {
  __typename?: 'AiAgentToolCallSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiAgentToolCall>>>;
};

export type AiHelpLog = {
  __typename?: 'AiHelpLog';
  aiPromptViaPromptIdPromptId?: Maybe<AiPrompt>;
  callTranscriptionViaTranscriptionIdTranscriptionId?: Maybe<CallTranscription>;
  content: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  logId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  promptId: Scalars['String']['output'];
  transcriptionId: Scalars['String']['output'];
};

export type AiHelpLogDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  logId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  promptId?: InputMaybe<Scalars['String']['input']>;
  transcriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type AiHelpLogDataResponse = {
  __typename?: 'AiHelpLogDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiHelpLog>>>;
};

export type AiHelpLogSearchResponse = {
  __typename?: 'AiHelpLogSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiHelpLog>>>;
};

export type AiPrompt = {
  __typename?: 'AiPrompt';
  active?: Maybe<Scalars['Boolean']['output']>;
  aiHelpLogRecordsViaPromptIdPromptId?: Maybe<Array<Maybe<AiHelpLog>>>;
  content: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<PlatformUser>;
  friendlyName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isPublic: Scalars['Boolean']['output'];
  macros?: Maybe<Array<Maybe<Macro>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  promptId: Scalars['String']['output'];
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
};

export type AiPromptDataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  promptId?: InputMaybe<Scalars['String']['input']>;
};

export type AiPromptDataResponse = {
  __typename?: 'AiPromptDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiPrompt>>>;
};

export type AiPromptSearchResponse = {
  __typename?: 'AiPromptSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<AiPrompt>>>;
};

export type AiPromptToUserGroup = {
  __typename?: 'AiPromptToUserGroup';
  createdAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  promptId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userGroupId: Scalars['String']['output'];
};

export type AiPromptToUserGroupDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  promptId?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type ArsPayoutRun = {
  __typename?: 'ArsPayoutRun';
  achPaidAmount: Scalars['Int']['output'];
  arsPayoutRunId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<PlatformUser>;
  failedAmount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['String']['output']>;
  guardCompletedAt?: Maybe<Scalars['String']['output']>;
  heartbeatAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastAttemptedTransfers?: Maybe<Array<Maybe<ArsTransfer>>>;
  paidAmount: Scalars['Int']['output'];
  paidCount: Scalars['Int']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  periodFrom: Scalars['String']['output'];
  periodTo: Scalars['String']['output'];
  reconciledCount: Scalars['Int']['output'];
  runReports?: Maybe<Array<Maybe<ArsRunReport>>>;
  settledCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stopReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  workerToken?: Maybe<Scalars['String']['output']>;
};

export type ArsPayoutRunDataInput = {
  achPaidAmount?: InputMaybe<Scalars['Int']['input']>;
  arsPayoutRunId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  failedAmount?: InputMaybe<Scalars['Int']['input']>;
  failedCount?: InputMaybe<Scalars['Int']['input']>;
  finishedAt?: InputMaybe<Scalars['String']['input']>;
  guardCompletedAt?: InputMaybe<Scalars['String']['input']>;
  heartbeatAt?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Int']['input']>;
  paidCount?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  periodFrom?: InputMaybe<Scalars['String']['input']>;
  periodTo?: InputMaybe<Scalars['String']['input']>;
  reconciledCount?: InputMaybe<Scalars['Int']['input']>;
  settledCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stopReason?: InputMaybe<Scalars['String']['input']>;
  workerToken?: InputMaybe<Scalars['String']['input']>;
};

export type ArsPayoutRunDataResponse = {
  __typename?: 'ArsPayoutRunDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ArsPayoutRun>>>;
};

export type ArsPayoutRunIdInput = {
  runId: Scalars['String']['input'];
};

export type ArsPayoutRunItem = {
  __typename?: 'ArsPayoutRunItem';
  achPaidAmount: Scalars['Int']['output'];
  arsPayoutRunId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  failedAmount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['String']['output']>;
  guardCompletedAt?: Maybe<Scalars['String']['output']>;
  paidAmount: Scalars['Int']['output'];
  paidCount: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  periodFrom: Scalars['String']['output'];
  periodTo: Scalars['String']['output'];
  reconciledCount: Scalars['Int']['output'];
  settledCount: Scalars['Int']['output'];
  status: ArsPayoutRunStatus;
  stopReason?: Maybe<Scalars['String']['output']>;
};

export type ArsPayoutRunSearchResponse = {
  __typename?: 'ArsPayoutRunSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ArsPayoutRun>>>;
};

export enum ArsPayoutRunStatus {
  Completed = 'completed',
  Failed = 'failed',
  Paused = 'paused',
  Queued = 'queued',
  Running = 'running',
}

export type ArsRunReport = {
  __typename?: 'ArsRunReport';
  arsPayoutRunId?: Maybe<Scalars['String']['output']>;
  arsRunReportId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  payoutRun?: Maybe<ArsPayoutRun>;
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  report: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ArsRunReportDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArsRunReportDataInput = {
  arsPayoutRunId?: InputMaybe<Scalars['String']['input']>;
  arsRunReportId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ArsRunReportDataResponse = {
  __typename?: 'ArsRunReportDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ArsRunReport>>>;
};

export type ArsRunReportSearchResponse = {
  __typename?: 'ArsRunReportSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ArsRunReport>>>;
};

export type ArsTransfer = {
  __typename?: 'ArsTransfer';
  addressId?: Maybe<Scalars['String']['output']>;
  amountReversed: Scalars['Int']['output'];
  arsTransferId: Scalars['String']['output'];
  billingInterval?: Maybe<Scalars['String']['output']>;
  billingIntervalCount?: Maybe<Scalars['Int']['output']>;
  chargeId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  grossChargeAmount: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  lastPayoutAttemptedAt?: Maybe<Scalars['String']['output']>;
  lastPayoutErrorCode?: Maybe<Scalars['String']['output']>;
  lastPayoutErrorMessage?: Maybe<Scalars['String']['output']>;
  lastPayoutRun?: Maybe<ArsPayoutRun>;
  lastPayoutRunId?: Maybe<Scalars['String']['output']>;
  netTransferAmount: Scalars['Int']['output'];
  onevisionFee: Scalars['Int']['output'];
  onevisionFeePercent: Scalars['Float']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  payoutAttemptCount: Scalars['Int']['output'];
  stripeFee: Scalars['Int']['output'];
  stripeTransferId?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  transferredAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ArsTransferDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  amountReversed?: InputMaybe<Scalars['Int']['input']>;
  arsTransferId?: InputMaybe<Scalars['String']['input']>;
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  billingIntervalCount?: InputMaybe<Scalars['Int']['input']>;
  chargeId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  grossChargeAmount?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  lastPayoutAttemptedAt?: InputMaybe<Scalars['String']['input']>;
  lastPayoutErrorCode?: InputMaybe<Scalars['String']['input']>;
  lastPayoutErrorMessage?: InputMaybe<Scalars['String']['input']>;
  lastPayoutRunId?: InputMaybe<Scalars['String']['input']>;
  netTransferAmount?: InputMaybe<Scalars['Int']['input']>;
  onevisionFee?: InputMaybe<Scalars['Int']['input']>;
  onevisionFeePercent?: InputMaybe<Scalars['Float']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  payoutAttemptCount?: InputMaybe<Scalars['Int']['input']>;
  stripeFee?: InputMaybe<Scalars['Int']['input']>;
  stripeTransferId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  transferredAt?: InputMaybe<Scalars['String']['input']>;
};

export type ArsTransferDataResponse = {
  __typename?: 'ArsTransferDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ArsTransfer>>>;
};

export type ArsTransferSearchResponse = {
  __typename?: 'ArsTransferSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ArsTransfer>>>;
};

export type AssignLabelToClientToAddressInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  labelId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type AssignLegalDocumentInput = {
  brandId: Scalars['String']['input'];
  kind: LegalDocumentKind;
  legalDocumentId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type AssociateClientsWithAddressInput = {
  addressId: Scalars['String']['input'];
  clientIds: Array<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type AssociateClientsWithAddressResponse = {
  __typename?: 'AssociateClientsWithAddressResponse';
  success: Scalars['Boolean']['output'];
};

export type AssociateParticipantWithClientInput = {
  client: ClientDataInput;
  participant?: InputMaybe<ConversationParticipantDataInput>;
  partnerId: Scalars['Int']['input'];
};

export type AssociateParticipantWithClientResponse = {
  __typename?: 'AssociateParticipantWithClientResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssociatedConversation = {
  __typename?: 'AssociatedConversation';
  friendlyId: Scalars['String']['output'];
  issue?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  shortSummary?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusLastUpdatedAt?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type AssociatedConversationFilter = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subjectContains?: InputMaybe<Scalars['String']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type AssociatedConversationInput = {
  filter?: InputMaybe<AssociatedConversationFilter>;
  params?: InputMaybe<AssociatedConversationParams>;
};

export type AssociatedConversationParams = {
  includeCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AttributeDependency = {
  __typename?: 'AttributeDependency';
  attribute: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AutogenerateSiteDocsInput = {
  addressId: Scalars['String']['input'];
  fileUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type AutogenerateSiteDocsResult = {
  __typename?: 'AutogenerateSiteDocsResult';
  hvacIntegration?: Maybe<Scalars['String']['output']>;
  orgNotes?: Maybe<Scalars['String']['output']>;
  site3rdPartyNetworkProvider?: Maybe<Scalars['String']['output']>;
  siteAccessControlSystemSmartLocks?: Maybe<Scalars['String']['output']>;
  siteAudioSystemType?: Maybe<Scalars['String']['output']>;
  siteCameraSystemBrand?: Maybe<Scalars['String']['output']>;
  siteCameraSystemType?: Maybe<Scalars['String']['output']>;
  siteControlSystemBrand?: Maybe<Scalars['String']['output']>;
  siteHvacBrand?: Maybe<Scalars['String']['output']>;
  siteIntercom?: Maybe<Scalars['String']['output']>;
  siteInternetService?: Maybe<Scalars['String']['output']>;
  siteLightingSystemBrand?: Maybe<Scalars['String']['output']>;
  siteLightingSystemType?: Maybe<Scalars['String']['output']>;
  siteNetworkLocation?: Maybe<Scalars['String']['output']>;
  sitePhoneSystemBrand?: Maybe<Scalars['String']['output']>;
  sitePhoneSystemType?: Maybe<Scalars['String']['output']>;
  sitePrimaryAudioInterface?: Maybe<Scalars['String']['output']>;
  sitePrimaryEquipmentLocation?: Maybe<Scalars['String']['output']>;
  siteRemoteSystemsManagement?: Maybe<Scalars['String']['output']>;
  siteSecuritySystemBrand?: Maybe<Scalars['String']['output']>;
  siteSecuritySystemIntegrated?: Maybe<Scalars['String']['output']>;
  siteShadeBrand?: Maybe<Scalars['String']['output']>;
  siteShadeInterface?: Maybe<Scalars['String']['output']>;
  siteShadeType?: Maybe<Scalars['String']['output']>;
  siteStreamingPlatform?: Maybe<Scalars['String']['output']>;
  siteTvServiceProvider?: Maybe<Scalars['String']['output']>;
  siteVideoDistributionBrand?: Maybe<Scalars['String']['output']>;
  siteVideoDoorbell?: Maybe<Scalars['String']['output']>;
  siteVideoSystemType?: Maybe<Scalars['String']['output']>;
  siteWiredNetworkBrand?: Maybe<Scalars['String']['output']>;
  siteWirelessNetworkBrand?: Maybe<Scalars['String']['output']>;
};

export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdByUserId?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  params?: Maybe<Scalars['AWSJSON']['output']>;
  partnerId: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  status: BackgroundJobStatus;
  succeededCount: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BackgroundJobError = {
  __typename?: 'BackgroundJobError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type BackgroundJobItem = {
  __typename?: 'BackgroundJobItem';
  attempts: Scalars['Int']['output'];
  error?: Maybe<BackgroundJobError>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  itemKey: Scalars['String']['output'];
  result?: Maybe<Scalars['AWSJSON']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: BackgroundJobItemStatus;
};

export enum BackgroundJobItemStatus {
  Failed = 'failed',
  Processing = 'processing',
  Queued = 'queued',
  Succeeded = 'succeeded',
}

export enum BackgroundJobStatus {
  Completed = 'completed',
  CompletedWithErrors = 'completed_with_errors',
  Failed = 'failed',
  Queued = 'queued',
  Running = 'running',
}

export type Behavior = {
  __typename?: 'Behavior';
  actions: Scalars['String']['output'];
  behaviorId: Scalars['String']['output'];
  behaviorTrigger: Scalars['String']['output'];
  conditions: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  sequences?: Maybe<Array<Maybe<BehaviorSequence>>>;
  updatedAt: Scalars['String']['output'];
};

export type BehaviorDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BehaviorConfig = {
  __typename?: 'BehaviorConfig';
  actionTypes: Array<BehaviorConfigActionType>;
  actions: BehaviorConfigActions;
  conditionTypes: Array<BehaviorConfigConditionType>;
  conditions: BehaviorConfigConditions;
  operators: BehaviorConfigOperatorsByUiType;
  triggers: Array<BehaviorConfigTrigger>;
  version: Scalars['String']['output'];
};

export type BehaviorConfigActionType = {
  __typename?: 'BehaviorConfigActionType';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BehaviorConfigActions = {
  __typename?: 'BehaviorConfigActions';
  blockConversationRequester: BehaviorConfigBlockConversationRequesterAction;
  createConversationMessageDraft: BehaviorConfigCreateConversationMessageDraftAction;
  createTwilioTask: BehaviorConfigCreateTwilioTaskAction;
  data: Array<BehaviorConfigDataAction>;
  deleteConversation: BehaviorConfigDeleteConversationAction;
  endSmsSession: BehaviorConfigEndSmsSessionAction;
  manageConversationLabels: BehaviorConfigManageConversationLabelsAction;
  manageSubAssignees: BehaviorConfigManageSubAssigneesAction;
  runTriage: BehaviorConfigRunTriageAction;
  sendConversationMessage: BehaviorConfigSendConversationMessageAction;
  sendSlackMessage: BehaviorConfigSendSlackMessageAction;
  signal: BehaviorConfigSignalAction;
  webhook: BehaviorConfigWebhookAction;
};

export type BehaviorConfigActorCondition = {
  __typename?: 'BehaviorConfigActorCondition';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  operators?: Maybe<Array<BehaviorConfigOperator>>;
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  triggers: Array<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigBlockConversationRequesterAction = {
  __typename?: 'BehaviorConfigBlockConversationRequesterAction';
  attributes: Array<BehaviorConfigParameterlessActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigConditionType = {
  __typename?: 'BehaviorConfigConditionType';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BehaviorConfigConditions = {
  __typename?: 'BehaviorConfigConditions';
  actor: Array<BehaviorConfigActorCondition>;
  contactCenterHours: Array<BehaviorConfigContactCenterHoursCondition>;
  customSchedule: Array<BehaviorConfigCustomScheduleCondition>;
  data: Array<BehaviorConfigDataCondition>;
  partnerBusinessHours: Array<BehaviorConfigPartnerBusinessHoursCondition>;
  partnerSetting: Array<BehaviorConfigPartnerSettingCondition>;
};

export type BehaviorConfigContactCenterHoursCondition = {
  __typename?: 'BehaviorConfigContactCenterHoursCondition';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  operators?: Maybe<Array<BehaviorConfigOperator>>;
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  triggers: Array<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigCreateConversationMessageDraftAction = {
  __typename?: 'BehaviorConfigCreateConversationMessageDraftAction';
  attributes: Array<BehaviorConfigCreateConversationMessageDraftActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigCreateConversationMessageDraftActionAttribute = {
  __typename?: 'BehaviorConfigCreateConversationMessageDraftActionAttribute';
  dependsOn?: Maybe<Array<Maybe<AttributeDependency>>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigCreateTwilioTaskAction = {
  __typename?: 'BehaviorConfigCreateTwilioTaskAction';
  attributes: Array<BehaviorConfigCreateTwilioTaskActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigCreateTwilioTaskActionAttribute = {
  __typename?: 'BehaviorConfigCreateTwilioTaskActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigCustomScheduleCondition = {
  __typename?: 'BehaviorConfigCustomScheduleCondition';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  operators?: Maybe<Array<BehaviorConfigOperator>>;
  triggers: Array<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigDataAction = {
  __typename?: 'BehaviorConfigDataAction';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  optionsQuery?: Maybe<BehaviorConfigOptionsQuery>;
  triggers: Array<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigDataCondition = {
  __typename?: 'BehaviorConfigDataCondition';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  group: Scalars['String']['output'];
  operators?: Maybe<Array<BehaviorConfigOperator>>;
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  optionsQuery?: Maybe<BehaviorConfigOptionsQuery>;
  triggers: Array<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigDeleteConversationAction = {
  __typename?: 'BehaviorConfigDeleteConversationAction';
  attributes: Array<BehaviorConfigParameterlessActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigEndSmsSessionAction = {
  __typename?: 'BehaviorConfigEndSmsSessionAction';
  attributes: Array<BehaviorConfigParameterlessActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigManageConversationLabelsAction = {
  __typename?: 'BehaviorConfigManageConversationLabelsAction';
  attributes: Array<BehaviorConfigManageConversationLabelsActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigManageConversationLabelsActionAttribute = {
  __typename?: 'BehaviorConfigManageConversationLabelsActionAttribute';
  label: Scalars['String']['output'];
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  optionsQuery?: Maybe<BehaviorConfigOptionsQuery>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigManageSubAssigneesAction = {
  __typename?: 'BehaviorConfigManageSubAssigneesAction';
  attributes: Array<BehaviorConfigManageSubAssigneesActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigManageSubAssigneesActionAttribute = {
  __typename?: 'BehaviorConfigManageSubAssigneesActionAttribute';
  label: Scalars['String']['output'];
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  optionsQuery?: Maybe<BehaviorConfigOptionsQuery>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigOperator = {
  __typename?: 'BehaviorConfigOperator';
  arity: Scalars['String']['output'];
  label: Scalars['String']['output'];
  triggers?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
};

export type BehaviorConfigOperatorsByUiType = {
  __typename?: 'BehaviorConfigOperatorsByUIType';
  boolean: Array<BehaviorConfigOperator>;
  date: Array<BehaviorConfigOperator>;
  list: Array<BehaviorConfigOperator>;
  number: Array<BehaviorConfigOperator>;
  text: Array<BehaviorConfigOperator>;
  textarea: Array<BehaviorConfigOperator>;
};

export type BehaviorConfigOption = {
  __typename?: 'BehaviorConfigOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BehaviorConfigOptionsQuery = {
  __typename?: 'BehaviorConfigOptionsQuery';
  graphqlQuery: Scalars['String']['output'];
};

export type BehaviorConfigParameterlessActionAttribute = {
  __typename?: 'BehaviorConfigParameterlessActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigPartnerBusinessHoursCondition = {
  __typename?: 'BehaviorConfigPartnerBusinessHoursCondition';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  operators?: Maybe<Array<BehaviorConfigOperator>>;
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  triggers: Array<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigPartnerSettingCondition = {
  __typename?: 'BehaviorConfigPartnerSettingCondition';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  operators?: Maybe<Array<BehaviorConfigOperator>>;
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  triggers: Array<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigRunTriageAction = {
  __typename?: 'BehaviorConfigRunTriageAction';
  attributes: Array<BehaviorConfigRunTriageActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigRunTriageActionAttribute = {
  __typename?: 'BehaviorConfigRunTriageActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigSendConversationMessageAction = {
  __typename?: 'BehaviorConfigSendConversationMessageAction';
  attributes: Array<BehaviorConfigSendConversationMessageActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigSendConversationMessageActionAttribute = {
  __typename?: 'BehaviorConfigSendConversationMessageActionAttribute';
  dependsOn?: Maybe<Array<Maybe<AttributeDependency>>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigSendSlackMessageAction = {
  __typename?: 'BehaviorConfigSendSlackMessageAction';
  attributes: Array<BehaviorConfigSendSlackMessageActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigSendSlackMessageActionAttribute = {
  __typename?: 'BehaviorConfigSendSlackMessageActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigSignalAction = {
  __typename?: 'BehaviorConfigSignalAction';
  attributes: Array<BehaviorConfigSignalActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigSignalActionAttribute = {
  __typename?: 'BehaviorConfigSignalActionAttribute';
  dependsOn?: Maybe<Array<Maybe<AttributeDependency>>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<Maybe<BehaviorConfigOption>>;
  uiType: Scalars['String']['output'];
};

export type BehaviorConfigTrigger = {
  __typename?: 'BehaviorConfigTrigger';
  label: Scalars['String']['output'];
  maxConditionGroupLevel?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type BehaviorConfigTriggerPlaceholder = {
  __typename?: 'BehaviorConfigTriggerPlaceholder';
  placeholder: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type BehaviorConfigWebhookAction = {
  __typename?: 'BehaviorConfigWebhookAction';
  attributes: Array<BehaviorConfigWebhookActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type BehaviorConfigWebhookActionAttribute = {
  __typename?: 'BehaviorConfigWebhookActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<BehaviorConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  placeholderByTrigger?: Maybe<Array<BehaviorConfigTriggerPlaceholder>>;
  uiType: Scalars['String']['output'];
};

export type BehaviorDataInput = {
  actions?: InputMaybe<Scalars['String']['input']>;
  behaviorId?: InputMaybe<Scalars['String']['input']>;
  behaviorTrigger?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type BehaviorDataResponse = {
  __typename?: 'BehaviorDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Behavior>>>;
};

export type BehaviorSearchResponse = {
  __typename?: 'BehaviorSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Behavior>>>;
};

export type BehaviorSequence = {
  __typename?: 'BehaviorSequence';
  behavior?: Maybe<Behavior>;
  behaviorId: Scalars['String']['output'];
  behaviorSequenceId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  sequencePosition: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BehaviorSequenceDataInput = {
  behaviorId?: InputMaybe<Scalars['String']['input']>;
  behaviorSequenceId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  sequencePosition?: InputMaybe<Scalars['Int']['input']>;
};

export type BehaviorSequenceDataResponse = {
  __typename?: 'BehaviorSequenceDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BehaviorSequence>>>;
};

export type BehaviorSequenceSearchResponse = {
  __typename?: 'BehaviorSequenceSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BehaviorSequence>>>;
};

export type BlockedEmail = {
  __typename?: 'BlockedEmail';
  blockedEmail: Scalars['String']['output'];
  blockedEmailId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByPlatformUser?: Maybe<PlatformUser>;
  createdByPlatformUserId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type BlockedEmailDataInput = {
  blockedEmail?: InputMaybe<Scalars['String']['input']>;
  blockedEmailId?: InputMaybe<Scalars['String']['input']>;
  createdByPlatformUserId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockedEmailDataResponse = {
  __typename?: 'BlockedEmailDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BlockedEmail>>>;
};

export type BlockedEmailSearchResponse = {
  __typename?: 'BlockedEmailSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BlockedEmail>>>;
};

export type BlockedPhoneNumber = {
  __typename?: 'BlockedPhoneNumber';
  blockedPhoneNumber: Scalars['String']['output'];
  blockedPhoneNumberId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdByPlatformUser?: Maybe<PlatformUser>;
  createdByPlatformUserId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BlockedPhoneNumberDataInput = {
  blockedPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  blockedPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  createdByPlatformUserId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockedPhoneNumberDataResponse = {
  __typename?: 'BlockedPhoneNumberDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BlockedPhoneNumber>>>;
};

export type BlockedPhoneNumberSearchResponse = {
  __typename?: 'BlockedPhoneNumberSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BlockedPhoneNumber>>>;
};

export type Brand = {
  __typename?: 'Brand';
  activationFlowConfigs?: Maybe<Array<Maybe<ActivationFlowConfig>>>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  brandGroup?: Maybe<BrandGroup>;
  brandGroupId?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  callForPricingPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customAttributes?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  e1111?: Maybe<Scalars['String']['output']>;
  e1111BuyNow?: Maybe<Scalars['String']['output']>;
  e2111?: Maybe<Scalars['String']['output']>;
  e2111BuyNow?: Maybe<Scalars['String']['output']>;
  e2121?: Maybe<Scalars['String']['output']>;
  e2121BuyNow?: Maybe<Scalars['String']['output']>;
  e2131?: Maybe<Scalars['String']['output']>;
  e2131BuyNow?: Maybe<Scalars['String']['output']>;
  e2141?: Maybe<Scalars['String']['output']>;
  e2141BuyNow?: Maybe<Scalars['String']['output']>;
  e2151?: Maybe<Scalars['String']['output']>;
  e2151BuyNow?: Maybe<Scalars['String']['output']>;
  e2161?: Maybe<Scalars['String']['output']>;
  e2161BuyNow?: Maybe<Scalars['String']['output']>;
  e2171?: Maybe<Scalars['String']['output']>;
  e2171BuyNow?: Maybe<Scalars['String']['output']>;
  e2181?: Maybe<Scalars['String']['output']>;
  e2181BuyNow?: Maybe<Scalars['String']['output']>;
  e2221?: Maybe<Scalars['String']['output']>;
  e2221BuyNow?: Maybe<Scalars['String']['output']>;
  e2231?: Maybe<Scalars['String']['output']>;
  e2231BuyNow?: Maybe<Scalars['String']['output']>;
  e2241?: Maybe<Scalars['String']['output']>;
  e2241BuyNow?: Maybe<Scalars['String']['output']>;
  e2261?: Maybe<Scalars['String']['output']>;
  e2261BuyNow?: Maybe<Scalars['String']['output']>;
  e2281?: Maybe<Scalars['String']['output']>;
  e2281BuyNow?: Maybe<Scalars['String']['output']>;
  e2321?: Maybe<Scalars['String']['output']>;
  e2321BuyNow?: Maybe<Scalars['String']['output']>;
  e2331?: Maybe<Scalars['String']['output']>;
  e2331BuyNow?: Maybe<Scalars['String']['output']>;
  e2341?: Maybe<Scalars['String']['output']>;
  e2341BuyNow?: Maybe<Scalars['String']['output']>;
  e2361?: Maybe<Scalars['String']['output']>;
  e2361BuyNow?: Maybe<Scalars['String']['output']>;
  e2381?: Maybe<Scalars['String']['output']>;
  e2381BuyNow?: Maybe<Scalars['String']['output']>;
  e3111?: Maybe<Scalars['String']['output']>;
  e3111BuyNow?: Maybe<Scalars['String']['output']>;
  e3121?: Maybe<Scalars['String']['output']>;
  e3121BuyNow?: Maybe<Scalars['String']['output']>;
  e3131?: Maybe<Scalars['String']['output']>;
  e3131BuyNow?: Maybe<Scalars['String']['output']>;
  e3141?: Maybe<Scalars['String']['output']>;
  e3141BuyNow?: Maybe<Scalars['String']['output']>;
  e3151?: Maybe<Scalars['String']['output']>;
  e3151BuyNow?: Maybe<Scalars['String']['output']>;
  e3161?: Maybe<Scalars['String']['output']>;
  e3161BuyNow?: Maybe<Scalars['String']['output']>;
  e3171?: Maybe<Scalars['String']['output']>;
  e3171BuyNow?: Maybe<Scalars['String']['output']>;
  e3181?: Maybe<Scalars['String']['output']>;
  e3181BuyNow?: Maybe<Scalars['String']['output']>;
  e4111?: Maybe<Scalars['String']['output']>;
  e4111BuyNow?: Maybe<Scalars['String']['output']>;
  e4121?: Maybe<Scalars['String']['output']>;
  e4121BuyNow?: Maybe<Scalars['String']['output']>;
  e4131?: Maybe<Scalars['String']['output']>;
  e4131BuyNow?: Maybe<Scalars['String']['output']>;
  e4141?: Maybe<Scalars['String']['output']>;
  e4141BuyNow?: Maybe<Scalars['String']['output']>;
  e4151?: Maybe<Scalars['String']['output']>;
  e4151BuyNow?: Maybe<Scalars['String']['output']>;
  e4161?: Maybe<Scalars['String']['output']>;
  e4161BuyNow?: Maybe<Scalars['String']['output']>;
  e4171?: Maybe<Scalars['String']['output']>;
  e4171BuyNow?: Maybe<Scalars['String']['output']>;
  e4181?: Maybe<Scalars['String']['output']>;
  e4181BuyNow?: Maybe<Scalars['String']['output']>;
  e4211?: Maybe<Scalars['String']['output']>;
  e4211BuyNow?: Maybe<Scalars['String']['output']>;
  e4221?: Maybe<Scalars['String']['output']>;
  e4221BuyNow?: Maybe<Scalars['String']['output']>;
  e4231?: Maybe<Scalars['String']['output']>;
  e4231BuyNow?: Maybe<Scalars['String']['output']>;
  e4241?: Maybe<Scalars['String']['output']>;
  e4241BuyNow?: Maybe<Scalars['String']['output']>;
  e4251?: Maybe<Scalars['String']['output']>;
  e4251BuyNow?: Maybe<Scalars['String']['output']>;
  e4261?: Maybe<Scalars['String']['output']>;
  e4261BuyNow?: Maybe<Scalars['String']['output']>;
  e4271?: Maybe<Scalars['String']['output']>;
  e4271BuyNow?: Maybe<Scalars['String']['output']>;
  e4281?: Maybe<Scalars['String']['output']>;
  e4281BuyNow?: Maybe<Scalars['String']['output']>;
  e4321?: Maybe<Scalars['String']['output']>;
  e4321BuyNow?: Maybe<Scalars['String']['output']>;
  e4331?: Maybe<Scalars['String']['output']>;
  e4331BuyNow?: Maybe<Scalars['String']['output']>;
  e4341?: Maybe<Scalars['String']['output']>;
  e4341BuyNow?: Maybe<Scalars['String']['output']>;
  e4361?: Maybe<Scalars['String']['output']>;
  e4361BuyNow?: Maybe<Scalars['String']['output']>;
  e4381?: Maybe<Scalars['String']['output']>;
  e4381BuyNow?: Maybe<Scalars['String']['output']>;
  e5111?: Maybe<Scalars['String']['output']>;
  e5112?: Maybe<Scalars['String']['output']>;
  eStandardEmail?: Maybe<Scalars['String']['output']>;
  emailSignature?: Maybe<Scalars['String']['output']>;
  galleryUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  landingPageConfigs?: Maybe<Array<Maybe<LandingPageConfig>>>;
  logo?: Maybe<Scalars['String']['output']>;
  logo100x600?: Maybe<Scalars['String']['output']>;
  logo290x40?: Maybe<Scalars['String']['output']>;
  membershipFeatures?: Maybe<Array<Maybe<MembershipFeature>>>;
  name?: Maybe<Scalars['String']['output']>;
  pageBlock1Color?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerCustomDomain?: Maybe<PartnerCustomDomain>;
  partnerCustomDomainId?: Maybe<Scalars['String']['output']>;
  partnerId: Scalars['Int']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  principal?: Maybe<Scalars['String']['output']>;
  privacyPolicyDocument?: Maybe<LegalDocument>;
  privacyPolicyDocumentId?: Maybe<Scalars['String']['output']>;
  recommendationEngine?: Maybe<Scalars['Boolean']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  securityOnly?: Maybe<Scalars['Boolean']['output']>;
  termsOfServiceDocument?: Maybe<LegalDocument>;
  termsOfServiceDocumentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BrandDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BrandDataInput = {
  bannerColor?: InputMaybe<Scalars['String']['input']>;
  brandGroupId?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  callForPricingPhone?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  e1111?: InputMaybe<Scalars['String']['input']>;
  e1111BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2111?: InputMaybe<Scalars['String']['input']>;
  e2111BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2121?: InputMaybe<Scalars['String']['input']>;
  e2121BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2131?: InputMaybe<Scalars['String']['input']>;
  e2131BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2141?: InputMaybe<Scalars['String']['input']>;
  e2141BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2151?: InputMaybe<Scalars['String']['input']>;
  e2151BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2161?: InputMaybe<Scalars['String']['input']>;
  e2161BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2171?: InputMaybe<Scalars['String']['input']>;
  e2171BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2181?: InputMaybe<Scalars['String']['input']>;
  e2181BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2221?: InputMaybe<Scalars['String']['input']>;
  e2221BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2231?: InputMaybe<Scalars['String']['input']>;
  e2231BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2241?: InputMaybe<Scalars['String']['input']>;
  e2241BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2261?: InputMaybe<Scalars['String']['input']>;
  e2261BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2281?: InputMaybe<Scalars['String']['input']>;
  e2281BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2321?: InputMaybe<Scalars['String']['input']>;
  e2321BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2331?: InputMaybe<Scalars['String']['input']>;
  e2331BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2341?: InputMaybe<Scalars['String']['input']>;
  e2341BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2361?: InputMaybe<Scalars['String']['input']>;
  e2361BuyNow?: InputMaybe<Scalars['String']['input']>;
  e2381?: InputMaybe<Scalars['String']['input']>;
  e2381BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3111?: InputMaybe<Scalars['String']['input']>;
  e3111BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3121?: InputMaybe<Scalars['String']['input']>;
  e3121BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3131?: InputMaybe<Scalars['String']['input']>;
  e3131BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3141?: InputMaybe<Scalars['String']['input']>;
  e3141BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3151?: InputMaybe<Scalars['String']['input']>;
  e3151BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3161?: InputMaybe<Scalars['String']['input']>;
  e3161BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3171?: InputMaybe<Scalars['String']['input']>;
  e3171BuyNow?: InputMaybe<Scalars['String']['input']>;
  e3181?: InputMaybe<Scalars['String']['input']>;
  e3181BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4111?: InputMaybe<Scalars['String']['input']>;
  e4111BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4121?: InputMaybe<Scalars['String']['input']>;
  e4121BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4131?: InputMaybe<Scalars['String']['input']>;
  e4131BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4141?: InputMaybe<Scalars['String']['input']>;
  e4141BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4151?: InputMaybe<Scalars['String']['input']>;
  e4151BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4161?: InputMaybe<Scalars['String']['input']>;
  e4161BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4171?: InputMaybe<Scalars['String']['input']>;
  e4171BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4181?: InputMaybe<Scalars['String']['input']>;
  e4181BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4211?: InputMaybe<Scalars['String']['input']>;
  e4211BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4221?: InputMaybe<Scalars['String']['input']>;
  e4221BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4231?: InputMaybe<Scalars['String']['input']>;
  e4231BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4241?: InputMaybe<Scalars['String']['input']>;
  e4241BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4251?: InputMaybe<Scalars['String']['input']>;
  e4251BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4261?: InputMaybe<Scalars['String']['input']>;
  e4261BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4271?: InputMaybe<Scalars['String']['input']>;
  e4271BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4281?: InputMaybe<Scalars['String']['input']>;
  e4281BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4321?: InputMaybe<Scalars['String']['input']>;
  e4321BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4331?: InputMaybe<Scalars['String']['input']>;
  e4331BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4341?: InputMaybe<Scalars['String']['input']>;
  e4341BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4361?: InputMaybe<Scalars['String']['input']>;
  e4361BuyNow?: InputMaybe<Scalars['String']['input']>;
  e4381?: InputMaybe<Scalars['String']['input']>;
  e4381BuyNow?: InputMaybe<Scalars['String']['input']>;
  e5111?: InputMaybe<Scalars['String']['input']>;
  e5112?: InputMaybe<Scalars['String']['input']>;
  eStandardEmail?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<Scalars['String']['input']>;
  galleryUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logo100x600?: InputMaybe<Scalars['String']['input']>;
  logo290x40?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageBlock1Color?: InputMaybe<Scalars['String']['input']>;
  partnerCustomDomainId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  principal?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyDocumentId?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  securityOnly?: InputMaybe<Scalars['Boolean']['input']>;
  termsOfServiceDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type BrandDataResponse = {
  __typename?: 'BrandDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Brand>>>;
};

export type BrandGroup = {
  __typename?: 'BrandGroup';
  brandGroupId: Scalars['String']['output'];
  brandGroupName?: Maybe<Scalars['String']['output']>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  callerIdPhone?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  fwdPhonePublished?: Maybe<Scalars['Float']['output']>;
  fwdPhonePublishedExt?: Maybe<Scalars['Int']['output']>;
  fwdPhoneReroute?: Maybe<Scalars['Float']['output']>;
  fwdPhoneRerouteExt?: Maybe<Scalars['Int']['output']>;
  fwdPhoneSignature?: Maybe<Scalars['Float']['output']>;
  fwdPhoneSupport?: Maybe<Scalars['Float']['output']>;
  fwdPhoneTwilio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalEmail?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  membershipEmail?: Maybe<Scalars['String']['output']>;
  membershipEmailSignature?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportEmailSignature?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BrandGroupDataInput = {
  brandGroupId?: InputMaybe<Scalars['String']['input']>;
  brandGroupName?: InputMaybe<Scalars['String']['input']>;
  callerIdPhone?: InputMaybe<Scalars['Float']['input']>;
  fwdPhonePublished?: InputMaybe<Scalars['Float']['input']>;
  fwdPhonePublishedExt?: InputMaybe<Scalars['Int']['input']>;
  fwdPhoneReroute?: InputMaybe<Scalars['Float']['input']>;
  fwdPhoneRerouteExt?: InputMaybe<Scalars['Int']['input']>;
  fwdPhoneSignature?: InputMaybe<Scalars['Float']['input']>;
  fwdPhoneSupport?: InputMaybe<Scalars['Float']['input']>;
  fwdPhoneTwilio?: InputMaybe<Scalars['Float']['input']>;
  internalEmail?: InputMaybe<Scalars['String']['input']>;
  membershipEmail?: InputMaybe<Scalars['String']['input']>;
  membershipEmailSignature?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportEmailSignature?: InputMaybe<Scalars['String']['input']>;
};

export type BrandGroupDataResponse = {
  __typename?: 'BrandGroupDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BrandGroup>>>;
};

export type BrandGroupSearchResponse = {
  __typename?: 'BrandGroupSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<BrandGroup>>>;
};

export type BrandSearchResponse = {
  __typename?: 'BrandSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Brand>>>;
};

export type BulkConversationContextItem = {
  __typename?: 'BulkConversationContextItem';
  context?: Maybe<GetConversationContextResponse>;
  conversationId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
};

export type BulkUpdateEntitiesInput = {
  entityName: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  operation: BulkUpdateOperationInput;
  partnerId: Scalars['Int']['input'];
  selection: BulkUpdateSelectionSnapshotInput;
};

export type BulkUpdateEntitiesProgressInput = {
  jobId: Scalars['String']['input'];
};

export type BulkUpdateEntitiesProgressResponse = {
  __typename?: 'BulkUpdateEntitiesProgressResponse';
  createdAt: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  errorCode: BulkUpdateInitErrorCode;
  errors: Array<BulkUpdateError>;
  failedCount: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  operation: BulkUpdateOperationSummary;
  processed: Scalars['Int']['output'];
  status: BulkUpdateJobStatus;
  submittedAt: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  undoConflictCount: Scalars['Int']['output'];
  undoIneligibilityCode?: Maybe<BulkUpdateUndoIneligibilityCode>;
  undoIneligibilityMessage?: Maybe<Scalars['String']['output']>;
  undoUntil?: Maybe<Scalars['String']['output']>;
  undoUsedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkUpdateEntitiesResponse = {
  __typename?: 'BulkUpdateEntitiesResponse';
  errorCode: BulkUpdateInitErrorCode;
  failedCount: Scalars['Int']['output'];
  idempotentReplay: Scalars['Boolean']['output'];
  jobId: Scalars['String']['output'];
  processed: Scalars['Int']['output'];
  status: BulkUpdateJobStatus;
  total: Scalars['Int']['output'];
  undoUntil?: Maybe<Scalars['String']['output']>;
  updatedCount: Scalars['Int']['output'];
};

export type BulkUpdateError = {
  __typename?: 'BulkUpdateError';
  code: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message: Scalars['String']['output'];
  records?: Maybe<Array<Maybe<BulkUpdateErrorRecord>>>;
};

export type BulkUpdateErrorRecord = {
  __typename?: 'BulkUpdateErrorRecord';
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export enum BulkUpdateInitErrorCode {
  Forbidden = 'forbidden',
  IdempotencyKeyReused = 'idempotency_key_reused',
  InternalError = 'internal_error',
  None = 'none',
  UnsupportedCriteria = 'unsupported_criteria',
  ValidationFailed = 'validation_failed',
}

export enum BulkUpdateJobStatus {
  Done = 'done',
  Failed = 'failed',
  InProgress = 'in_progress',
  PartialFailure = 'partial_failure',
  Queued = 'queued',
  UndoQueued = 'undo_queued',
  Undone = 'undone',
}

export type BulkUpdateOperationInput = {
  attribute: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  value?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type BulkUpdateOperationSummary = {
  __typename?: 'BulkUpdateOperationSummary';
  attribute: Scalars['String']['output'];
};

export type BulkUpdateSelectionManualInput = {
  selectedIds: Array<Scalars['String']['input']>;
};

export enum BulkUpdateSelectionMode {
  Manual = 'manual',
}

export type BulkUpdateSelectionSnapshotInput = {
  manual: BulkUpdateSelectionManualInput;
  mode: BulkUpdateSelectionMode;
};

export enum BulkUpdateUndoIneligibilityCode {
  CapExceeded = 'cap_exceeded',
  Consumed = 'consumed',
  Expired = 'expired',
  InvalidStatus = 'invalid_status',
  MissingSnapshot = 'missing_snapshot',
  None = 'none',
}

export type CallTranscription = {
  __typename?: 'CallTranscription';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['String']['output']>;
  aiHelpLogRecordsViaTranscriptionIdTranscriptionId?: Maybe<Array<Maybe<AiHelpLog>>>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientViaClientIdClientId?: Maybe<Client>;
  conversationAttachment?: Maybe<ConversationAttachment>;
  conversationAttachmentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  externalCallId?: Maybe<Scalars['String']['output']>;
  externalTranscriptionId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  phoneCall?: Maybe<PhoneCall>;
  phoneCallId?: Maybe<Scalars['String']['output']>;
  platformUsers?: Maybe<Array<Maybe<PlatformUser>>>;
  segments?: Maybe<Array<Maybe<CallTranscriptionSegment>>>;
  status?: Maybe<Scalars['String']['output']>;
  storedFile?: Maybe<StoredFile>;
  storedFileId?: Maybe<Scalars['String']['output']>;
  transcriptText?: Maybe<Scalars['String']['output']>;
  transcriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CallTranscriptionDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  conversationAttachmentId?: InputMaybe<Scalars['String']['input']>;
  externalCallId?: InputMaybe<Scalars['String']['input']>;
  externalTranscriptionId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  phoneCallId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storedFileId?: InputMaybe<Scalars['String']['input']>;
  transcriptText?: InputMaybe<Scalars['String']['input']>;
  transcriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type CallTranscriptionDataResponse = {
  __typename?: 'CallTranscriptionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CallTranscription>>>;
};

export type CallTranscriptionSearchResponse = {
  __typename?: 'CallTranscriptionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CallTranscription>>>;
};

export type CallTranscriptionSegment = {
  __typename?: 'CallTranscriptionSegment';
  callTranscriptionSegmentId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  segmentOffsetMs: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  transcription?: Maybe<CallTranscription>;
  transcriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CallTranscriptionSegmentDataInput = {
  callTranscriptionSegmentId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  segmentOffsetMs?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  transcriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type CallTranscriptionSegmentDataResponse = {
  __typename?: 'CallTranscriptionSegmentDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CallTranscriptionSegment>>>;
};

export type CallTranscriptionSegmentSearchResponse = {
  __typename?: 'CallTranscriptionSegmentSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CallTranscriptionSegment>>>;
};

export type CallTranscriptionToPlatformUser = {
  __typename?: 'CallTranscriptionToPlatformUser';
  createdAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  transcriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CallTranscriptionToPlatformUserDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  transcriptionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CgCustomDomain = {
  __typename?: 'CgCustomDomain';
  brandIds: Array<Scalars['String']['output']>;
  cnameTarget: Scalars['String']['output'];
  hostname: Scalars['String']['output'];
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  partnerCustomDomainId: Scalars['String']['output'];
  routingRecord?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CgCustomDomainInput = {
  partnerCustomDomainId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type ChangeWorkflowVersionActiveStateInput = {
  active: Scalars['Boolean']['input'];
  partnerId: Scalars['Int']['input'];
  workflowVersionId: Scalars['String']['input'];
};

export type ChangeWorkflowVersionActiveStateOutput = {
  __typename?: 'ChangeWorkflowVersionActiveStateOutput';
  active: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
  workflowVersionId: Scalars['String']['output'];
};

export type CheckSmsDeliverabilityInput = {
  /** A number on a client record with no channel yet; looked up on every call, nothing is cached. */
  clientPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  /** A TwilioSMS channel; the verdict is cached on the channel row. */
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckSmsDeliverabilityResponse = {
  __typename?: 'CheckSmsDeliverabilityResponse';
  lineType?: Maybe<Scalars['String']['output']>;
  lineTypeCheckedAt?: Maybe<Scalars['String']['output']>;
  sendable: Scalars['Boolean']['output'];
};

export type Client = {
  __typename?: 'Client';
  addresses?: Maybe<Array<Maybe<Address>>>;
  callTranscriptionRecordsViaClientIdClientId?: Maybe<Array<Maybe<CallTranscription>>>;
  clientId: Scalars['String']['output'];
  conversationParticipant?: Maybe<ConversationParticipant>;
  createdAt: Scalars['String']['output'];
  customAttributes?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  doNotContact?: Maybe<Scalars['Boolean']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  emails?: Maybe<Array<Maybe<ClientEmail>>>;
  firstName: Scalars['String']['output'];
  frequentFlyer?: Maybe<Scalars['Boolean']['output']>;
  fullName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  lastName: Scalars['String']['output'];
  marketingOptOut?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  pdPersonId?: Maybe<Scalars['Int']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<ClientPhoneNumber>>>;
  primaryClientEmailId?: Maybe<Scalars['String']['output']>;
  primaryClientForAddresses?: Maybe<Array<Maybe<Address>>>;
  primaryClientPhoneNumberId?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<ClientEmail>;
  primaryPhoneNumber?: Maybe<ClientPhoneNumber>;
  updatedAt: Scalars['String']['output'];
  zdUserId?: Maybe<Scalars['Float']['output']>;
};

export type ClientDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClientDataInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Scalars['String']['input']>;
  doNotContact?: InputMaybe<Scalars['Boolean']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequentFlyer?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  pdPersonId?: InputMaybe<Scalars['Int']['input']>;
  primaryClientEmailId?: InputMaybe<Scalars['String']['input']>;
  primaryClientPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  zdUserId?: InputMaybe<Scalars['Float']['input']>;
};

export type ClientDataResponse = {
  __typename?: 'ClientDataResponse';
  metadata: MetaDataWithSearch;
  records?: Maybe<Array<Maybe<Client>>>;
};

export type ClientEmail = {
  __typename?: 'ClientEmail';
  client?: Maybe<Client>;
  clientEmailId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  emailLabel?: Maybe<ClientEmailLabels>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  labelId?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  value: Scalars['String']['output'];
  zdIdentityId?: Maybe<Scalars['Float']['output']>;
};

export type ClientEmailDataInput = {
  clientEmailId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  zdIdentityId?: InputMaybe<Scalars['Float']['input']>;
};

export type ClientEmailDataResponse = {
  __typename?: 'ClientEmailDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientEmail>>>;
};

export type ClientEmailLabels = {
  __typename?: 'ClientEmailLabels';
  clientEmailRecordsViaIdLabelId?: Maybe<Array<Maybe<ClientEmail>>>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  updatedAt: Scalars['String']['output'];
};

export type ClientEmailLabelsDataInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ClientEmailLabelsDataResponse = {
  __typename?: 'ClientEmailLabelsDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientEmailLabels>>>;
};

export type ClientEmailLabelsSearchResponse = {
  __typename?: 'ClientEmailLabelsSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientEmailLabels>>>;
};

export type ClientEmailSearchResponse = {
  __typename?: 'ClientEmailSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientEmail>>>;
};

export type ClientGatewayConversationParticipants = {
  __typename?: 'ClientGatewayConversationParticipants';
  agents?: Maybe<Array<Maybe<PlatformUser>>>;
  botParticipants?: Maybe<Array<Maybe<ConversationParticipant>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  unknownParticipants?: Maybe<Array<Maybe<ConversationParticipant>>>;
};

export type ClientGatewayGenerateLandingPageCheckoutUrlInput = {
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  pricePointId: Scalars['String']['input'];
  successUrl?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type ClientGatewayGenerateLandingPageCheckoutUrlResponse = {
  __typename?: 'ClientGatewayGenerateLandingPageCheckoutUrlResponse';
  unavailableReason?: Maybe<LandingPageCheckoutUnavailableReason>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ClientGatewayGetActivationFlowConfigInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['String']['input'];
};

export type ClientGatewayGetActivationFlowConfigResponse = {
  __typename?: 'ClientGatewayGetActivationFlowConfigResponse';
  features?: Maybe<Array<Maybe<AfConfigFeature>>>;
  id: Scalars['String']['output'];
  options?: Maybe<AfConfigOptions>;
  products: Array<AfConfigProduct>;
};

export type ClientGatewayGetAuthTokenInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  magicToken?: InputMaybe<Scalars['String']['input']>;
};

export type ClientGatewayGetAuthTokenResponse = {
  __typename?: 'ClientGatewayGetAuthTokenResponse';
  email: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type ClientGatewayGetBrandingInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  partnerSlug?: InputMaybe<Scalars['String']['input']>;
};

export type ClientGatewayGetBrandingResponse = {
  __typename?: 'ClientGatewayGetBrandingResponse';
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  pageBlock1Color?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type ClientGatewayGetConversationMessageParams = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Array<InputMaybe<SortingInput>>>;
};

export type ClientGatewayGetConversationParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientGatewayGetLandingPageCheckoutConfirmationInput = {
  sessionId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ClientGatewayGetLandingPageInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSlug: Scalars['String']['input'];
  partnerSlug: Scalars['String']['input'];
};

export type ClientGatewayGetLandingPageResponse = {
  __typename?: 'ClientGatewayGetLandingPageResponse';
  config: Scalars['String']['output'];
  features?: Maybe<Array<Maybe<AfConfigFeature>>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  options?: Maybe<AfConfigOptions>;
  partner: ClientGatewayLandingPagePartner;
  products: Array<ClientGatewayLandingPageProduct>;
};

export type ClientGatewayGetLegalDocumentInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  kind: LegalDocumentKind;
  partnerSlug: Scalars['String']['input'];
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type ClientGatewayIsPartnerAvailableInput = {
  partnerSlug: Scalars['String']['input'];
};

export type ClientGatewayLandingPagePartner = {
  __typename?: 'ClientGatewayLandingPagePartner';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  termsOfServiceUrl?: Maybe<Scalars['String']['output']>;
};

export type ClientGatewayLandingPagePrice = {
  __typename?: 'ClientGatewayLandingPagePrice';
  amountCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type ClientGatewayLandingPagePrices = {
  __typename?: 'ClientGatewayLandingPagePrices';
  annual?: Maybe<ClientGatewayLandingPagePrice>;
  monthly: ClientGatewayLandingPagePrice;
};

export type ClientGatewayLandingPageProduct = {
  __typename?: 'ClientGatewayLandingPageProduct';
  activeFeatures?: Maybe<Array<Maybe<AfConfigActiveFeature>>>;
  callForPricing?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  platformSlaId?: Maybe<Scalars['String']['output']>;
  prices: ClientGatewayLandingPagePrices;
};

export type ClientGatewayLegalDocument = {
  __typename?: 'ClientGatewayLegalDocument';
  bodyHtml: Scalars['String']['output'];
  brand?: Maybe<ClientGatewayLegalDocumentBrand>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ClientGatewayLegalDocumentBrand = {
  __typename?: 'ClientGatewayLegalDocumentBrand';
  displayName?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type ClientGatewayResolveHostInput = {
  hostname: Scalars['String']['input'];
};

export type ClientGatewayResolveHostResponse = {
  __typename?: 'ClientGatewayResolveHostResponse';
  brandIds: Array<Scalars['String']['output']>;
  partnerSlug: Scalars['String']['output'];
};

export type ClientGatewaySendConversationMessageInput = {
  attachments?: InputMaybe<Array<InputMaybe<File>>>;
  body: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  isNewConversation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientPhoneLabels = {
  __typename?: 'ClientPhoneLabels';
  clientPhoneNumbers?: Maybe<Array<Maybe<ClientPhoneNumber>>>;
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ClientPhoneLabelsDataInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ClientPhoneLabelsDataResponse = {
  __typename?: 'ClientPhoneLabelsDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientPhoneLabels>>>;
};

export type ClientPhoneLabelsSearchResponse = {
  __typename?: 'ClientPhoneLabelsSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientPhoneLabels>>>;
};

export type ClientPhoneNumber = {
  __typename?: 'ClientPhoneNumber';
  client?: Maybe<Client>;
  clientId: Scalars['String']['output'];
  clientPhoneLabels?: Maybe<ClientPhoneLabels>;
  clientPhoneNumberId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  ext?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  labelId?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  smsOptOut: Scalars['Boolean']['output'];
  smsOptOutUpdatedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  zdIdentityId?: Maybe<Scalars['Float']['output']>;
};

export type ClientPhoneNumberDataInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['Int']['input']>;
  labelId?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  zdIdentityId?: InputMaybe<Scalars['Float']['input']>;
};

export type ClientPhoneNumberDataResponse = {
  __typename?: 'ClientPhoneNumberDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientPhoneNumber>>>;
};

export type ClientPhoneNumberSearchResponse = {
  __typename?: 'ClientPhoneNumberSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ClientPhoneNumber>>>;
};

export type ClientSearchResponse = {
  __typename?: 'ClientSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Client>>>;
};

export type ClientToAddress = {
  __typename?: 'ClientToAddress';
  addressId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientToAddressId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ClientToAddressDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientToAddressId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConditionInput = {
  attribute: Scalars['String']['input'];
  coalesceDefault?: InputMaybe<Scalars['String']['input']>;
  logicalOperator?: InputMaybe<Scalars['String']['input']>;
  operator: Scalars['String']['input'];
  value: Scalars['String']['input'];
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type ContactSupportAttachments = {
  name: Scalars['String']['input'];
  s3Url: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type ContactSupportInput = {
  additionalContext: Scalars['String']['input'];
  attachments?: InputMaybe<Array<InputMaybe<ContactSupportAttachments>>>;
  conversationId: Scalars['String']['input'];
  issueType: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type ContactSupportResponse = {
  __typename?: 'ContactSupportResponse';
  conversationId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
};

export type Conversation = {
  __typename?: 'Conversation';
  assignee?: Maybe<PlatformUser>;
  assigneeGroupUpdatedAt?: Maybe<Scalars['String']['output']>;
  assigneeUpdatedAt?: Maybe<Scalars['String']['output']>;
  associatedAddresses?: Maybe<Array<Maybe<Address>>>;
  attachments?: Maybe<Array<Maybe<ConversationAttachment>>>;
  callTranscriptions?: Maybe<Array<Maybe<CallTranscription>>>;
  conversationAssigneeGroup?: Maybe<ConversationAssigneeGroup>;
  conversationAssigneeGroupId?: Maybe<Scalars['String']['output']>;
  conversationAssigneeId?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  conversationMessages?: Maybe<Array<Maybe<ConversationMessage>>>;
  conversationStatusId?: Maybe<Scalars['String']['output']>;
  conversationStatusUpdatedAt?: Maybe<Scalars['String']['output']>;
  conversationUrgencyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customAttributes?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  drafts?: Maybe<Array<Maybe<ConversationMessageDraft>>>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  lastMessageReceivedAt?: Maybe<Scalars['String']['output']>;
  messageThreads?: Maybe<Array<Maybe<ConversationMessageThread>>>;
  messagesCount: Scalars['Int']['output'];
  notifications?: Maybe<Array<Maybe<Notification>>>;
  participations?: Maybe<Array<Maybe<ConversationParticipation>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  phoneCalls?: Maybe<Array<Maybe<PhoneCall>>>;
  reactions?: Maybe<Array<Maybe<ConversationMessageReaction>>>;
  requester?: Maybe<ConversationParticipant>;
  requesterId?: Maybe<Scalars['String']['output']>;
  requesterUpdatedAt?: Maybe<Scalars['String']['output']>;
  seenState?: Maybe<Array<Maybe<ConversationSeenState>>>;
  sidekickRunMessages?: Maybe<Array<Maybe<SidekickRunMessage>>>;
  sidekickRuns?: Maybe<Array<Maybe<SidekickRun>>>;
  signalIncidents?: Maybe<Array<Maybe<SignalIncident>>>;
  smsSessions?: Maybe<Array<Maybe<ConversationSmsSession>>>;
  snoozeUntil?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConversationStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  summaries?: Maybe<Array<Maybe<ConversationSummary>>>;
  triageRuns?: Maybe<Array<Maybe<ConversationTriageRun>>>;
  type?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<ConversationUrgency>;
  workspaceConversationId: Scalars['Int']['output'];
  zdTicketId?: Maybe<Scalars['Int']['output']>;
};

export type ConversationDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationAssigneeGroup = {
  __typename?: 'ConversationAssigneeGroup';
  conversationAssigneeGroup?: Maybe<ConversationAssigneeGroup>;
  conversationAssigneeGroupId: Scalars['String']['output'];
  conversationAssigneeGroups?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  name: Scalars['String']['output'];
  notificationRoles?: Maybe<Array<Maybe<NotificationRole>>>;
  parentGroupId?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
};

export type ConversationAssigneeGroupDataInput = {
  conversationAssigneeGroupId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentGroupId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationAssigneeGroupDataResponse = {
  __typename?: 'ConversationAssigneeGroupDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
};

export type ConversationAssigneeGroupSearchResponse = {
  __typename?: 'ConversationAssigneeGroupSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
};

export type ConversationAssigneeToGroup = {
  __typename?: 'ConversationAssigneeToGroup';
  conversationAssigneeGroupId: Scalars['String']['output'];
  conversationAssigneeId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export type ConversationAssigneeToGroupDataInput = {
  conversationAssigneeGroupId?: InputMaybe<Scalars['String']['input']>;
  conversationAssigneeId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationAttachment = {
  __typename?: 'ConversationAttachment';
  attachmentDistributions?: Maybe<Array<Maybe<ConversationAttachmentDistribution>>>;
  callTranscription?: Maybe<CallTranscription>;
  contentType?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  conversationAttachmentId: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  conversationMessageDraft?: Maybe<ConversationMessageDraft>;
  conversationMessageDraftId?: Maybe<Scalars['String']['output']>;
  conversationMessageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  message?: Maybe<ConversationMessage>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  size?: Maybe<Scalars['Int']['output']>;
};

export type ConversationAttachmentDataInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  conversationAttachmentId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageDraftId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationAttachmentDataResponse = {
  __typename?: 'ConversationAttachmentDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationAttachment>>>;
};

export type ConversationAttachmentDistribution = {
  __typename?: 'ConversationAttachmentDistribution';
  attachment?: Maybe<ConversationAttachment>;
  conversationAttachmentDistributionId: Scalars['String']['output'];
  conversationAttachmentId: Scalars['String']['output'];
  conversationParticipationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participation?: Maybe<ConversationParticipation>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
};

export type ConversationAttachmentDistributionDataInput = {
  conversationAttachmentDistributionId?: InputMaybe<Scalars['String']['input']>;
  conversationAttachmentId?: InputMaybe<Scalars['String']['input']>;
  conversationParticipationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationAttachmentDistributionDataResponse = {
  __typename?: 'ConversationAttachmentDistributionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationAttachmentDistribution>>>;
};

export type ConversationAttachmentDistributionSearchResponse = {
  __typename?: 'ConversationAttachmentDistributionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationAttachmentDistribution>>>;
};

export type ConversationAttachmentSearchResponse = {
  __typename?: 'ConversationAttachmentSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationAttachment>>>;
};

export type ConversationChannel = {
  __typename?: 'ConversationChannel';
  channelType?: Maybe<ConversationChannelType>;
  conversationChannelId: Scalars['String']['output'];
  conversationChannelTypeId?: Maybe<Scalars['String']['output']>;
  conversationParticipant?: Maybe<ConversationParticipant>;
  conversationParticipantId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  externalIdentifier: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  internalIdentifier: Scalars['String']['output'];
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  lineType?: Maybe<Scalars['String']['output']>;
  lineTypeCheckedAt?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Maybe<ConversationMessage>>>;
  participations?: Maybe<Array<Maybe<ConversationParticipation>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  phoneCallParticipations?: Maybe<Array<Maybe<PhoneCallParticipation>>>;
  smsSessionRecipients?: Maybe<Array<Maybe<ConversationSmsSessionRecipient>>>;
  smsSessions?: Maybe<Array<Maybe<ConversationSmsSession>>>;
  updatedAt: Scalars['String']['output'];
};

export type ConversationChannelDataInput = {
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
  conversationChannelTypeId?: InputMaybe<Scalars['String']['input']>;
  conversationParticipantId?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  internalIdentifier?: InputMaybe<Scalars['String']['input']>;
  lineType?: InputMaybe<Scalars['String']['input']>;
  lineTypeCheckedAt?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationChannelDataResponse = {
  __typename?: 'ConversationChannelDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationChannel>>>;
};

export type ConversationChannelSearchResponse = {
  __typename?: 'ConversationChannelSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationChannel>>>;
};

export type ConversationChannelType = {
  __typename?: 'ConversationChannelType';
  conversationChannelTypeId: Scalars['String']['output'];
  conversationChannels?: Maybe<Array<Maybe<ConversationChannel>>>;
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ConversationChannelTypeDataInput = {
  conversationChannelTypeId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationChannelTypeDataResponse = {
  __typename?: 'ConversationChannelTypeDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationChannelType>>>;
};

export type ConversationChannelTypeSearchResponse = {
  __typename?: 'ConversationChannelTypeSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationChannelType>>>;
};

export type ConversationContextAttachment = {
  __typename?: 'ConversationContextAttachment';
  content?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ConversationContextClientParticipant = {
  __typename?: 'ConversationContextClientParticipant';
  internalNotes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ConversationContextMessage = {
  __typename?: 'ConversationContextMessage';
  attachments?: Maybe<Array<Maybe<ConversationContextAttachment>>>;
  author?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  rawBody?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ConversationContextParticipants = {
  __typename?: 'ConversationContextParticipants';
  agents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clients?: Maybe<Array<Maybe<ConversationContextClientParticipant>>>;
};

export type ConversationContextPartner = {
  __typename?: 'ConversationContextPartner';
  businessName: Scalars['String']['output'];
  litsDate?: Maybe<Scalars['String']['output']>;
  membershipSalesCalendlyUrl?: Maybe<Scalars['String']['output']>;
  supportPolicies?: Maybe<Array<Maybe<SupportPolicyForConversationContext>>>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ConversationContextSite = {
  __typename?: 'ConversationContextSite';
  activationFlowUrl?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  associatedConversations?: Maybe<Array<Maybe<AssociatedConversation>>>;
  cppExpDate?: Maybe<Scalars['String']['output']>;
  internalMembershipNotes?: Maybe<Scalars['String']['output']>;
  internalSiteNotes?: Maybe<Scalars['String']['output']>;
  serviceLevel: Scalars['String']['output'];
};

export type ConversationCounter = {
  __typename?: 'ConversationCounter';
  counter: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
};

export type ConversationCounterDataInput = {
  counter?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationCounterDataResponse = {
  __typename?: 'ConversationCounterDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationCounter>>>;
};

export type ConversationCounterSearchResponse = {
  __typename?: 'ConversationCounterSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationCounter>>>;
};

export type ConversationDataInput = {
  assigneeGroupUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  assigneeUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  conversationAssigneeGroupId?: InputMaybe<Scalars['String']['input']>;
  conversationAssigneeId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationStatusId?: InputMaybe<Scalars['String']['input']>;
  conversationStatusUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  conversationUrgencyId?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  lastMessageReceivedAt?: InputMaybe<Scalars['String']['input']>;
  messagesCount?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  requesterId?: InputMaybe<Scalars['String']['input']>;
  requesterUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  snoozeUntil?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workspaceConversationId?: InputMaybe<Scalars['Int']['input']>;
  zdTicketId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationDataResponse = {
  __typename?: 'ConversationDataResponse';
  metadata: MetaDataWithSearch;
  records?: Maybe<Array<Maybe<Conversation>>>;
};

export type ConversationDraftAttachmentInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationEmail = {
  __typename?: 'ConversationEmail';
  conversationEmailId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  emailDispatches?: Maybe<Array<Maybe<ConversationEmailDispatch>>>;
  emailMessageId?: Maybe<Scalars['String']['output']>;
  fileKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  message?: Maybe<ConversationMessage>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  retryHistory?: Maybe<Scalars['String']['output']>;
  sfnExecutionArn?: Maybe<Scalars['String']['output']>;
};

export type ConversationEmailDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationEmailDataInput = {
  conversationEmailId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  emailMessageId?: InputMaybe<Scalars['String']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  retryHistory?: InputMaybe<Scalars['String']['input']>;
  sfnExecutionArn?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationEmailDataResponse = {
  __typename?: 'ConversationEmailDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationEmail>>>;
};

export type ConversationEmailDispatch = {
  __typename?: 'ConversationEmailDispatch';
  conversationEmail?: Maybe<ConversationEmail>;
  conversationEmailDispatchId: Scalars['String']['output'];
  conversationEmailId?: Maybe<Scalars['String']['output']>;
  conversationMessageDispatchId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCarbonCopy?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  messageDispatch?: Maybe<ConversationMessageDispatch>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
};

export type ConversationEmailDispatchDataInput = {
  conversationEmailDispatchId?: InputMaybe<Scalars['String']['input']>;
  conversationEmailId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageDispatchId?: InputMaybe<Scalars['String']['input']>;
  isCarbonCopy?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationEmailDispatchDataResponse = {
  __typename?: 'ConversationEmailDispatchDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationEmailDispatch>>>;
};

export type ConversationEmailDispatchSearchResponse = {
  __typename?: 'ConversationEmailDispatchSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationEmailDispatch>>>;
};

export type ConversationEmailSearchResponse = {
  __typename?: 'ConversationEmailSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationEmail>>>;
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  attachments?: Maybe<Array<Maybe<ConversationAttachment>>>;
  body?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  conversationEmails?: Maybe<Array<Maybe<ConversationEmail>>>;
  conversationId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
  conversationSmsRecords?: Maybe<Array<Maybe<ConversationSms>>>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incomingConversationEmail?: Maybe<ConversationEmail>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  mentionedGroups?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
  mentionedUsers?: Maybe<Array<Maybe<PlatformUser>>>;
  messageDispatches?: Maybe<Array<Maybe<ConversationMessageDispatch>>>;
  parentConversationMessageId?: Maybe<Scalars['String']['output']>;
  parentMessage?: Maybe<ConversationMessage>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  reactions?: Maybe<Array<Maybe<ConversationMessageReaction>>>;
  replies?: Maybe<Array<Maybe<ConversationMessage>>>;
  senderChannel?: Maybe<ConversationChannel>;
  senderChannelId: Scalars['String']['output'];
  thread?: Maybe<ConversationMessageThread>;
};

export type ConversationMessageAssigneeGroupMention = {
  __typename?: 'ConversationMessageAssigneeGroupMention';
  conversationAssigneeGroupId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export type ConversationMessageAssigneeGroupMentionDataInput = {
  conversationAssigneeGroupId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationMessageDataInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  parentConversationMessageId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  senderChannelId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationMessageDataResponse = {
  __typename?: 'ConversationMessageDataResponse';
  metadata: MetaDataWithSearch;
  records?: Maybe<Array<Maybe<ConversationMessage>>>;
};

export type ConversationMessageDispatch = {
  __typename?: 'ConversationMessageDispatch';
  conversationMessageDispatchId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
  conversationParticipationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customAttributes?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dispatchStatus: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  emailDispatches?: Maybe<Array<Maybe<ConversationEmailDispatch>>>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<ConversationMessage>;
  participation?: Maybe<ConversationParticipation>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  smsDispatches?: Maybe<Array<Maybe<ConversationSmsDispatch>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ConversationMessageDispatchDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationMessageDispatchDataInput = {
  conversationMessageDispatchId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  conversationParticipationId?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Scalars['String']['input']>;
  dispatchStatus?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationMessageDispatchDataResponse = {
  __typename?: 'ConversationMessageDispatchDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageDispatch>>>;
};

export type ConversationMessageDispatchSearchResponse = {
  __typename?: 'ConversationMessageDispatchSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageDispatch>>>;
};

export type ConversationMessageDraft = {
  __typename?: 'ConversationMessageDraft';
  attachments?: Maybe<Array<Maybe<ConversationAttachment>>>;
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  conversationMessageDraftId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messageHtml?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  scheduledAt?: Maybe<Scalars['String']['output']>;
  sendUnless: Scalars['String']['output'];
  sideEffects: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ConversationMessageDraftDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationMessageDraftDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageDraftId?: InputMaybe<Scalars['String']['input']>;
  discardedAt?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageHtml?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  sendUnless?: InputMaybe<Scalars['String']['input']>;
  sideEffects?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationMessageDraftDataResponse = {
  __typename?: 'ConversationMessageDraftDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageDraft>>>;
};

export type ConversationMessageDraftSearchResponse = {
  __typename?: 'ConversationMessageDraftSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageDraft>>>;
};

export type ConversationMessageReaction = {
  __typename?: 'ConversationMessageReaction';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
  conversationMessageReactionId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  emoji: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  message?: Maybe<ConversationMessage>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  userId: Scalars['String']['output'];
};

export type ConversationMessageReactionDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageReactionId?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationMessageReactionDataResponse = {
  __typename?: 'ConversationMessageReactionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageReaction>>>;
};

export type ConversationMessageReactionInput = {
  conversationMessageId: Scalars['String']['input'];
  emoji: Scalars['String']['input'];
};

export type ConversationMessageReactionSearchResponse = {
  __typename?: 'ConversationMessageReactionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageReaction>>>;
};

export type ConversationMessageSearchResponse = {
  __typename?: 'ConversationMessageSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessage>>>;
};

export type ConversationMessageThread = {
  __typename?: 'ConversationMessageThread';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
  conversationMessageThreadId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  message?: Maybe<ConversationMessage>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  resolutionConversationMessageId?: Maybe<Scalars['String']['output']>;
  resolutionMessage?: Maybe<ConversationMessage>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<PlatformUser>;
  resolvedByUserId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ConversationMessageThreadDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  conversationMessageThreadId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  resolutionConversationMessageId?: InputMaybe<Scalars['String']['input']>;
  resolvedAt?: InputMaybe<Scalars['String']['input']>;
  resolvedByUserId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationMessageThreadDataResponse = {
  __typename?: 'ConversationMessageThreadDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageThread>>>;
};

export type ConversationMessageThreadSearchResponse = {
  __typename?: 'ConversationMessageThreadSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationMessageThread>>>;
};

export type ConversationMessageUserMention = {
  __typename?: 'ConversationMessageUserMention';
  conversationMessageId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type ConversationMessageUserMentionDataInput = {
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationParticipant = {
  __typename?: 'ConversationParticipant';
  client?: Maybe<Client>;
  conversationChannels?: Maybe<Array<Maybe<ConversationChannel>>>;
  conversationParticipantId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  entityPartner?: Maybe<Partner>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  participantEntity?: Maybe<Scalars['String']['output']>;
  participantEntityPartnerId?: Maybe<Scalars['Int']['output']>;
  participantIdentity?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  requesterForConversations?: Maybe<Array<Maybe<Conversation>>>;
  rsmEmail?: Maybe<RsmEmail>;
  updatedAt: Scalars['String']['output'];
};

export type ConversationParticipantDataInput = {
  conversationParticipantId?: InputMaybe<Scalars['String']['input']>;
  participantEntity?: InputMaybe<Scalars['String']['input']>;
  participantEntityPartnerId?: InputMaybe<Scalars['Int']['input']>;
  participantIdentity?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationParticipantDataResponse = {
  __typename?: 'ConversationParticipantDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationParticipant>>>;
};

export type ConversationParticipantOption = {
  __typename?: 'ConversationParticipantOption';
  avatarFileKey?: Maybe<Scalars['String']['output']>;
  conversationParticipantId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entityPartnerId?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  participantEntity: Scalars['String']['output'];
  participantIdentity?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ConversationParticipantSearchResponse = {
  __typename?: 'ConversationParticipantSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationParticipant>>>;
};

export type ConversationParticipation = {
  __typename?: 'ConversationParticipation';
  attachmentDistributions?: Maybe<Array<Maybe<ConversationAttachmentDistribution>>>;
  channel?: Maybe<ConversationChannel>;
  conversation?: Maybe<Conversation>;
  conversationChannelId: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  conversationParticipationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  messageDispatches?: Maybe<Array<Maybe<ConversationMessageDispatch>>>;
  participationMode: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
};

export type ConversationParticipationDataInput = {
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationParticipationId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  participationMode?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationParticipationDataResponse = {
  __typename?: 'ConversationParticipationDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationParticipation>>>;
};

export type ConversationParticipationSearchResponse = {
  __typename?: 'ConversationParticipationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationParticipation>>>;
};

export type ConversationSearchResponse = {
  __typename?: 'ConversationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Conversation>>>;
};

export type ConversationSeenState = {
  __typename?: 'ConversationSeenState';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  conversationSeenStateId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  lastSeenAt: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  userId: Scalars['String']['output'];
};

export type ConversationSeenStateDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationSeenStateId?: InputMaybe<Scalars['String']['input']>;
  lastSeenAt?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationSeenStateDataResponse = {
  __typename?: 'ConversationSeenStateDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSeenState>>>;
};

export type ConversationSeenStateSearchResponse = {
  __typename?: 'ConversationSeenStateSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSeenState>>>;
};

export type ConversationSms = {
  __typename?: 'ConversationSms';
  conversationMessageId?: Maybe<Scalars['String']['output']>;
  conversationSmsId: Scalars['String']['output'];
  conversationSmsSessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  externalMessageId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<ConversationMessage>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  segmentCount?: Maybe<Scalars['Int']['output']>;
  smsDispatches?: Maybe<Array<Maybe<ConversationSmsDispatch>>>;
  smsSession?: Maybe<ConversationSmsSession>;
};

export type ConversationSmsDataInput = {
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  conversationSmsId?: InputMaybe<Scalars['String']['input']>;
  conversationSmsSessionId?: InputMaybe<Scalars['String']['input']>;
  deliveryStatus?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  externalMessageId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  segmentCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationSmsDataResponse = {
  __typename?: 'ConversationSmsDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSms>>>;
};

export type ConversationSmsDispatch = {
  __typename?: 'ConversationSmsDispatch';
  conversationMessageDispatchId: Scalars['String']['output'];
  conversationSms?: Maybe<ConversationSms>;
  conversationSmsDispatchId: Scalars['String']['output'];
  conversationSmsId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageDispatch?: Maybe<ConversationMessageDispatch>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
};

export type ConversationSmsDispatchDataInput = {
  conversationMessageDispatchId?: InputMaybe<Scalars['String']['input']>;
  conversationSmsDispatchId?: InputMaybe<Scalars['String']['input']>;
  conversationSmsId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationSmsDispatchDataResponse = {
  __typename?: 'ConversationSmsDispatchDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSmsDispatch>>>;
};

export type ConversationSmsDispatchSearchResponse = {
  __typename?: 'ConversationSmsDispatchSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSmsDispatch>>>;
};

export type ConversationSmsSearchResponse = {
  __typename?: 'ConversationSmsSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSms>>>;
};

export type ConversationSmsSession = {
  __typename?: 'ConversationSmsSession';
  channel?: Maybe<ConversationChannel>;
  conversation?: Maybe<Conversation>;
  conversationChannelId: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  conversationSmsSessionId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  endedVia?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  goodbyeCopy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idleSeconds?: Maybe<Scalars['Int']['output']>;
  lastActivityAt?: Maybe<Scalars['String']['output']>;
  nudgeAttempts?: Maybe<Scalars['Int']['output']>;
  nudgeCopy?: Maybe<Scalars['String']['output']>;
  nudgeCount: Scalars['Int']['output'];
  openedAt?: Maybe<Scalars['String']['output']>;
  openedByUser?: Maybe<PlatformUser>;
  openedByUserId?: Maybe<Scalars['String']['output']>;
  openedVia?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerPhoneNumber?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<ConversationSmsSessionRecipient>>>;
  smsRecords?: Maybe<Array<Maybe<ConversationSms>>>;
  state: Scalars['String']['output'];
};

export type ConversationSmsSessionDataInput = {
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationSmsSessionId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  endedVia?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  goodbyeCopy?: InputMaybe<Scalars['String']['input']>;
  idleSeconds?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['String']['input']>;
  nudgeAttempts?: InputMaybe<Scalars['Int']['input']>;
  nudgeCopy?: InputMaybe<Scalars['String']['input']>;
  nudgeCount?: InputMaybe<Scalars['Int']['input']>;
  openedAt?: InputMaybe<Scalars['String']['input']>;
  openedByUserId?: InputMaybe<Scalars['String']['input']>;
  openedVia?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationSmsSessionDataResponse = {
  __typename?: 'ConversationSmsSessionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSmsSession>>>;
};

export type ConversationSmsSessionRecipient = {
  __typename?: 'ConversationSmsSessionRecipient';
  channel?: Maybe<ConversationChannel>;
  conversationChannelId: Scalars['String']['output'];
  conversationSmsSessionId: Scalars['String']['output'];
  conversationSmsSessionRecipientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  externalParticipantId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  session?: Maybe<ConversationSmsSession>;
};

export type ConversationSmsSessionRecipientDataInput = {
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
  conversationSmsSessionId?: InputMaybe<Scalars['String']['input']>;
  conversationSmsSessionRecipientId?: InputMaybe<Scalars['String']['input']>;
  externalParticipantId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationSmsSessionRecipientDataResponse = {
  __typename?: 'ConversationSmsSessionRecipientDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSmsSessionRecipient>>>;
};

export type ConversationSmsSessionRecipientSearchResponse = {
  __typename?: 'ConversationSmsSessionRecipientSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSmsSessionRecipient>>>;
};

export type ConversationSmsSessionSearchResponse = {
  __typename?: 'ConversationSmsSessionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSmsSession>>>;
};

export type ConversationStatus = {
  __typename?: 'ConversationStatus';
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  id: Scalars['String']['output'];
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type ConversationStatusDataInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStatusDataResponse = {
  __typename?: 'ConversationStatusDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationStatus>>>;
};

export type ConversationStatusSearchResponse = {
  __typename?: 'ConversationStatusSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationStatus>>>;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  conversationSummaryId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  intermediateSummary?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  shortSummary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type ConversationSummaryDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationSummaryDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationSummaryId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  intermediateSummary?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  shortSummary?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationSummaryDataResponse = {
  __typename?: 'ConversationSummaryDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSummary>>>;
};

export type ConversationSummarySearchResponse = {
  __typename?: 'ConversationSummarySearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationSummary>>>;
};

export type ConversationToAddress = {
  __typename?: 'ConversationToAddress';
  addressId: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export type ConversationToAddressDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationToAssignee = {
  __typename?: 'ConversationToAssignee';
  conversationId: Scalars['String']['output'];
  conversationToAssigneeId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  platformUserId: Scalars['String']['output'];
};

export type ConversationToAssigneeDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationToAssigneeId?: InputMaybe<Scalars['String']['input']>;
  platformUserId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationToCallTranscription = {
  __typename?: 'ConversationToCallTranscription';
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  transcriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ConversationToCallTranscriptionDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  transcriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationTriage = {
  __typename?: 'ConversationTriage';
  actionConfig: Scalars['String']['output'];
  conversationTriageId: Scalars['String']['output'];
  conversationTriageRuns?: Maybe<Array<Maybe<ConversationTriageRun>>>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  instructions: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  llmConfig: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ConversationTriageDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationTriageBehaviorUsage = {
  __typename?: 'ConversationTriageBehaviorUsage';
  behaviorId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ConversationTriageDataInput = {
  actionConfig?: InputMaybe<Scalars['String']['input']>;
  conversationTriageId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  llmConfig?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationTriageDataResponse = {
  __typename?: 'ConversationTriageDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriage>>>;
};

export type ConversationTriageRun = {
  __typename?: 'ConversationTriageRun';
  actionConfigSnapshot: Scalars['String']['output'];
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  conversationTriage?: Maybe<ConversationTriage>;
  conversationTriageId?: Maybe<Scalars['String']['output']>;
  conversationTriageRunId: Scalars['String']['output'];
  conversationTriageRunSteps?: Maybe<Array<Maybe<ConversationTriageRunStep>>>;
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  idempotencyId: Scalars['String']['output'];
  llmConfigSnapshot: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  userInstructions?: Maybe<Scalars['String']['output']>;
};

export type ConversationTriageRunDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationTriageRunAction = {
  __typename?: 'ConversationTriageRunAction';
  appliedAt?: Maybe<Scalars['String']['output']>;
  appliedBy?: Maybe<Scalars['String']['output']>;
  appliedByUser?: Maybe<PlatformUser>;
  applyError?: Maybe<Scalars['String']['output']>;
  conversationTriageRunActionId: Scalars['String']['output'];
  conversationTriageRunStep?: Maybe<ConversationTriageRunStep>;
  conversationTriageRunStepId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  payload: Scalars['String']['output'];
  providerCallId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  visibility: Scalars['String']['output'];
};

export type ConversationTriageRunActionDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationTriageRunActionDataInput = {
  appliedAt?: InputMaybe<Scalars['String']['input']>;
  appliedBy?: InputMaybe<Scalars['String']['input']>;
  applyError?: InputMaybe<Scalars['String']['input']>;
  conversationTriageRunActionId?: InputMaybe<Scalars['String']['input']>;
  conversationTriageRunStepId?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  payload?: InputMaybe<Scalars['String']['input']>;
  providerCallId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationTriageRunActionDataResponse = {
  __typename?: 'ConversationTriageRunActionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriageRunAction>>>;
};

export type ConversationTriageRunActionSearchResponse = {
  __typename?: 'ConversationTriageRunActionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriageRunAction>>>;
};

export type ConversationTriageRunDataInput = {
  actionConfigSnapshot?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationTriageId?: InputMaybe<Scalars['String']['input']>;
  conversationTriageRunId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  idempotencyId?: InputMaybe<Scalars['String']['input']>;
  llmConfigSnapshot?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationTriageRunDataResponse = {
  __typename?: 'ConversationTriageRunDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriageRun>>>;
};

export type ConversationTriageRunSearchResponse = {
  __typename?: 'ConversationTriageRunSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriageRun>>>;
};

export type ConversationTriageRunStep = {
  __typename?: 'ConversationTriageRunStep';
  conversationTriageRun?: Maybe<ConversationTriageRun>;
  conversationTriageRunActions?: Maybe<Array<Maybe<ConversationTriageRunAction>>>;
  conversationTriageRunId: Scalars['String']['output'];
  conversationTriageRunStepId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  forkAttempt: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  llmInput: Scalars['String']['output'];
  llmOutput?: Maybe<Scalars['String']['output']>;
  providerResponseId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  toolCallResults?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ConversationTriageRunStepDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationTriageRunStepDataInput = {
  conversationTriageRunId?: InputMaybe<Scalars['String']['input']>;
  conversationTriageRunStepId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  forkAttempt?: InputMaybe<Scalars['Int']['input']>;
  llmInput?: InputMaybe<Scalars['String']['input']>;
  llmOutput?: InputMaybe<Scalars['String']['input']>;
  providerResponseId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toolCallResults?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationTriageRunStepDataResponse = {
  __typename?: 'ConversationTriageRunStepDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriageRunStep>>>;
};

export type ConversationTriageRunStepSearchResponse = {
  __typename?: 'ConversationTriageRunStepSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriageRunStep>>>;
};

export type ConversationTriageSearchResponse = {
  __typename?: 'ConversationTriageSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationTriage>>>;
};

export type ConversationTriageState = {
  __typename?: 'ConversationTriageState';
  actionConfig: Scalars['String']['output'];
  conversationTriageId: Scalars['String']['output'];
  instructions: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  llmConfig: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  usedByBehaviors: Array<ConversationTriageBehaviorUsage>;
};

export type ConversationUrgency = {
  __typename?: 'ConversationUrgency';
  conversationUrgencyId: Scalars['String']['output'];
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  signalIncidents?: Maybe<Array<Maybe<SignalIncident>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  urgencyName?: Maybe<Scalars['String']['output']>;
};

export type ConversationUrgencyDataInput = {
  conversationUrgencyId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  urgencyName?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationUrgencyDataResponse = {
  __typename?: 'ConversationUrgencyDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationUrgency>>>;
};

export type ConversationUrgencySearchResponse = {
  __typename?: 'ConversationUrgencySearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationUrgency>>>;
};

export type CopyActivationFlowConfigInput = {
  partnerId: Scalars['Int']['input'];
  sourceBrandId: Scalars['String']['input'];
  targetBrandIds: Array<Scalars['String']['input']>;
};

export type CopyActivationFlowConfigResponse = {
  __typename?: 'CopyActivationFlowConfigResponse';
  success: Scalars['Boolean']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  amountOff?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
};

export type CreateDraftWorkflowVersionInput = {
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  workflowId: Scalars['String']['input'];
};

export type CreateDraftWorkflowVersionOutput = {
  __typename?: 'CreateDraftWorkflowVersionOutput';
  version: Scalars['Int']['output'];
  workflowId: Scalars['String']['output'];
  workflowVersionId: Scalars['String']['output'];
};

export type CreateInitialMembershipsConfigInput = {
  partnerId: Scalars['Int']['input'];
};

export type CreateInitialMembershipsConfigResponse = {
  __typename?: 'CreateInitialMembershipsConfigResponse';
  partnerProducts?: Maybe<Array<Maybe<PartnerProduct>>>;
};

export type CreateParticipantWithRelatedDataInput = {
  channels: Array<CreateParticipantWithRelatedDataInputChannel>;
  conversationId: Scalars['String']['input'];
  entityIdentifier: Scalars['String']['input'];
  participantEntity: Scalars['String']['input'];
  participationMode: Scalars['String']['input'];
  partnerEmail: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type CreateParticipantWithRelatedDataInputChannel = {
  channelType: Scalars['String']['input'];
  externalIdentifier: Scalars['String']['input'];
};

export type CreateParticipantWithRelatedDataResponse = {
  __typename?: 'CreateParticipantWithRelatedDataResponse';
  channels: Array<ConversationChannel>;
  participant: ConversationParticipant;
  participations: Array<ConversationParticipation>;
};

export type CreatePartnerWithRelatedDataError = {
  __typename?: 'CreatePartnerWithRelatedDataError';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreatePartnerWithRelatedDataInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  brandsToCreate: Array<Scalars['String']['input']>;
  businessName: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  currentPartner?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  partnerGroupIdsToAssign?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  usersEmailDomain?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  zendeskDomain?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerWithRelatedDataResponse = {
  __typename?: 'CreatePartnerWithRelatedDataResponse';
  errors?: Maybe<Array<CreatePartnerWithRelatedDataError>>;
  partner?: Maybe<Partner>;
};

export type CreateProjectWithSideEffectsInput = {
  addressId: Scalars['String']['input'];
  day1Date?: InputMaybe<Scalars['String']['input']>;
  estimatedDay1?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  projectStageId: Scalars['Int']['input'];
  signingDate?: InputMaybe<Scalars['String']['input']>;
  tosAccepted: Scalars['String']['input'];
  warrantyExpiration?: InputMaybe<Scalars['String']['input']>;
  warrantyLength?: InputMaybe<Scalars['Int']['input']>;
  willReceiveEmails: Scalars['Boolean']['input'];
};

export type CreateProjectWithSideEffectsResponse = {
  __typename?: 'CreateProjectWithSideEffectsResponse';
  address?: Maybe<Address>;
  project: Project;
  success: Scalars['Boolean']['output'];
};

export type CreatePublicApiKeyInput = {
  allowedOperations: Array<PublicApiAllowedOperationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  usagePlanId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePublicApiUsagePlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rateLimitBurst: Scalars['Int']['input'];
  rateLimitRps: Scalars['Int']['input'];
};

export type CreateSubscriptionScheduleCppInput = {
  expDate: Scalars['String']['input'];
  partnerProductId: Scalars['String']['input'];
};

export type CreateSubscriptionScheduleInput = {
  addressId: Scalars['String']['input'];
  cpp?: InputMaybe<CreateSubscriptionScheduleCppInput>;
  oneTimeTrial?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId: Scalars['Int']['input'];
  preSoldMembership?: InputMaybe<CreateSubscriptionSchedulePreSoldMembershipInput>;
};

export type CreateSubscriptionSchedulePreSoldMembershipInput = {
  amount: Scalars['Float']['input'];
  intervalCount: Scalars['Int']['input'];
  intervalUnit: Scalars['String']['input'];
  partnerProductId: Scalars['String']['input'];
};

export type CreateSubscriptionScheduleResponse = {
  __typename?: 'CreateSubscriptionScheduleResponse';
  addressId: Scalars['String']['output'];
  cppExpDate?: Maybe<Scalars['String']['output']>;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateSupportPolicyWithGroupsInput = {
  supportPolicy: SupportPolicyDataInput;
  userGroupIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreateUserDataResponse = {
  __typename?: 'CreateUserDataResponse';
  cognitoUsername: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CreateWorkflowWithFirstVersionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  /** Workflow whose active version is copied as version 1. Null starts from a blank definition. */
  sourceWorkflowId?: InputMaybe<Scalars['String']['input']>;
  /** InboundPhoneCall or InboundSms. Written onto the trigger node of version 1. */
  triggerType: Scalars['String']['input'];
  versionDescription?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkflowWithFirstVersionOutput = {
  __typename?: 'CreateWorkflowWithFirstVersionOutput';
  version: Scalars['Int']['output'];
  /**
   * The workflow as inserted. Lists read the reader replica, which can lag this write; show this
   * row instead of refetching straight away.
   */
  workflow: Workflow;
  workflowId: Scalars['String']['output'];
  /** Version 1 as inserted, with the same caveat as `workflow`. */
  workflowVersion: WorkflowVersion;
  workflowVersionId: Scalars['String']['output'];
};

export type CtaLabel = {
  __typename?: 'CtaLabel';
  addressId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  labelGroupId?: Maybe<Scalars['String']['output']>;
  labelId: Scalars['String']['output'];
  labelIsPublic?: Maybe<Scalars['Boolean']['output']>;
  labelName: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export type CurrentTriage = {
  __typename?: 'CurrentTriage';
  config?: Maybe<ConversationTriageState>;
  configurations: Array<ConversationTriageState>;
  defaultConversationTriageId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type CustomAttributeDefinition = {
  __typename?: 'CustomAttributeDefinition';
  createdAt: Scalars['String']['output'];
  customAttributeDefinitionId: Scalars['String']['output'];
  definition: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  entity: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformEntity?: Maybe<PlatformEntity>;
  updatedAt: Scalars['String']['output'];
};

export type CustomAttributeDefinitionDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomAttributeDefinitionDataInput = {
  customAttributeDefinitionId?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  entity?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomAttributeDefinitionDataResponse = {
  __typename?: 'CustomAttributeDefinitionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CustomAttributeDefinition>>>;
};

export type CustomAttributeDefinitionSearchResponse = {
  __typename?: 'CustomAttributeDefinitionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CustomAttributeDefinition>>>;
};

export enum CustomSignupBillingIntervalUnit {
  Month = 'month',
  Year = 'year',
}

export type CustomView = {
  __typename?: 'CustomView';
  columns: Scalars['String']['output'];
  conditions: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<PlatformUser>;
  customViewAccess?: Maybe<Array<Maybe<CustomViewAccess>>>;
  customViewId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  entityName: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  sort?: Maybe<Scalars['String']['output']>;
};

export type CustomViewDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomViewAccess = {
  __typename?: 'CustomViewAccess';
  createdAt: Scalars['String']['output'];
  customView?: Maybe<CustomView>;
  customViewAccessId: Scalars['String']['output'];
  customViewId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isFavorite: Scalars['Boolean']['output'];
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  platformUser?: Maybe<PlatformUser>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['String']['output'];
};

export type CustomViewAccessDataInput = {
  customViewAccessId?: InputMaybe<Scalars['String']['input']>;
  customViewId?: InputMaybe<Scalars['String']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomViewAccessDataResponse = {
  __typename?: 'CustomViewAccessDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CustomViewAccess>>>;
};

export type CustomViewAccessSearchResponse = {
  __typename?: 'CustomViewAccessSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CustomViewAccess>>>;
};

export type CustomViewConfig = {
  __typename?: 'CustomViewConfig';
  attributes?: Maybe<CustomViewConfigAttributeMap>;
  operators?: Maybe<CustomViewConfigOperatorsByUiType>;
};

export type CustomViewConfigAttribute = {
  __typename?: 'CustomViewConfigAttribute';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  default?: Maybe<Scalars['Boolean']['output']>;
  group: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<CustomViewConfigOption>>>;
  optionsQuery?: Maybe<CustomViewConfigOptionsQuery>;
  uiType: Scalars['String']['output'];
};

export type CustomViewConfigAttributeMap = {
  __typename?: 'CustomViewConfigAttributeMap';
  conversation?: Maybe<Array<Maybe<CustomViewConfigAttribute>>>;
  site?: Maybe<Array<Maybe<CustomViewConfigAttribute>>>;
};

export type CustomViewConfigOperator = {
  __typename?: 'CustomViewConfigOperator';
  arity: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomViewConfigOperatorsByUiType = {
  __typename?: 'CustomViewConfigOperatorsByUIType';
  boolean: Array<CustomViewConfigOperator>;
  date: Array<CustomViewConfigOperator>;
  list: Array<CustomViewConfigOperator>;
  number: Array<CustomViewConfigOperator>;
  text: Array<CustomViewConfigOperator>;
  textarea: Array<CustomViewConfigOperator>;
};

export type CustomViewConfigOption = {
  __typename?: 'CustomViewConfigOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomViewConfigOptionsQuery = {
  __typename?: 'CustomViewConfigOptionsQuery';
  graphqlQuery: Scalars['String']['output'];
};

export type CustomViewDataInput = {
  columns?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customViewId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type CustomViewDataResponse = {
  __typename?: 'CustomViewDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CustomView>>>;
};

export type CustomViewSearchResponse = {
  __typename?: 'CustomViewSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CustomView>>>;
};

export type DefaultSignalBusinessHour = {
  __typename?: 'DefaultSignalBusinessHour';
  endHour: Scalars['Int']['output'];
  endMinute: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  startHour: Scalars['Int']['output'];
  startMinute: Scalars['Int']['output'];
  weekday: Scalars['Int']['output'];
};

export type DefaultSignalBusinessHourByUrgency = {
  __typename?: 'DefaultSignalBusinessHourByUrgency';
  id: Scalars['String']['output'];
  signalBusinessHours: Array<Maybe<DefaultSignalBusinessHour>>;
  urgency: Scalars['String']['output'];
};

export type DefaultSignalBusinessHoursResponse = {
  __typename?: 'DefaultSignalBusinessHoursResponse';
  records: Array<Maybe<DefaultSignalBusinessHourByUrgency>>;
};

export type DeleteAddressWithRelatedDataInput = {
  addressId: Scalars['String']['input'];
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAddressWithRelatedDataResponse = {
  __typename?: 'DeleteAddressWithRelatedDataResponse';
  addressId: Scalars['String']['output'];
};

export type DeleteBrandWithRelatedDataInput = {
  brandId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type DeleteBrandWithRelatedDataResponse = {
  __typename?: 'DeleteBrandWithRelatedDataResponse';
  brandId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteClientWithRelatedDataInput = {
  clientId: Scalars['String']['input'];
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteClientWithRelatedDataResponse = {
  __typename?: 'DeleteClientWithRelatedDataResponse';
  clientId: Scalars['String']['output'];
};

export type DeleteConversationWithRelatedDataInput = {
  conversationId: Scalars['String']['input'];
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteConversationWithRelatedDataResponse = {
  __typename?: 'DeleteConversationWithRelatedDataResponse';
  conversationId: Scalars['String']['output'];
};

export type DeleteLabelToClientToAddress = {
  __typename?: 'DeleteLabelToClientToAddress';
  entity?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  labelAssignmentId?: Maybe<Scalars['String']['output']>;
  labelId?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
};

export type DeleteLabelToClientToAddressInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteLabelWithRelatedDataInput = {
  labelId: Scalars['String']['input'];
};

export type DeleteLabelWithRelatedDataResponse = {
  __typename?: 'DeleteLabelWithRelatedDataResponse';
  labelId: Scalars['String']['output'];
};

export type DeleteLegalDocumentVersionInput = {
  legalDocumentId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type DeleteMacroWithRelatedDataInput = {
  macroId: Scalars['String']['input'];
};

export type DeleteMacroWithRelatedDataResponse = {
  __typename?: 'DeleteMacroWithRelatedDataResponse';
  macroId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteProjectWithRelatedDataInput = {
  projectId: Scalars['String']['input'];
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteProjectWithRelatedDataResponse = {
  __typename?: 'DeleteProjectWithRelatedDataResponse';
  projectId: Scalars['String']['output'];
};

export type DeletePublicApiKeyInput = {
  apiKeyId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type DeleteRecordFolderWithAssignmentsDataInput = {
  recordFolderId: Scalars['String']['input'];
};

export type DeleteRecordFolderWithAssignmentsDataResponse = {
  __typename?: 'DeleteRecordFolderWithAssignmentsDataResponse';
  id: Scalars['String']['output'];
  recordFolderId: Scalars['String']['output'];
};

export type DisableBehaviorInput = {
  behaviorId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type DisableBehaviorResponse = {
  __typename?: 'DisableBehaviorResponse';
  behaviorId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DisableMacroInput = {
  macroId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type DisableMacroResponse = {
  __typename?: 'DisableMacroResponse';
  macroId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DtoolsAuthDetails = {
  __typename?: 'DtoolsAuthDetails';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastValidatedAt?: Maybe<Scalars['String']['output']>;
  maskedApiKey: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  status?: Maybe<DtoolsConnectionStatus>;
};

export type DtoolsAuthResponse = {
  __typename?: 'DtoolsAuthResponse';
  authDetails?: Maybe<DtoolsAuthDetails>;
};

export type DtoolsAuthenticateInput = {
  apiKey: Scalars['String']['input'];
};

export enum DtoolsConnectionStatus {
  Connected = 'CONNECTED',
  Invalid = 'INVALID',
}

export type DtoolsProject = {
  __typename?: 'DtoolsProject';
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  modifiedDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  projectManager?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  stageGroup?: Maybe<Scalars['String']['output']>;
  systemState?: Maybe<Scalars['String']['output']>;
};

export type DtoolsRevokeAuthenticationInput = {
  partnerId: Scalars['Int']['input'];
};

export type DtoolsRevokeAuthenticationResponse = {
  __typename?: 'DtoolsRevokeAuthenticationResponse';
  partnerId: Scalars['Int']['output'];
};

export type DynamicEntityAttribute = {
  __typename?: 'DynamicEntityAttribute';
  attribute: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DynamicEntityAttributeInput = {
  attribute: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type EmailCampaign = {
  __typename?: 'EmailCampaign';
  additionalContext?: Maybe<Scalars['String']['output']>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  approvalStatusChangedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  emailCampaignId: Scalars['String']['output'];
  emailCampaignName?: Maybe<Scalars['String']['output']>;
  emailCampaignSendDate?: Maybe<Scalars['String']['output']>;
  emailCampaignSubject?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  platformUser?: Maybe<PlatformUser>;
  previewMessageId?: Maybe<Scalars['String']['output']>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type EmailCampaignDataInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  approvalStatusChangedAt?: InputMaybe<Scalars['String']['input']>;
  emailCampaignId?: InputMaybe<Scalars['String']['input']>;
  emailCampaignName?: InputMaybe<Scalars['String']['input']>;
  emailCampaignSendDate?: InputMaybe<Scalars['String']['input']>;
  emailCampaignSubject?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  previewMessageId?: InputMaybe<Scalars['String']['input']>;
  reviewerId?: InputMaybe<Scalars['String']['input']>;
};

export type EmailCampaignDataResponse = {
  __typename?: 'EmailCampaignDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<EmailCampaign>>>;
};

export type EmailCampaignSearchResponse = {
  __typename?: 'EmailCampaignSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<EmailCampaign>>>;
};

export type EnableBehaviorInput = {
  behaviorId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type EnableBehaviorResponse = {
  __typename?: 'EnableBehaviorResponse';
  behaviorId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EnableMacroInput = {
  macroId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type EnableMacroResponse = {
  __typename?: 'EnableMacroResponse';
  macroId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EndSmsSessionInput = {
  conversationSmsSessionId: Scalars['String']['input'];
};

export type EndSmsSessionResponse = {
  __typename?: 'EndSmsSessionResponse';
  conversationSmsSession: ConversationSmsSession;
};

export type EntityIdentifier = {
  entityId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
};

export type ExportPartnerInput = {
  email: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type ExportPartnerResponse = {
  __typename?: 'ExportPartnerResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalProjectImportEntity = {
  __typename?: 'ExternalProjectImportEntity';
  diffs?: Maybe<Array<Maybe<ExternalProjectImportEntityDiff>>>;
  entity: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExternalProjectImportEntityDiff = {
  __typename?: 'ExternalProjectImportEntityDiff';
  field: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

export type ExternalProjectImportError = {
  __typename?: 'ExternalProjectImportError';
  error: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
};

export type ExternalProjectImportPreview = {
  __typename?: 'ExternalProjectImportPreview';
  address: Scalars['String']['output'];
  addressId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Array<Maybe<ExternalProjectImportEntity>>>;
  id?: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
  updated?: Maybe<Array<Maybe<ExternalProjectImportEntity>>>;
};

export type FaqQuestionInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type File = {
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type GenerateAfMagicLoginUrlInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  disableLink?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type GenerateAfMagicLoginUrlResponse = {
  __typename?: 'GenerateAFMagicLoginUrlResponse';
  url: Scalars['String']['output'];
};

export type GenerateAddressSummaryInput = {
  addressId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type GenerateAddressSummaryResponse = {
  __typename?: 'GenerateAddressSummaryResponse';
  addressId?: Maybe<Scalars['String']['output']>;
  addressSummaryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intermediateSummary?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  shortSummary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type GenerateConversationSummaryParams = {
  conversationId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type GenerateCustomMembershipCheckoutUrlInput = {
  addressId: Scalars['String']['input'];
  amountCents: Scalars['Int']['input'];
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  disableLink?: InputMaybe<Scalars['Boolean']['input']>;
  intervalCount: Scalars['Int']['input'];
  intervalUnit: CustomSignupBillingIntervalUnit;
  partnerId: Scalars['Int']['input'];
  partnerProductId: Scalars['String']['input'];
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateLandingPageLinkInput = {
  addressId: Scalars['String']['input'];
  pageSlug?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  partnerSlug?: InputMaybe<Scalars['String']['input']>;
  ttl?: InputMaybe<Scalars['Int']['input']>;
};

export type GenerateLandingPageLinkResponse = {
  __typename?: 'GenerateLandingPageLinkResponse';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateStripeBillingPortalUrlInput = {
  addressId: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateStripeBillingPortalUrlResponse = {
  __typename?: 'GenerateStripeBillingPortalUrlResponse';
  url: Scalars['String']['output'];
};

export type GenerateStripeCheckoutUrlInput = {
  addressId: Scalars['String']['input'];
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  disableLink?: InputMaybe<Scalars['Boolean']['input']>;
  selectedPricePointId: Scalars['String']['input'];
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateStripeCheckoutUrlResponse = {
  __typename?: 'GenerateStripeCheckoutUrlResponse';
  url: Scalars['String']['output'];
};

export type GetActivationFlowConfigInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['String']['input'];
  partnerId: Scalars['String']['input'];
};

export type GetActivationFlowConfigResponse = {
  __typename?: 'GetActivationFlowConfigResponse';
  features?: Maybe<Array<Maybe<AfConfigFeature>>>;
  id: Scalars['String']['output'];
  options?: Maybe<AfConfigOptions>;
  products: Array<AfConfigProduct>;
};

export type GetActivityFeedInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  entityEvents: Array<ActivityFeedEntityEvents>;
  identityIds: Array<InputMaybe<Scalars['String']['input']>>;
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId: Scalars['Int']['input'];
  referenceName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Leaves out the activities that render nested inside another activity, so only the roots of the
   * hierarchy are returned.
   */
  rootsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetActivityFeedResponse = {
  __typename?: 'GetActivityFeedResponse';
  records?: Maybe<Array<Maybe<ActivityFeed>>>;
};

export type GetAiFollowUpInput = {
  conversationId: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  promptId: Scalars['String']['input'];
  transcriptionId: Scalars['String']['input'];
  userCorrection?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type GetAiFollowUpResponse = {
  __typename?: 'GetAiFollowUpResponse';
  aiFollowUp: Scalars['String']['output'];
};

export type GetAiMessageCompositionInput = {
  conversationId: Scalars['String']['input'];
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  correction?: InputMaybe<Scalars['String']['input']>;
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  previousResponseId?: InputMaybe<Scalars['String']['input']>;
  promptId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userInput?: InputMaybe<Scalars['String']['input']>;
};

export type GetAiMessageCompositionResponse = {
  __typename?: 'GetAiMessageCompositionResponse';
  aiMessage: Scalars['String']['output'];
  responseId?: Maybe<Scalars['String']['output']>;
};

export type GetAvailableCustomViewsInput = {
  limit: Scalars['Int']['input'];
};

export type GetAvailableCustomViewsResult = {
  __typename?: 'GetAvailableCustomViewsResult';
  metadata?: Maybe<MetaData>;
  records: Array<Maybe<CustomView>>;
};

export type GetBackgroundJobInput = {
  jobId: Scalars['String']['input'];
};

export type GetBackgroundJobItemsInput = {
  jobId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BackgroundJobItemStatus>;
};

export type GetBackgroundJobItemsResponse = {
  __typename?: 'GetBackgroundJobItemsResponse';
  items: Array<BackgroundJobItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type GetBackgroundJobsInput = {
  jobType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type GetBackgroundJobsResponse = {
  __typename?: 'GetBackgroundJobsResponse';
  items: Array<BackgroundJob>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type GetBulkConversationContextInput = {
  conversationIds: Array<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetBulkConversationContextResponse = {
  __typename?: 'GetBulkConversationContextResponse';
  results: Array<BulkConversationContextItem>;
};

export type GetBundledLandingPageConfigInput = {
  brandId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type GetBundledLandingPageConfigResponse = {
  __typename?: 'GetBundledLandingPageConfigResponse';
  config: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type GetCgCustomDomainsInput = {
  partnerId: Scalars['Int']['input'];
};

export type GetChildActivityFeedInput = {
  parentActorUid: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type GetClientGatewayUrlInput = {
  partnerId: Scalars['Int']['input'];
};

export type GetConversationAggregationsInput = {
  conversationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetConversationAggregationsRecord = {
  __typename?: 'GetConversationAggregationsRecord';
  conversationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastMessageCreatedAt?: Maybe<Scalars['String']['output']>;
  unseenCount?: Maybe<Scalars['Int']['output']>;
};

export type GetConversationAggregationsResponse = {
  __typename?: 'GetConversationAggregationsResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<GetConversationAggregationsRecord>>>;
};

export type GetConversationContextInput = {
  associatedConversation?: InputMaybe<AssociatedConversationInput>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetConversationContextResponse = {
  __typename?: 'GetConversationContextResponse';
  associatedSites?: Maybe<Array<ConversationContextSite>>;
  currentUser?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  messages?: Maybe<Array<Maybe<ConversationContextMessage>>>;
  participants?: Maybe<ConversationContextParticipants>;
  partner?: Maybe<ConversationContextPartner>;
  requester?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<Scalars['String']['output']>;
};

export type GetConversationLiveTranscriptionInput = {
  conversationId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<LiveTranscriptionPaginationDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type GetConversationLiveTranscriptionResponse = {
  __typename?: 'GetConversationLiveTranscriptionResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  externalTranscriptionId: Scalars['String']['output'];
  isFinished: Scalars['Boolean']['output'];
  segments: Array<Maybe<LiveTranscriptionSegment>>;
  transcriptionId: Scalars['String']['output'];
};

export type GetConversationParticipantOptionsInput = {
  partnerId: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  skipClients?: InputMaybe<Scalars['Boolean']['input']>;
  skipPlatformUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetConversationParticipantOptionsResponse = {
  __typename?: 'GetConversationParticipantOptionsResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationParticipantOption>>>;
};

export type GetCtaLabelInput = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetCtaLabelResponse = {
  __typename?: 'GetCtaLabelResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<CtaLabel>>>;
};

export type GetDtoolsAuthDetailsInput = {
  partnerId: Scalars['Int']['input'];
};

export type GetDtoolsProjectDetailsInput = {
  projectId: Scalars['String']['input'];
};

export type GetDtoolsProjectDetailsResponse = {
  __typename?: 'GetDtoolsProjectDetailsResponse';
  content?: Maybe<Scalars['String']['output']>;
};

export type GetDtoolsProjectsInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
};

export type GetDtoolsProjectsResponse = {
  __typename?: 'GetDtoolsProjectsResponse';
  projects: Array<Maybe<DtoolsProject>>;
  totalProjects: Scalars['Int']['output'];
};

export type GetEnabledAiPromptsInput = {
  partnerId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type GetEnabledAiPromptsResponse = {
  __typename?: 'GetEnabledAiPromptsResponse';
  records: Array<Maybe<AiPrompt>>;
};

export type GetEnabledConversationAssigneeGroupsDataResponse = {
  __typename?: 'GetEnabledConversationAssigneeGroupsDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
};

export type GetEnabledConversationUrgenciesDataResponse = {
  __typename?: 'GetEnabledConversationUrgenciesDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ConversationUrgency>>>;
};

export type GetEnabledRecordFolderDataResponse = {
  __typename?: 'GetEnabledRecordFolderDataResponse';
  metadata: MetaData;
  records: Array<Maybe<RecordFolder>>;
};

export type GetEntityViewerInput = {
  entity: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
};

export type GetEntityViewerResult = {
  __typename?: 'GetEntityViewerResult';
  entity: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  items: Array<Viewer>;
  ts: Scalars['Int']['output'];
};

export type GetExternalProjectImportPreviewResponse = {
  __typename?: 'GetExternalProjectImportPreviewResponse';
  errors?: Maybe<Array<Maybe<ExternalProjectImportError>>>;
  records: Array<Maybe<ExternalProjectImportPreview>>;
};

export type GetHealthStatusResponse = {
  __typename?: 'GetHealthStatusResponse';
  status: Scalars['String']['output'];
};

export type GetLegalDocumentLinksInput = {
  brandId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type GetLegalDocumentSegmentTokenInput = {
  brandId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type GetLegalDocumentsInput = {
  partnerId: Scalars['Int']['input'];
};

export type GetMentionOptionsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type GetMentionOptionsResponse = {
  __typename?: 'GetMentionOptionsResponse';
  records?: Maybe<Array<Maybe<MentionOption>>>;
};

export type GetOriginalEmailInput = {
  conversationMessageId: Scalars['String']['input'];
};

export type GetOriginalEmailResponse = {
  __typename?: 'GetOriginalEmailResponse';
  cc?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type GetPartnerImportErrorsResponse = {
  __typename?: 'GetPartnerImportErrorsResponse';
  invalidRows?: Maybe<Scalars['AWSJSON']['output']>;
};

export type GetPartnerInvoicesInput = {
  partnerId: Scalars['Int']['input'];
};

export type GetPartnerInvoicesResponse = {
  __typename?: 'GetPartnerInvoicesResponse';
  invoices: Array<PartnerInvoice>;
};

export type GetPortalioProposalDetailsInput = {
  proposalId: Scalars['Int']['input'];
};

export type GetPortalioProposalDetailsResponse = {
  __typename?: 'GetPortalioProposalDetailsResponse';
  content: Scalars['String']['output'];
};

export type GetPortalioProposalsInput = {
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetPortalioProposalsResponse = {
  __typename?: 'GetPortalioProposalsResponse';
  records?: Maybe<Array<Maybe<PortalioProposalInfo>>>;
  total: Scalars['Int']['output'];
};

export type GetPreSignedDeleteUrlInput = {
  fileKey: Scalars['String']['input'];
};

export type GetPreSignedDeleteUrlResponse = {
  __typename?: 'GetPreSignedDeleteUrlResponse';
  url: Scalars['String']['output'];
};

export type GetPublicApiPermissionsResponse = {
  __typename?: 'GetPublicApiPermissionsResponse';
  items: Array<Maybe<PublicApiPermissionItem>>;
};

export type GetSidekickChatSessionsInput = {
  conversationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type GetSidekickRunResultInput = {
  partnerId: Scalars['Int']['input'];
  runId: Scalars['String']['input'];
};

export type GetSidekickRunsInput = {
  conversationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['Int']['input'];
  sessionRootRunId?: InputMaybe<Scalars['String']['input']>;
};

export type GetSidekickSessionRunsInput = {
  conversationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['Int']['input'];
  sessionRootRunId: Scalars['String']['input'];
};

export type GetSidekickSuggestedQuestionsInput = {
  conversationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type GetSiteContextInput = {
  addressId: Scalars['String']['input'];
  associatedConversationsFilter?: InputMaybe<AssociatedConversationFilter>;
  associatedConversationsLimit?: InputMaybe<Scalars['Int']['input']>;
  associatedConversationsOffset?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type GetSiteContextResponse = {
  __typename?: 'GetSiteContextResponse';
  activationFlowUrl?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  addressId: Scalars['String']['output'];
  associatedConversations: Array<Maybe<AssociatedConversation>>;
  clients: Array<ConversationContextClientParticipant>;
  cppExpDate?: Maybe<Scalars['String']['output']>;
  internalMembershipNotes?: Maybe<Scalars['String']['output']>;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  siteOverview?: Maybe<Scalars['String']['output']>;
  supportPolicies?: Maybe<Array<Maybe<SupportPolicyForConversationContext>>>;
};

export type GetSmsSessionLineInput = {
  conversationId: Scalars['String']['input'];
};

/** The partner line a session started from this conversation texts from (the composer's "Sends from"). */
export type GetSmsSessionLineResponse = {
  __typename?: 'GetSmsSessionLineResponse';
  brandName?: Maybe<Scalars['String']['output']>;
  /** 10 digits. */
  phoneNumber: Scalars['String']['output'];
};

export type GetSortedBehaviorsResponse = {
  __typename?: 'GetSortedBehaviorsResponse';
  metadata: MetaData;
  records: Array<Maybe<Behavior>>;
};

export type GetStripeAccountDashboardLoginUrlInput = {
  partnerId: Scalars['Int']['input'];
};

export type GetStripeAccountDashboardLoginUrlResponse = {
  __typename?: 'GetStripeAccountDashboardLoginUrlResponse';
  url: Scalars['String']['output'];
};

export type GetStripeAccountOnboardStatusInput = {
  partnerId: Scalars['Int']['input'];
};

export type GetStripeAccountOnboardStatusResponse = {
  __typename?: 'GetStripeAccountOnboardStatusResponse';
  bankAccount?: Maybe<StripeConnectedBankAccount>;
  chargesEnabled?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  detailsSubmitted: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasAccount: Scalars['Boolean']['output'];
  payoutSchedule?: Maybe<Scalars['String']['output']>;
  payoutsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GetStripeAccountOnboardUrlInput = {
  callbackUrl: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type GetStripeAccountOnboardUrlResponse = {
  __typename?: 'GetStripeAccountOnboardUrlResponse';
  url: Scalars['String']['output'];
};

export type GetStripeCheckoutConfirmationDataInput = {
  addressId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type GetStripeCheckoutConfirmationDataResponse = {
  __typename?: 'GetStripeCheckoutConfirmationDataResponse';
  intervalUnit?: Maybe<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
  product?: Maybe<Scalars['String']['output']>;
  renewsAt?: Maybe<Scalars['Int']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type GetStripeSubscriptionDetailsInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
};

export type GetStripeSubscriptionDetailsResponse = {
  __typename?: 'GetStripeSubscriptionDetailsResponse';
  balance?: Maybe<Scalars['Float']['output']>;
  billingFrequency?: Maybe<Scalars['String']['output']>;
  cancelsAt?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
  customerId?: Maybe<Scalars['String']['output']>;
  partnerProduct?: Maybe<PartnerProduct>;
  paused?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  plan?: Maybe<Scalars['String']['output']>;
  renewalAmount?: Maybe<Scalars['Float']['output']>;
  renewalDate?: Maybe<Scalars['String']['output']>;
  resumesAt?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Schedule>;
  subscriptionStatus: Scalars['String']['output'];
  trialEnd?: Maybe<Scalars['String']['output']>;
};

export type GetSubscriptionReportRow = {
  __typename?: 'GetSubscriptionReportRow';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  addressId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  chargeAmount?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  intervalCount?: Maybe<Scalars['Int']['output']>;
  invoiceSubtotal?: Maybe<Scalars['Float']['output']>;
  latestInvoiceDiscount?: Maybe<Scalars['Float']['output']>;
  latestInvoiceSubtotal?: Maybe<Scalars['Float']['output']>;
  latestInvoiceUrl?: Maybe<Scalars['String']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type GetSubscriptionsReportPagination = {
  __typename?: 'GetSubscriptionsReportPagination';
  limit: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type GetSubscriptionsReportParams = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextPage?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GetSubscriptionsReportResponse = {
  __typename?: 'GetSubscriptionsReportResponse';
  pagination: GetSubscriptionsReportPagination;
  records: Array<Maybe<GetSubscriptionReportRow>>;
};

export type GetTextInterpolationInput = {
  conversationId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type GetTriageSettingsPageDataResponse = {
  __typename?: 'GetTriageSettingsPageDataResponse';
  currentTriage: CurrentTriage;
  template: TriageTemplate;
};

export type GetTwilioClientPartnerInfoInput = {
  clientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  partnerFwdNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserConversationMessageDraftInput = {
  filters?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type GetUserConversationMessageDraftResult = {
  __typename?: 'GetUserConversationMessageDraftResult';
  metadata?: Maybe<MetaData>;
  records: Array<Maybe<ConversationMessageDraft>>;
};

export type GetUserLiveTranscriptionInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<LiveTranscriptionPaginationDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetUserLiveTranscriptionResponse = {
  __typename?: 'GetUserLiveTranscriptionResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  externalTranscriptionId: Scalars['String']['output'];
  isFinished: Scalars['Boolean']['output'];
  partnerId: Scalars['Int']['output'];
  segments: Array<Maybe<LiveTranscriptionSegment>>;
  transcriptionId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type GetUserPresenceInput = {
  userIds: Array<Scalars['String']['input']>;
};

export type GetUserPresenceResult = {
  __typename?: 'GetUserPresenceResult';
  items: Array<UserPresenceItem>;
  ts: Scalars['Int']['output'];
};

export type GetVisibleLabelsDataResponse = {
  __typename?: 'GetVisibleLabelsDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Label>>>;
};

export type GetWorkflowStepTypesResponse = {
  __typename?: 'GetWorkflowStepTypesResponse';
  stepTypes: Array<WorkflowStepType>;
  triggerTypes: Array<WorkflowTriggerType>;
};

export type HardDeleteConversationAttachmentInput = {
  conversationAttachmentId: Scalars['String']['input'];
};

export type HardDeleteConversationAttachmentResponse = {
  __typename?: 'HardDeleteConversationAttachmentResponse';
  conversationAttachmentId: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
};

export type IgnoreActiveChannelsInfo = {
  channelType?: InputMaybe<Scalars['String']['input']>;
  participationMode: Scalars['String']['input'];
};

export type ImportExternalProjectResponse = {
  __typename?: 'ImportExternalProjectResponse';
  errors?: Maybe<Array<Maybe<ExternalProjectImportError>>>;
  records: Array<Maybe<ExternalProjectImportPreview>>;
};

export type ImportPartnerInput = {
  fileKey: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type ImportPartnerProgressResponse = {
  __typename?: 'ImportPartnerProgressResponse';
  duration?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  importId?: Maybe<Scalars['String']['output']>;
  invalidCount?: Maybe<Scalars['Int']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ImportPortalioProjectInput = {
  partnerId: Scalars['Int']['input'];
  projectIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type IntegrationDriver = {
  __typename?: 'IntegrationDriver';
  address?: Maybe<Address>;
  addressId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  integrationDriverId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type IntegrationDriverDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  integrationDriverId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationDriverDataResponse = {
  __typename?: 'IntegrationDriverDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<IntegrationDriver>>>;
};

export type IntegrationDriverSearchResponse = {
  __typename?: 'IntegrationDriverSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<IntegrationDriver>>>;
};

export type Label = {
  __typename?: 'Label';
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  labelAssociations?: Maybe<Array<Maybe<LabelAssociation>>>;
  labelGroup?: Maybe<LabelGroup>;
  labelGroupId?: Maybe<Scalars['String']['output']>;
  labelId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type LabelAssignment = {
  __typename?: 'LabelAssignment';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Label>;
  labelAssignmentId: Scalars['String']['output'];
  labelId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformEntity?: Maybe<PlatformEntity>;
};

export type LabelAssignmentDataInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  labelAssignmentId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelAssignmentDataResponse = {
  __typename?: 'LabelAssignmentDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LabelAssignment>>>;
};

export type LabelAssignmentSearchResponse = {
  __typename?: 'LabelAssignmentSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LabelAssignment>>>;
};

export type LabelAssociation = {
  __typename?: 'LabelAssociation';
  createdAt: Scalars['String']['output'];
  entity: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Label>;
  labelAssociationId: Scalars['String']['output'];
  labelId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformEntity?: Maybe<PlatformEntity>;
};

export type LabelAssociationDataInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  labelAssociationId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelAssociationDataResponse = {
  __typename?: 'LabelAssociationDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LabelAssociation>>>;
};

export type LabelAssociationSearchResponse = {
  __typename?: 'LabelAssociationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LabelAssociation>>>;
};

export type LabelDataInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  labelGroupId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelDataResponse = {
  __typename?: 'LabelDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Label>>>;
};

export type LabelGroup = {
  __typename?: 'LabelGroup';
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelGroupId: Scalars['String']['output'];
  labels?: Maybe<Array<Maybe<Label>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type LabelGroupDataInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labelGroupId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelGroupDataResponse = {
  __typename?: 'LabelGroupDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LabelGroup>>>;
};

export type LabelGroupSearchResponse = {
  __typename?: 'LabelGroupSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LabelGroup>>>;
};

export type LabelSearchResponse = {
  __typename?: 'LabelSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Label>>>;
};

export type LabelToClientToAddress = {
  __typename?: 'LabelToClientToAddress';
  addressId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  labelAssignmentId: Scalars['String']['output'];
  labelId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export enum LandingPageCheckoutUnavailableReason {
  AlreadySubscribed = 'ALREADY_SUBSCRIBED',
  TokenExpired = 'TOKEN_EXPIRED',
}

export type LandingPageConfig = {
  __typename?: 'LandingPageConfig';
  brand?: Maybe<Brand>;
  brandId: Scalars['String']['output'];
  config: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  landingPageConfigId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type LandingPageConfigDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LandingPageConfigDataInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  landingPageConfigId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type LandingPageConfigDataResponse = {
  __typename?: 'LandingPageConfigDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LandingPageConfig>>>;
};

export type LandingPageConfigSearchResponse = {
  __typename?: 'LandingPageConfigSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LandingPageConfig>>>;
};

export type LegalDocument = {
  __typename?: 'LegalDocument';
  bodyHtml: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  legalDocumentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  privacyPolicyBrands?: Maybe<Array<Maybe<Brand>>>;
  termsOfServiceBrands?: Maybe<Array<Maybe<Brand>>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LegalDocumentDataInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  legalDocumentId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LegalDocumentDataResponse = {
  __typename?: 'LegalDocumentDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LegalDocument>>>;
};

export enum LegalDocumentKind {
  PrivacyPolicy = 'privacy_policy',
  TermsOfService = 'terms_of_service',
}

export type LegalDocumentLinks = {
  __typename?: 'LegalDocumentLinks';
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  termsOfServiceUrl?: Maybe<Scalars['String']['output']>;
};

export type LegalDocumentSearchResponse = {
  __typename?: 'LegalDocumentSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<LegalDocument>>>;
};

export type LegalDocumentView = {
  __typename?: 'LegalDocumentView';
  bodyHtml: Scalars['String']['output'];
  brandIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  kind: LegalDocumentKind;
  legalDocumentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum LiveTranscriptionPaginationDirection {
  Forward = 'FORWARD',
  Reverse = 'REVERSE',
}

export type LiveTranscriptionSegment = {
  __typename?: 'LiveTranscriptionSegment';
  duration?: Maybe<Scalars['Float']['output']>;
  role: Scalars['String']['output'];
  start?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['String']['output'];
  transcriptionText: Scalars['String']['output'];
};

export type Macro = {
  __typename?: 'Macro';
  actions?: Maybe<Scalars['String']['output']>;
  aiPrompt?: Maybe<AiPrompt>;
  aiPromptId?: Maybe<Scalars['String']['output']>;
  aiPromptText?: Maybe<Scalars['String']['output']>;
  author?: Maybe<PlatformUser>;
  conversationAssigneeGroups?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  macroId: Scalars['String']['output'];
  messagePrivacy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  public?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
};

export type MacroDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MacroConfig = {
  __typename?: 'MacroConfig';
  actionTypes: Array<MacroConfigActionType>;
  actions: MacroConfigActions;
  version: Scalars['String']['output'];
};

export type MacroConfigActionType = {
  __typename?: 'MacroConfigActionType';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MacroConfigActions = {
  __typename?: 'MacroConfigActions';
  data: Array<MacroConfigDataAction>;
  manageConversationLabels: MacroConfigManageConversationLabelsAction;
  manageSubAssignees: MacroConfigManageSubAssigneesAction;
  sendConversationMessage: MacroConfigSendConversationMessageAction;
  sendSlackMessage: MacroConfigSendSlackMessageAction;
  signal: MacroConfigSignalAction;
  webhook: MacroConfigWebhookAction;
};

export type MacroConfigDataAction = {
  __typename?: 'MacroConfigDataAction';
  attribute: Scalars['String']['output'];
  attributeLabel: Scalars['String']['output'];
  group: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<MacroConfigOption>>>;
  optionsQuery?: Maybe<MacroConfigOptionsQuery>;
  uiType: Scalars['String']['output'];
};

export type MacroConfigManageConversationLabelsAction = {
  __typename?: 'MacroConfigManageConversationLabelsAction';
  attributes: Array<MacroConfigManageConversationLabelsActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type MacroConfigManageConversationLabelsActionAttribute = {
  __typename?: 'MacroConfigManageConversationLabelsActionAttribute';
  label: Scalars['String']['output'];
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<MacroConfigOption>>>;
  optionsQuery?: Maybe<MacroConfigOptionsQuery>;
  uiType: Scalars['String']['output'];
};

export type MacroConfigManageSubAssigneesAction = {
  __typename?: 'MacroConfigManageSubAssigneesAction';
  attributes: Array<MacroConfigManageSubAssigneesActionAttribute>;
  triggers: Array<Scalars['String']['output']>;
};

export type MacroConfigManageSubAssigneesActionAttribute = {
  __typename?: 'MacroConfigManageSubAssigneesActionAttribute';
  label: Scalars['String']['output'];
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<MacroConfigOption>>>;
  optionsQuery?: Maybe<MacroConfigOptionsQuery>;
  uiType: Scalars['String']['output'];
};

export type MacroConfigOption = {
  __typename?: 'MacroConfigOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MacroConfigOptionsQuery = {
  __typename?: 'MacroConfigOptionsQuery';
  graphqlQuery: Scalars['String']['output'];
};

export type MacroConfigSendConversationMessageAction = {
  __typename?: 'MacroConfigSendConversationMessageAction';
  attributes: Array<MacroConfigSendConversationMessageActionAttribute>;
};

export type MacroConfigSendConversationMessageActionAttribute = {
  __typename?: 'MacroConfigSendConversationMessageActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type MacroConfigSendSlackMessageAction = {
  __typename?: 'MacroConfigSendSlackMessageAction';
  attributes: Array<MacroConfigSendSlackMessageActionAttribute>;
};

export type MacroConfigSendSlackMessageActionAttribute = {
  __typename?: 'MacroConfigSendSlackMessageActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<MacroConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type MacroConfigSignalAction = {
  __typename?: 'MacroConfigSignalAction';
  attributes: Array<MacroConfigSignalActionAttribute>;
};

export type MacroConfigSignalActionAttribute = {
  __typename?: 'MacroConfigSignalActionAttribute';
  dependsOn?: Maybe<Array<Maybe<AttributeDependency>>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<Maybe<MacroConfigOption>>;
  uiType: Scalars['String']['output'];
};

export type MacroConfigWebhookAction = {
  __typename?: 'MacroConfigWebhookAction';
  attributes: Array<MacroConfigWebhookActionAttribute>;
};

export type MacroConfigWebhookActionAttribute = {
  __typename?: 'MacroConfigWebhookActionAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<MacroConfigOption>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  uiType: Scalars['String']['output'];
};

export type MacroDataInput = {
  actions?: InputMaybe<Scalars['String']['input']>;
  aiPromptId?: InputMaybe<Scalars['String']['input']>;
  aiPromptText?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  macroId?: InputMaybe<Scalars['String']['input']>;
  messagePrivacy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

export type MacroDataResponse = {
  __typename?: 'MacroDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Macro>>>;
};

export type MacroSearchResponse = {
  __typename?: 'MacroSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Macro>>>;
};

export type MacroToConversationAssigneeGroup = {
  __typename?: 'MacroToConversationAssigneeGroup';
  conversationAssigneeGroupId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  macroId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export type MacroToConversationAssigneeGroupDataInput = {
  conversationAssigneeGroupId?: InputMaybe<Scalars['String']['input']>;
  macroId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type MacroToUserGroup = {
  __typename?: 'MacroToUserGroup';
  createdAt: Scalars['String']['output'];
  macroId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  userGroupId: Scalars['String']['output'];
};

export type MacroToUserGroupDataInput = {
  macroId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type ManageNotificationPreferencesInput = {
  notificationPreferences?: InputMaybe<
    Array<InputMaybe<ManageUserNotificationPreferenceInput>>
  >;
  persistDefaults?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManageNotificationPreferencesResponse = {
  __typename?: 'ManageNotificationPreferencesResponse';
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
};

export type ManageUserCommunicationPreferenceUnitInput = {
  communicationChannel: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  userCommunicationPreferenceId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ManageUserCommunicationPreferencesDataInput = {
  userCommunicationPreferences: Array<InputMaybe<ManageUserCommunicationPreferenceUnitInput>>;
  userId: Scalars['String']['input'];
};

export type ManageUserCommunicationPreferencesDataResponse = {
  __typename?: 'ManageUserCommunicationPreferencesDataResponse';
  userCommunicationPreferences?: Maybe<Array<Maybe<UserCommunicationPreference>>>;
  userId: Scalars['String']['output'];
};

export type ManageUserConversationAssigneeGroupsDataInput = {
  userConversationAssigneeGroups: Array<InputMaybe<ConversationAssigneeToGroupDataInput>>;
  userId: Scalars['String']['input'];
};

export type ManageUserConversationAssigneeGroupsDataResponse = {
  __typename?: 'ManageUserConversationAssigneeGroupsDataResponse';
  userConversationAssigneeGroups?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
  userId: Scalars['String']['output'];
};

export type ManageUserNotificationPreferenceInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  notificationChannelId: Scalars['String']['input'];
  notificationEventId: Scalars['String']['input'];
  notificationPreferenceId: Scalars['String']['input'];
  operation: Scalars['String']['input'];
  userNotificationRole?: InputMaybe<Array<InputMaybe<ManageUserNotificationRoleDataInput>>>;
};

export type ManageUserNotificationRoleDataInput = {
  isActive: Scalars['Boolean']['input'];
  notificationRoleId: Scalars['String']['input'];
  operation: Scalars['String']['input'];
  userNotificationRoleId: Scalars['String']['input'];
};

export type ManageUserPermissionsDataInput = {
  userGroupIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ManageUserPermissionsDataResponse = {
  __typename?: 'ManageUserPermissionsDataResponse';
  userId: Scalars['String']['output'];
};

export type Membership = {
  __typename?: 'Membership';
  addressesClientActivatedMembership?: Maybe<Array<Maybe<Address>>>;
  addressesClientSelectedMembership?: Maybe<Array<Maybe<Address>>>;
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  membershipId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type MembershipDataInput = {
  membershipId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipDataResponse = {
  __typename?: 'MembershipDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Membership>>>;
};

export type MembershipFeature = {
  __typename?: 'MembershipFeature';
  activeMembershipFeatures?: Maybe<Array<Maybe<ActiveMembershipFeature>>>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  defaultContent?: Maybe<Scalars['String']['output']>;
  defaultTooltip?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  membershipFeatureId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MembershipFeatureDataInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  defaultContent?: InputMaybe<Scalars['String']['input']>;
  defaultTooltip?: InputMaybe<Scalars['String']['input']>;
  membershipFeatureId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipFeatureDataResponse = {
  __typename?: 'MembershipFeatureDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<MembershipFeature>>>;
};

export type MembershipFeatureSearchResponse = {
  __typename?: 'MembershipFeatureSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<MembershipFeature>>>;
};

export type MembershipSearchResponse = {
  __typename?: 'MembershipSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Membership>>>;
};

export type MentionOption = {
  __typename?: 'MentionOption';
  assigneeGroupId?: Maybe<Scalars['String']['output']>;
  assigneeGroupName?: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type MergeAddressInput = {
  addressOriginId?: InputMaybe<Scalars['String']['input']>;
  addressTargetId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeAddressResponse = {
  __typename?: 'MergeAddressResponse';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MergeClientInput = {
  clientOriginId?: InputMaybe<Scalars['String']['input']>;
  clientTargetId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeClientResponse = {
  __typename?: 'MergeClientResponse';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MergeConversationInput = {
  conversationOriginId?: InputMaybe<Scalars['String']['input']>;
  conversationTargetId?: InputMaybe<Scalars['String']['input']>;
  friendlyConversationOriginId?: InputMaybe<Scalars['String']['input']>;
  friendlyConversationTargetId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<MergeConversationUserDataInput>;
};

export type MergeConversationResponse = {
  __typename?: 'MergeConversationResponse';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MergeConversationUserDataInput = {
  conversationAssigneeGroups?: InputMaybe<
    Array<InputMaybe<ConversationAssigneeGroupDataInput>>
  >;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MessageDataForSubmission = {
  attachments?: InputMaybe<Array<InputMaybe<File>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  conversationMessageId?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  mentions?: InputMaybe<Array<InputMaybe<EntityIdentifier>>>;
  parentConversationMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type MetaData = {
  __typename?: 'MetaData';
  appVersion?: Maybe<Scalars['String']['output']>;
  forceAppVersion?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type MetaDataWithSearch = {
  __typename?: 'MetaDataWithSearch';
  appVersion?: Maybe<Scalars['String']['output']>;
  forceAppVersion?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  search?: Maybe<Array<Maybe<SearchMeta>>>;
  totalRecords: Scalars['Int']['output'];
};

export type MoveAttachmentToSiteFilesInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  attachmentId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MoveAttachmentToSiteFilesResponse = {
  __typename?: 'MoveAttachmentToSiteFilesResponse';
  addressFile?: Maybe<AddressFile>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCgCustomDomain: AddCgCustomDomainResponse;
  addConversationMessageReaction: ConversationMessageReaction;
  addPartnerCgCustomDomain: CgCustomDomain;
  assignLabelToClientToAddress: LabelToClientToAddress;
  assignLegalDocument: Array<LegalDocumentView>;
  associateClientsWithAddress?: Maybe<AssociateClientsWithAddressResponse>;
  associateParticipantWithClient: AssociateParticipantWithClientResponse;
  autogenerateSiteDocs: AutogenerateSiteDocsResult;
  bulkUpdateEntities: BulkUpdateEntitiesResponse;
  cancelArsPayoutRun: ArsPayoutRunItem;
  changeWorkflowVersionActiveState: ChangeWorkflowVersionActiveStateOutput;
  checkCgCustomDomainNow: CgCustomDomain;
  checkSmsDeliverability: CheckSmsDeliverabilityResponse;
  clientGatewayAcceptTermsOfService: Scalars['Boolean']['output'];
  clientGatewayGenerateLandingPageCheckoutUrl: ClientGatewayGenerateLandingPageCheckoutUrlResponse;
  clientGatewayGenerateStripeBillingPortalUrl: GenerateStripeBillingPortalUrlResponse;
  clientGatewayGenerateStripeCheckoutUrl: GenerateStripeCheckoutUrlResponse;
  clientGatewayGetActivationFlowToken: Scalars['String']['output'];
  clientGatewayGetAuthToken: ClientGatewayGetAuthTokenResponse;
  clientGatewayRequestCode: Scalars['Boolean']['output'];
  clientGatewaySendConversationMessage: NewConversationMessageIds;
  contactSupport: ContactSupportResponse;
  copyActivationFlowConfig: CopyActivationFlowConfigResponse;
  createActivationFlowConfig: Array<Maybe<ActivationFlowConfig>>;
  createActivationFlowConfigToPrice: Array<Maybe<ActivationFlowConfigToPrice>>;
  createActiveMembershipFeature: Array<Maybe<ActiveMembershipFeature>>;
  createActivity: Array<Maybe<Activity>>;
  createActivityReference: Array<Maybe<ActivityReference>>;
  createActivityTextTemplate: Array<Maybe<ActivityTextTemplate>>;
  createAddress: Array<Maybe<Address>>;
  createAddressFile: Array<Maybe<AddressFile>>;
  createAddressSubscription: Array<Maybe<AddressSubscription>>;
  createAddressSummary: Array<Maybe<AddressSummary>>;
  createAiAgentConversation: Array<Maybe<AiAgentConversation>>;
  createAiAgentModelCall: Array<Maybe<AiAgentModelCall>>;
  createAiAgentRun: Array<Maybe<AiAgentRun>>;
  createAiAgentToolCall: Array<Maybe<AiAgentToolCall>>;
  createAiHelpLog: Array<Maybe<AiHelpLog>>;
  createAiPrompt: Array<Maybe<AiPrompt>>;
  createAiPromptToUserGroup: Array<Maybe<AiPromptToUserGroup>>;
  createArsPayoutRun: Array<Maybe<ArsPayoutRun>>;
  createArsRunReport: Array<Maybe<ArsRunReport>>;
  createArsTransfer: Array<Maybe<ArsTransfer>>;
  createBehavior: Array<Maybe<Behavior>>;
  createBehaviorSequence: Array<Maybe<BehaviorSequence>>;
  createBlockedEmail: Array<Maybe<BlockedEmail>>;
  createBlockedPhoneNumber: Array<Maybe<BlockedPhoneNumber>>;
  createBrand: Array<Maybe<Brand>>;
  createBrandGroup: Array<Maybe<BrandGroup>>;
  createCallTranscription: Array<Maybe<CallTranscription>>;
  createCallTranscriptionSegment: Array<Maybe<CallTranscriptionSegment>>;
  createCallTranscriptionToPlatformUser: Array<Maybe<CallTranscriptionToPlatformUser>>;
  createClient: Array<Maybe<Client>>;
  createClientEmail: Array<Maybe<ClientEmail>>;
  createClientEmailLabels: Array<Maybe<ClientEmailLabels>>;
  createClientPhoneLabels: Array<Maybe<ClientPhoneLabels>>;
  createClientPhoneNumber: Array<Maybe<ClientPhoneNumber>>;
  createClientToAddress: Array<Maybe<ClientToAddress>>;
  createConversation: Array<Maybe<Conversation>>;
  createConversationAssigneeGroup: Array<Maybe<ConversationAssigneeGroup>>;
  createConversationAssigneeToGroup: Array<Maybe<ConversationAssigneeToGroup>>;
  createConversationAttachment: Array<Maybe<ConversationAttachment>>;
  createConversationAttachmentDistribution: Array<Maybe<ConversationAttachmentDistribution>>;
  createConversationChannel: Array<Maybe<ConversationChannel>>;
  createConversationChannelType: Array<Maybe<ConversationChannelType>>;
  createConversationCounter: Array<Maybe<ConversationCounter>>;
  createConversationEmail: Array<Maybe<ConversationEmail>>;
  createConversationEmailDispatch: Array<Maybe<ConversationEmailDispatch>>;
  createConversationMessage: Array<Maybe<ConversationMessage>>;
  createConversationMessageAssigneeGroupMention: Array<
    Maybe<ConversationMessageAssigneeGroupMention>
  >;
  createConversationMessageDispatch: Array<Maybe<ConversationMessageDispatch>>;
  createConversationMessageDraft: Array<Maybe<ConversationMessageDraft>>;
  createConversationMessageReaction: Array<Maybe<ConversationMessageReaction>>;
  createConversationMessageThread: Array<Maybe<ConversationMessageThread>>;
  createConversationMessageUserMention: Array<Maybe<ConversationMessageUserMention>>;
  createConversationParticipant: Array<Maybe<ConversationParticipant>>;
  createConversationParticipation: Array<Maybe<ConversationParticipation>>;
  createConversationSeenState: Array<Maybe<ConversationSeenState>>;
  createConversationSms: Array<Maybe<ConversationSms>>;
  createConversationSmsDispatch: Array<Maybe<ConversationSmsDispatch>>;
  createConversationSmsSession: Array<Maybe<ConversationSmsSession>>;
  createConversationSmsSessionRecipient: Array<Maybe<ConversationSmsSessionRecipient>>;
  createConversationStatus: Array<Maybe<ConversationStatus>>;
  createConversationSummary: Array<Maybe<ConversationSummary>>;
  createConversationToAddress: Array<Maybe<ConversationToAddress>>;
  createConversationToAssignee: Array<Maybe<ConversationToAssignee>>;
  createConversationToCallTranscription: Array<Maybe<ConversationToCallTranscription>>;
  createConversationTriage: Array<Maybe<ConversationTriage>>;
  createConversationTriageRun: Array<Maybe<ConversationTriageRun>>;
  createConversationTriageRunAction: Array<Maybe<ConversationTriageRunAction>>;
  createConversationTriageRunStep: Array<Maybe<ConversationTriageRunStep>>;
  createConversationUrgency: Array<Maybe<ConversationUrgency>>;
  createCustomAttributeDefinition: Array<Maybe<CustomAttributeDefinition>>;
  createCustomView: Array<Maybe<CustomView>>;
  createCustomViewAccess: Array<Maybe<CustomViewAccess>>;
  createDraftWorkflowVersion: CreateDraftWorkflowVersionOutput;
  createEmailCampaign: Array<Maybe<EmailCampaign>>;
  createInitialMembershipsConfig: CreateInitialMembershipsConfigResponse;
  createIntegrationDriver: Array<Maybe<IntegrationDriver>>;
  createLabel: Array<Maybe<Label>>;
  createLabelAssignment: Array<Maybe<LabelAssignment>>;
  createLabelAssociation: Array<Maybe<LabelAssociation>>;
  createLabelGroup: Array<Maybe<LabelGroup>>;
  createLandingPageConfig: Array<Maybe<LandingPageConfig>>;
  createLegalDocument: Array<Maybe<LegalDocument>>;
  createMacro: Array<Maybe<Macro>>;
  createMacroToConversationAssigneeGroup: Array<Maybe<MacroToConversationAssigneeGroup>>;
  createMacroToUserGroup: Array<Maybe<MacroToUserGroup>>;
  createMembership: Array<Maybe<Membership>>;
  createMembershipFeature: Array<Maybe<MembershipFeature>>;
  createNotification: Array<Maybe<Notification>>;
  createNotificationChannel: Array<Maybe<NotificationChannel>>;
  createNotificationEvent: Array<Maybe<NotificationEvent>>;
  createNotificationEventToRole: Array<Maybe<NotificationEventToRole>>;
  createNotificationPreference: Array<Maybe<NotificationPreference>>;
  createNotificationRole: Array<Maybe<NotificationRole>>;
  createOncallManagementSchedule: Array<Maybe<OncallManagementSchedule>>;
  createOvAnnouncementsSlackApp: Array<Maybe<OvAnnouncementsSlackApp>>;
  createParticipantWithRelatedData: CreateParticipantWithRelatedDataResponse;
  createPartner: Array<Maybe<Partner>>;
  createPartnerBusinessHours: Array<Maybe<PartnerBusinessHours>>;
  createPartnerCustomDomain: Array<Maybe<PartnerCustomDomain>>;
  createPartnerDomain: Array<Maybe<PartnerDomain>>;
  createPartnerGroup: Array<Maybe<PartnerGroup>>;
  createPartnerGroupRule: Array<Maybe<PartnerGroupRule>>;
  createPartnerGroupRuleValue: Array<Maybe<PartnerGroupRuleValue>>;
  createPartnerHoliday: Array<Maybe<PartnerHoliday>>;
  createPartnerNotificationRole: Array<Maybe<PartnerNotificationRole>>;
  createPartnerOnesheet: Array<Maybe<PartnerOnesheet>>;
  createPartnerProduct: Array<Maybe<PartnerProduct>>;
  createPartnerProductPrice: Array<Maybe<PartnerProductPrice>>;
  createPartnerSetting: Array<Maybe<PartnerSetting>>;
  createPartnerSettingValue: Array<Maybe<PartnerSettingValue>>;
  createPartnerToPartnerGroup: Array<Maybe<PartnerToPartnerGroup>>;
  createPartnerWithRelatedData: CreatePartnerWithRelatedDataResponse;
  createPhoneCall: Array<Maybe<PhoneCall>>;
  createPhoneCallFile: Array<Maybe<PhoneCallFile>>;
  createPhoneCallParticipation: Array<Maybe<PhoneCallParticipation>>;
  createPhoneCallToConversation: Array<Maybe<PhoneCallToConversation>>;
  createPlatformEntity: Array<Maybe<PlatformEntity>>;
  createPlatformSla: Array<Maybe<PlatformSla>>;
  createPlatformUser: Array<Maybe<PlatformUser>>;
  createPreSoldMembership: Array<Maybe<PreSoldMembership>>;
  createProject: Array<Maybe<Project>>;
  createProjectLostReason: Array<Maybe<ProjectLostReason>>;
  createProjectStage: Array<Maybe<ProjectStage>>;
  createProjectWithSideEffects?: Maybe<CreateProjectWithSideEffectsResponse>;
  createPublicApiKey: PublicApiKeyItem;
  createPublicApiUsagePlan: PublicApiUsagePlanCreatedResponse;
  createPushNotificationSubscription: Array<Maybe<PushNotificationSubscription>>;
  createRecordFolder: Array<Maybe<RecordFolder>>;
  createRecordFolderAssignment: Array<Maybe<RecordFolderAssignment>>;
  createRsmEmail: Array<Maybe<RsmEmail>>;
  createSearchableText: Array<Maybe<SearchableText>>;
  createSearchableTextMeta: Array<Maybe<SearchableTextMeta>>;
  createSearchableTextReference: Array<Maybe<SearchableTextReference>>;
  createSidekickAiAgentConversation: Array<Maybe<SidekickAiAgentConversation>>;
  createSidekickConfiguration: Array<Maybe<SidekickConfiguration>>;
  createSidekickRun: Array<Maybe<SidekickRun>>;
  createSidekickRunMessage: Array<Maybe<SidekickRunMessage>>;
  createSignalBusinessHours: Array<Maybe<SignalBusinessHours>>;
  createSignalIncident: Array<Maybe<SignalIncident>>;
  createSignalIncidentSlackMessage: Array<Maybe<SignalIncidentSlackMessage>>;
  createStoredFile: Array<Maybe<StoredFile>>;
  createSubscriptionSchedule: CreateSubscriptionScheduleResponse;
  createSupportPolicy: Array<Maybe<SupportPolicy>>;
  createSupportPolicyToUserGroup: Array<Maybe<SupportPolicyToUserGroup>>;
  createSupportPolicyWithGroups: SupportPolicy;
  createUser: CreateUserDataResponse;
  createUserCommunicationPreference: Array<Maybe<UserCommunicationPreference>>;
  createUserGroup: Array<Maybe<UserGroup>>;
  createUserGroupRule: Array<Maybe<UserGroupRule>>;
  createUserGroupRuleValue: Array<Maybe<UserGroupRuleValue>>;
  createUserGroupSettingValue: Array<Maybe<UserGroupSettingValue>>;
  createUserNotificationRole: Array<Maybe<UserNotificationRole>>;
  createUserSetting: Array<Maybe<UserSetting>>;
  createUserSettingValue: Array<Maybe<UserSettingValue>>;
  createUserToUserGroup: Array<Maybe<UserToUserGroup>>;
  createWorkflow: Array<Maybe<Workflow>>;
  createWorkflowAssignment: Array<Maybe<WorkflowAssignment>>;
  createWorkflowExecution: Array<Maybe<WorkflowExecution>>;
  createWorkflowExecutionLog: Array<Maybe<WorkflowExecutionLog>>;
  createWorkflowVersion: Array<Maybe<WorkflowVersion>>;
  createWorkflowWithFirstVersion: CreateWorkflowWithFirstVersionOutput;
  deactivatePushNotificationSubscription: PushNotificationSubscriptionResponse;
  deleteActivationFlowConfig: Array<Maybe<ActivationFlowConfig>>;
  deleteActivationFlowConfigToPrice: Array<Maybe<ActivationFlowConfigToPrice>>;
  deleteActiveMembershipFeature: Array<Maybe<ActiveMembershipFeature>>;
  deleteActivity: Array<Maybe<Activity>>;
  deleteActivityReference: Array<Maybe<ActivityReference>>;
  deleteActivityTextTemplate: Array<Maybe<ActivityTextTemplate>>;
  deleteAddress: Array<Maybe<Address>>;
  deleteAddressFile: Array<Maybe<AddressFile>>;
  deleteAddressSubscription: Array<Maybe<AddressSubscription>>;
  deleteAddressSummary: Array<Maybe<AddressSummary>>;
  deleteAddressWithRelatedData: DeleteAddressWithRelatedDataResponse;
  deleteAiAgentConversation: Array<Maybe<AiAgentConversation>>;
  deleteAiAgentModelCall: Array<Maybe<AiAgentModelCall>>;
  deleteAiAgentRun: Array<Maybe<AiAgentRun>>;
  deleteAiAgentToolCall: Array<Maybe<AiAgentToolCall>>;
  deleteAiHelpLog: Array<Maybe<AiHelpLog>>;
  deleteAiPrompt: Array<Maybe<AiPrompt>>;
  deleteAiPromptToUserGroup: Array<Maybe<AiPromptToUserGroup>>;
  deleteArsPayoutRun: Array<Maybe<ArsPayoutRun>>;
  deleteArsRunReport: Array<Maybe<ArsRunReport>>;
  deleteArsTransfer: Array<Maybe<ArsTransfer>>;
  deleteBehavior: Array<Maybe<Behavior>>;
  deleteBehaviorSequence: Array<Maybe<BehaviorSequence>>;
  deleteBlockedEmail: Array<Maybe<BlockedEmail>>;
  deleteBlockedPhoneNumber: Array<Maybe<BlockedPhoneNumber>>;
  deleteBrand: Array<Maybe<Brand>>;
  deleteBrandGroup: Array<Maybe<BrandGroup>>;
  deleteBrandWithRelatedData: DeleteBrandWithRelatedDataResponse;
  deleteCallTranscription: Array<Maybe<CallTranscription>>;
  deleteCallTranscriptionSegment: Array<Maybe<CallTranscriptionSegment>>;
  deleteCallTranscriptionToPlatformUser: Array<Maybe<CallTranscriptionToPlatformUser>>;
  deleteClient: Array<Maybe<Client>>;
  deleteClientEmail: Array<Maybe<ClientEmail>>;
  deleteClientEmailLabels: Array<Maybe<ClientEmailLabels>>;
  deleteClientPhoneLabels: Array<Maybe<ClientPhoneLabels>>;
  deleteClientPhoneNumber: Array<Maybe<ClientPhoneNumber>>;
  deleteClientToAddress: Array<Maybe<ClientToAddress>>;
  deleteClientWithRelatedData: DeleteClientWithRelatedDataResponse;
  deleteConversation: Array<Maybe<Conversation>>;
  deleteConversationAssigneeGroup: Array<Maybe<ConversationAssigneeGroup>>;
  deleteConversationAssigneeToGroup: Array<Maybe<ConversationAssigneeToGroup>>;
  deleteConversationAttachment: Array<Maybe<ConversationAttachment>>;
  deleteConversationAttachmentDistribution: Array<Maybe<ConversationAttachmentDistribution>>;
  deleteConversationChannel: Array<Maybe<ConversationChannel>>;
  deleteConversationChannelType: Array<Maybe<ConversationChannelType>>;
  deleteConversationCounter: Array<Maybe<ConversationCounter>>;
  deleteConversationEmail: Array<Maybe<ConversationEmail>>;
  deleteConversationEmailDispatch: Array<Maybe<ConversationEmailDispatch>>;
  deleteConversationMessage: Array<Maybe<ConversationMessage>>;
  deleteConversationMessageAssigneeGroupMention: Array<
    Maybe<ConversationMessageAssigneeGroupMention>
  >;
  deleteConversationMessageDispatch: Array<Maybe<ConversationMessageDispatch>>;
  deleteConversationMessageDraft: Array<Maybe<ConversationMessageDraft>>;
  deleteConversationMessageReaction: Array<Maybe<ConversationMessageReaction>>;
  deleteConversationMessageThread: Array<Maybe<ConversationMessageThread>>;
  deleteConversationMessageUserMention: Array<Maybe<ConversationMessageUserMention>>;
  deleteConversationParticipant: Array<Maybe<ConversationParticipant>>;
  deleteConversationParticipation: Array<Maybe<ConversationParticipation>>;
  deleteConversationSeenState: Array<Maybe<ConversationSeenState>>;
  deleteConversationSms: Array<Maybe<ConversationSms>>;
  deleteConversationSmsDispatch: Array<Maybe<ConversationSmsDispatch>>;
  deleteConversationSmsSession: Array<Maybe<ConversationSmsSession>>;
  deleteConversationSmsSessionRecipient: Array<Maybe<ConversationSmsSessionRecipient>>;
  deleteConversationStatus: Array<Maybe<ConversationStatus>>;
  deleteConversationSummary: Array<Maybe<ConversationSummary>>;
  deleteConversationToAddress: Array<Maybe<ConversationToAddress>>;
  deleteConversationToAssignee: Array<Maybe<ConversationToAssignee>>;
  deleteConversationToCallTranscription: Array<Maybe<ConversationToCallTranscription>>;
  deleteConversationTriage: Array<Maybe<ConversationTriage>>;
  deleteConversationTriageRun: Array<Maybe<ConversationTriageRun>>;
  deleteConversationTriageRunAction: Array<Maybe<ConversationTriageRunAction>>;
  deleteConversationTriageRunStep: Array<Maybe<ConversationTriageRunStep>>;
  deleteConversationUrgency: Array<Maybe<ConversationUrgency>>;
  deleteConversationWithRelatedData: DeleteConversationWithRelatedDataResponse;
  deleteCustomAttributeDefinition: Array<Maybe<CustomAttributeDefinition>>;
  deleteCustomView: Array<Maybe<CustomView>>;
  deleteCustomViewAccess: Array<Maybe<CustomViewAccess>>;
  deleteEmailCampaign: Array<Maybe<EmailCampaign>>;
  deleteIntegrationDriver: Array<Maybe<IntegrationDriver>>;
  deleteLabel: Array<Maybe<Label>>;
  deleteLabelAssignment: Array<Maybe<LabelAssignment>>;
  deleteLabelAssociation: Array<Maybe<LabelAssociation>>;
  deleteLabelGroup: Array<Maybe<LabelGroup>>;
  deleteLabelToClientToAddress: Array<Maybe<DeleteLabelToClientToAddress>>;
  deleteLabelWithRelatedData: DeleteLabelWithRelatedDataResponse;
  deleteLandingPageConfig: Array<Maybe<LandingPageConfig>>;
  deleteLegalDocument: Array<Maybe<LegalDocument>>;
  deleteLegalDocumentVersion: Array<LegalDocumentView>;
  deleteMacro: Array<Maybe<Macro>>;
  deleteMacroToConversationAssigneeGroup: Array<Maybe<MacroToConversationAssigneeGroup>>;
  deleteMacroToUserGroup: Array<Maybe<MacroToUserGroup>>;
  deleteMacroWithRelatedData: DeleteMacroWithRelatedDataResponse;
  deleteMembership: Array<Maybe<Membership>>;
  deleteMembershipFeature: Array<Maybe<MembershipFeature>>;
  deleteNotification: Array<Maybe<Notification>>;
  deleteNotificationChannel: Array<Maybe<NotificationChannel>>;
  deleteNotificationEvent: Array<Maybe<NotificationEvent>>;
  deleteNotificationEventToRole: Array<Maybe<NotificationEventToRole>>;
  deleteNotificationPreference: Array<Maybe<NotificationPreference>>;
  deleteNotificationRole: Array<Maybe<NotificationRole>>;
  deleteOncallManagementSchedule: Array<Maybe<OncallManagementSchedule>>;
  deleteOvAnnouncementsSlackApp: Array<Maybe<OvAnnouncementsSlackApp>>;
  deletePartner: Array<Maybe<Partner>>;
  deletePartnerBusinessHours: Array<Maybe<PartnerBusinessHours>>;
  deletePartnerCustomDomain: Array<Maybe<PartnerCustomDomain>>;
  deletePartnerDomain: Array<Maybe<PartnerDomain>>;
  deletePartnerGroup: Array<Maybe<PartnerGroup>>;
  deletePartnerGroupRule: Array<Maybe<PartnerGroupRule>>;
  deletePartnerGroupRuleValue: Array<Maybe<PartnerGroupRuleValue>>;
  deletePartnerHoliday: Array<Maybe<PartnerHoliday>>;
  deletePartnerNotificationRole: Array<Maybe<PartnerNotificationRole>>;
  deletePartnerOnesheet: Array<Maybe<PartnerOnesheet>>;
  deletePartnerProduct: Array<Maybe<PartnerProduct>>;
  deletePartnerProductPrice: Array<Maybe<PartnerProductPrice>>;
  deletePartnerSetting: Array<Maybe<PartnerSetting>>;
  deletePartnerSettingValue: Array<Maybe<PartnerSettingValue>>;
  deletePartnerToPartnerGroup: Array<Maybe<PartnerToPartnerGroup>>;
  deletePhoneCall: Array<Maybe<PhoneCall>>;
  deletePhoneCallFile: Array<Maybe<PhoneCallFile>>;
  deletePhoneCallParticipation: Array<Maybe<PhoneCallParticipation>>;
  deletePhoneCallToConversation: Array<Maybe<PhoneCallToConversation>>;
  deletePlatformEntity: Array<Maybe<PlatformEntity>>;
  deletePlatformSla: Array<Maybe<PlatformSla>>;
  deletePlatformUser: Array<Maybe<PlatformUser>>;
  deletePreSoldMembership: Array<Maybe<PreSoldMembership>>;
  deleteProject: Array<Maybe<Project>>;
  deleteProjectLostReason: Array<Maybe<ProjectLostReason>>;
  deleteProjectStage: Array<Maybe<ProjectStage>>;
  deleteProjectWithRelatedData: DeleteProjectWithRelatedDataResponse;
  deletePublicApiKey: Scalars['Boolean']['output'];
  deletePushNotificationSubscription: Array<Maybe<PushNotificationSubscription>>;
  deleteRecordFolder: Array<Maybe<RecordFolder>>;
  deleteRecordFolderAssignment: Array<Maybe<RecordFolderAssignment>>;
  deleteRecordFolderWithAssignments: DeleteRecordFolderWithAssignmentsDataResponse;
  deleteRsmEmail: Array<Maybe<RsmEmail>>;
  deleteSearchableText: Array<Maybe<SearchableText>>;
  deleteSearchableTextMeta: Array<Maybe<SearchableTextMeta>>;
  deleteSearchableTextReference: Array<Maybe<SearchableTextReference>>;
  deleteSidekickAiAgentConversation: Array<Maybe<SidekickAiAgentConversation>>;
  deleteSidekickConfiguration: Array<Maybe<SidekickConfiguration>>;
  deleteSidekickRun: Array<Maybe<SidekickRun>>;
  deleteSidekickRunMessage: Array<Maybe<SidekickRunMessage>>;
  deleteSignalBusinessHours: Array<Maybe<SignalBusinessHours>>;
  deleteSignalIncident: Array<Maybe<SignalIncident>>;
  deleteSignalIncidentSlackMessage: Array<Maybe<SignalIncidentSlackMessage>>;
  deleteStoredFile: Array<Maybe<StoredFile>>;
  deleteSupportPolicy: Array<Maybe<SupportPolicy>>;
  deleteSupportPolicyToUserGroup: Array<Maybe<SupportPolicyToUserGroup>>;
  deleteUserCommunicationPreference: Array<Maybe<UserCommunicationPreference>>;
  deleteUserGroup: Array<Maybe<UserGroup>>;
  deleteUserGroupRule: Array<Maybe<UserGroupRule>>;
  deleteUserGroupRuleValue: Array<Maybe<UserGroupRuleValue>>;
  deleteUserGroupSettingValue: Array<Maybe<UserGroupSettingValue>>;
  deleteUserNotificationRole: Array<Maybe<UserNotificationRole>>;
  deleteUserSetting: Array<Maybe<UserSetting>>;
  deleteUserSettingValue: Array<Maybe<UserSettingValue>>;
  deleteUserToUserGroup: Array<Maybe<UserToUserGroup>>;
  deleteWorkflow: Array<Maybe<Workflow>>;
  deleteWorkflowAssignment: Array<Maybe<WorkflowAssignment>>;
  deleteWorkflowExecution: Array<Maybe<WorkflowExecution>>;
  deleteWorkflowExecutionLog: Array<Maybe<WorkflowExecutionLog>>;
  deleteWorkflowVersion: Array<Maybe<WorkflowVersion>>;
  disableBehavior: DisableBehaviorResponse;
  disableMacro: DisableMacroResponse;
  dtoolsAuthenticate: DtoolsAuthResponse;
  dtoolsRevokeAuthentication: DtoolsRevokeAuthenticationResponse;
  enableBehavior: EnableBehaviorResponse;
  enableMacro: EnableMacroResponse;
  endSmsSession: EndSmsSessionResponse;
  exportPartner: ExportPartnerResponse;
  generateAFMagicLoginUrl: GenerateAfMagicLoginUrlResponse;
  generateAddressSummary: GenerateAddressSummaryResponse;
  generateCustomMembershipCheckoutUrl: GenerateStripeCheckoutUrlResponse;
  generateLandingPageLink: GenerateLandingPageLinkResponse;
  generateStripeBillingPortalUrl: PortalGenerateStripeBillingPortalUrlResponse;
  hardDeleteConversationAttachment: HardDeleteConversationAttachmentResponse;
  importPortalioProject: ImportExternalProjectResponse;
  initImportPartner: ImportPartnerProgressResponse;
  manageNotificationPreferences?: Maybe<ManageNotificationPreferencesResponse>;
  manageUserCommunicationPreferences: ManageUserCommunicationPreferencesDataResponse;
  manageUserConversationAssigneeGroups: ManageUserConversationAssigneeGroupsDataResponse;
  manageUserPermissions: ManageUserPermissionsDataResponse;
  mergeAddress: MergeAddressResponse;
  mergeClient: MergeClientResponse;
  mergeConversation: MergeConversationResponse;
  moveAttachmentToSiteFiles: MoveAttachmentToSiteFilesResponse;
  pauseSubscription: PauseSubscriptionResponse;
  portalioAuthenticate: PortalioAuthResponse;
  portalioRevokeAuthentication: PortalioRevokeAuthenticationResponse;
  postMemberServicesFollowUp?: Maybe<PostMemberServicesFollowUpResponse>;
  prepareSidekickAiAgentRequest: PrepareSidekickAiAgentRequestResponse;
  removeCgCustomDomain: Scalars['Boolean']['output'];
  removeConversationMessageReaction: RemoveConversationMessageReactionResponse;
  resolveConversationMessageThread: ConversationMessageThread;
  resolveCustomMembershipPrice: ResolveCustomMembershipPriceResponse;
  resolveSignalIncident: ResolveSignalIncidentResponse;
  resolveTriageAction: ResolveTriageActionResponse;
  restoreDeletedAddress: RestoreDeletedAddressResponse;
  restoreDeletedClient: RestoreDeletedClientResponse;
  restoreDeletedConversation: RestoreDeletedConversationResponse;
  restoreDeletedProject: RestoreDeletedProjectResponse;
  resumeArsPayoutRun: ArsPayoutRunItem;
  rotatePublicApiKey: PublicApiKeyRotatedResponse;
  saveActivationFlowConfigBundle: SaveActivationFlowConfigBundleResponse;
  saveClientWithRelatedData: SaveClientWithRelatedDataResponse;
  saveConversationForTwilioPhoneCallRecording: Scalars['Boolean']['output'];
  saveDraftWorkflowVersionDefinition: SaveDraftWorkflowVersionDefinitionOutput;
  saveLandingPageConfig: SaveLandingPageConfigResponse;
  saveLegalDocument: Array<LegalDocumentView>;
  saveTwilioConversationContent: Scalars['Boolean']['output'];
  sendMembershipEmail?: Maybe<SendMembershipEmailResponse>;
  setCgCustomDomainSegments: CgCustomDomain;
  setDefaultConversationTriage: Scalars['Boolean']['output'];
  setUserPassword: SetUserPasswordDataResponse;
  setWorkflowAssignment: SetWorkflowAssignmentOutput;
  snoozeConversation: SnoozeConversationResponse;
  softDeleteConversationTriage: Scalars['Boolean']['output'];
  softDeleteWorkflow: Scalars['Boolean']['output'];
  softDeleteWorkflowVersion: Scalars['Boolean']['output'];
  startArsPayoutRun: ArsPayoutRunItem;
  startConversationTriage: StartConversationTriageResponse;
  startDtoolsProjectImportJob: BackgroundJob;
  startSidekickRun: SidekickRun;
  startSmsSession: StartSmsSessionResponse;
  submitConversationData: SubmitConversationDataResponse;
  submitDay1: SubmitDay1Response;
  submitProposalLost: SubmitProposalLostResponse;
  submitProposalWon: SubmitProposalWonResponse;
  syncEmailBrandingCache: SyncEmailBrandingCacheResponse;
  syncPartnerSla: SyncPartnerSlaResponse;
  triggerIterableSync: TriggerIterableSyncResponse;
  triggerPartnerInvoiceGeneration: TriggerPartnerInvoiceGenerationResponse;
  undoBulkUpdateEntities: UndoBulkUpdateEntitiesResponse;
  unpauseSubscription: PauseSubscriptionResponse;
  unresolveConversationMessageThread?: Maybe<ConversationMessageThread>;
  updateActivationFlowConfig: Array<Maybe<ActivationFlowConfig>>;
  updateActivationFlowConfigToPrice: Array<Maybe<ActivationFlowConfigToPrice>>;
  updateActiveMembershipFeature: Array<Maybe<ActiveMembershipFeature>>;
  updateActivity: Array<Maybe<Activity>>;
  updateActivityReference: Array<Maybe<ActivityReference>>;
  updateActivityTextTemplate: Array<Maybe<ActivityTextTemplate>>;
  updateAddress: Array<Maybe<Address>>;
  updateAddressFile: Array<Maybe<AddressFile>>;
  updateAddressSubscription: Array<Maybe<AddressSubscription>>;
  updateAddressSummary: Array<Maybe<AddressSummary>>;
  updateAiAgentConversation: Array<Maybe<AiAgentConversation>>;
  updateAiAgentModelCall: Array<Maybe<AiAgentModelCall>>;
  updateAiAgentRun: Array<Maybe<AiAgentRun>>;
  updateAiAgentToolCall: Array<Maybe<AiAgentToolCall>>;
  updateAiHelpLog: Array<Maybe<AiHelpLog>>;
  updateAiPrompt: Array<Maybe<AiPrompt>>;
  updateArsPayoutRun: Array<Maybe<ArsPayoutRun>>;
  updateArsRunReport: Array<Maybe<ArsRunReport>>;
  updateArsTransfer: Array<Maybe<ArsTransfer>>;
  updateBehavior: Array<Maybe<Behavior>>;
  updateBehaviorSequence: Array<Maybe<BehaviorSequence>>;
  updateBehaviorSorting: UpdateBehaviorSortingResponse;
  updateBlockedEmail: Array<Maybe<BlockedEmail>>;
  updateBlockedPhoneNumber: Array<Maybe<BlockedPhoneNumber>>;
  updateBrand: Array<Maybe<Brand>>;
  updateBrandGroup: Array<Maybe<BrandGroup>>;
  updateCallTranscription: Array<Maybe<CallTranscription>>;
  updateCallTranscriptionSegment: Array<Maybe<CallTranscriptionSegment>>;
  updateClient: Array<Maybe<Client>>;
  updateClientEmail: Array<Maybe<ClientEmail>>;
  updateClientEmailLabels: Array<Maybe<ClientEmailLabels>>;
  updateClientPhoneLabels: Array<Maybe<ClientPhoneLabels>>;
  updateClientPhoneNumber: Array<Maybe<ClientPhoneNumber>>;
  updateConversation: Array<Maybe<Conversation>>;
  updateConversationAsSeen: UpdateConversationAsSeenResponse;
  updateConversationAssigneeGroup: Array<Maybe<ConversationAssigneeGroup>>;
  updateConversationAttachment: Array<Maybe<ConversationAttachment>>;
  updateConversationAttachmentDistribution: Array<Maybe<ConversationAttachmentDistribution>>;
  updateConversationChannel: Array<Maybe<ConversationChannel>>;
  updateConversationChannelType: Array<Maybe<ConversationChannelType>>;
  updateConversationCounter: Array<Maybe<ConversationCounter>>;
  updateConversationEmail: Array<Maybe<ConversationEmail>>;
  updateConversationEmailDispatch: Array<Maybe<ConversationEmailDispatch>>;
  updateConversationMessage: Array<Maybe<ConversationMessage>>;
  updateConversationMessageDispatch: Array<Maybe<ConversationMessageDispatch>>;
  updateConversationMessageDraft: Array<Maybe<ConversationMessageDraft>>;
  updateConversationMessageReaction: Array<Maybe<ConversationMessageReaction>>;
  updateConversationMessageThread: Array<Maybe<ConversationMessageThread>>;
  updateConversationParticipant: Array<Maybe<ConversationParticipant>>;
  updateConversationParticipation: Array<Maybe<ConversationParticipation>>;
  updateConversationPrivateMessage: Array<ConversationMessage>;
  updateConversationSeenState: Array<Maybe<ConversationSeenState>>;
  updateConversationSms: Array<Maybe<ConversationSms>>;
  updateConversationSmsDispatch: Array<Maybe<ConversationSmsDispatch>>;
  updateConversationSmsSession: Array<Maybe<ConversationSmsSession>>;
  updateConversationSmsSessionRecipient: Array<Maybe<ConversationSmsSessionRecipient>>;
  updateConversationStatus: Array<Maybe<ConversationStatus>>;
  updateConversationSummary: Array<Maybe<ConversationSummary>>;
  updateConversationTriage: Array<Maybe<ConversationTriage>>;
  updateConversationTriageRun: Array<Maybe<ConversationTriageRun>>;
  updateConversationTriageRunAction: Array<Maybe<ConversationTriageRunAction>>;
  updateConversationTriageRunStep: Array<Maybe<ConversationTriageRunStep>>;
  updateConversationUrgency: Array<Maybe<ConversationUrgency>>;
  updateCustomAttributeDefinition: Array<Maybe<CustomAttributeDefinition>>;
  updateCustomView: Array<Maybe<CustomView>>;
  updateCustomViewAccess: Array<Maybe<CustomViewAccess>>;
  updateEmailCampaign: Array<Maybe<EmailCampaign>>;
  updateEntityViewer: UpdateEntityViewerResult;
  updateIntegrationDriver: Array<Maybe<IntegrationDriver>>;
  updateLabel: Array<Maybe<Label>>;
  updateLabelAssignment: Array<Maybe<LabelAssignment>>;
  updateLabelAssociation: Array<Maybe<LabelAssociation>>;
  updateLabelGroup: Array<Maybe<LabelGroup>>;
  updateLandingPageConfig: Array<Maybe<LandingPageConfig>>;
  updateLegalDocument: Array<Maybe<LegalDocument>>;
  updateMacro: Array<Maybe<Macro>>;
  updateMembership: Array<Maybe<Membership>>;
  updateMembershipFeature: Array<Maybe<MembershipFeature>>;
  updateNotification: Array<Maybe<Notification>>;
  updateNotificationChannel: Array<Maybe<NotificationChannel>>;
  updateNotificationEvent: Array<Maybe<NotificationEvent>>;
  updateNotificationPreference: Array<Maybe<NotificationPreference>>;
  updateNotificationRole: Array<Maybe<NotificationRole>>;
  updateOncallManagementSchedule: Array<Maybe<OncallManagementSchedule>>;
  updateOvAnnouncementsSlackApp: Array<Maybe<OvAnnouncementsSlackApp>>;
  updatePartner: Array<Maybe<Partner>>;
  updatePartnerBusinessHours: Array<Maybe<PartnerBusinessHours>>;
  updatePartnerCustomDomain: Array<Maybe<PartnerCustomDomain>>;
  updatePartnerDomain: Array<Maybe<PartnerDomain>>;
  updatePartnerGroup: Array<Maybe<PartnerGroup>>;
  updatePartnerGroupRule: Array<Maybe<PartnerGroupRule>>;
  updatePartnerGroupRuleValue: Array<Maybe<PartnerGroupRuleValue>>;
  updatePartnerHoliday: Array<Maybe<PartnerHoliday>>;
  updatePartnerNotificationRole: Array<Maybe<PartnerNotificationRole>>;
  updatePartnerOnesheet: Array<Maybe<PartnerOnesheet>>;
  updatePartnerProduct: Array<Maybe<PartnerProduct>>;
  updatePartnerProductPrice: Array<Maybe<PartnerProductPrice>>;
  updatePartnerSetting: Array<Maybe<PartnerSetting>>;
  updatePartnerSettingValue: Array<Maybe<PartnerSettingValue>>;
  updatePhoneCall: Array<Maybe<PhoneCall>>;
  updatePhoneCallFile: Array<Maybe<PhoneCallFile>>;
  updatePhoneCallParticipation: Array<Maybe<PhoneCallParticipation>>;
  updatePlatformEntity: Array<Maybe<PlatformEntity>>;
  updatePlatformSla: Array<Maybe<PlatformSla>>;
  updatePlatformUser: Array<Maybe<PlatformUser>>;
  updatePreSoldMembership: Array<Maybe<PreSoldMembership>>;
  updateProject: Array<Maybe<Project>>;
  updateProjectLostReason: Array<Maybe<ProjectLostReason>>;
  updateProjectStage: Array<Maybe<ProjectStage>>;
  updatePublicApiKey: PublicApiKeyItem;
  updatePushNotificationSubscription: Array<Maybe<PushNotificationSubscription>>;
  updateRecordFolder: Array<Maybe<RecordFolder>>;
  updateRecordFolderAssignment: Array<Maybe<RecordFolderAssignment>>;
  updateRsmEmail: Array<Maybe<RsmEmail>>;
  updateSearchableText: Array<Maybe<SearchableText>>;
  updateSearchableTextMeta: Array<Maybe<SearchableTextMeta>>;
  updateSearchableTextReference: Array<Maybe<SearchableTextReference>>;
  updateSidekickAiAgentConversation: Array<Maybe<SidekickAiAgentConversation>>;
  updateSidekickConfiguration: Array<Maybe<SidekickConfiguration>>;
  updateSidekickRun: Array<Maybe<SidekickRun>>;
  updateSidekickRunMessage: Array<Maybe<SidekickRunMessage>>;
  updateSignalBusinessHours: Array<Maybe<SignalBusinessHours>>;
  updateSignalIncident: Array<Maybe<SignalIncident>>;
  updateSignalIncidentSlackMessage: Array<Maybe<SignalIncidentSlackMessage>>;
  updateStoredFile: Array<Maybe<StoredFile>>;
  updateSupportPolicy: Array<Maybe<SupportPolicy>>;
  updateSupportPolicyToUserGroup: Array<Maybe<SupportPolicyToUserGroup>>;
  updateSupportPolicyWithGroups: SupportPolicy;
  updateUserActiveState: UpdateUserActiveStateDataResponse;
  updateUserCommunicationPreference: Array<Maybe<UserCommunicationPreference>>;
  updateUserGroup: Array<Maybe<UserGroup>>;
  updateUserGroupRule: Array<Maybe<UserGroupRule>>;
  updateUserGroupRuleValue: Array<Maybe<UserGroupRuleValue>>;
  updateUserGroupSettingValue: Array<Maybe<UserGroupSettingValue>>;
  updateUserNotificationRole: Array<Maybe<UserNotificationRole>>;
  updateUserPresence: UpdateUserPresenceResult;
  updateUserSetting: Array<Maybe<UserSetting>>;
  updateUserSettingValue: Array<Maybe<UserSettingValue>>;
  updateWorkflow: Array<Maybe<Workflow>>;
  updateWorkflowAssignment: Array<Maybe<WorkflowAssignment>>;
  updateWorkflowExecution: Array<Maybe<WorkflowExecution>>;
  updateWorkflowExecutionLog: Array<Maybe<WorkflowExecutionLog>>;
  updateWorkflowVersion: Array<Maybe<WorkflowVersion>>;
  upsertConversationMessageDraft: ConversationMessageDraft;
  upsertPushNotificationSubscription: PushNotificationSubscription;
};

export type MutationAddCgCustomDomainArgs = {
  params: AddCgCustomDomainInput;
};

export type MutationAddConversationMessageReactionArgs = {
  params: ConversationMessageReactionInput;
};

export type MutationAddPartnerCgCustomDomainArgs = {
  input: AddPartnerCgCustomDomainInput;
};

export type MutationAssignLabelToClientToAddressArgs = {
  data?: InputMaybe<AssignLabelToClientToAddressInput>;
};

export type MutationAssignLegalDocumentArgs = {
  input: AssignLegalDocumentInput;
};

export type MutationAssociateClientsWithAddressArgs = {
  data: AssociateClientsWithAddressInput;
};

export type MutationAssociateParticipantWithClientArgs = {
  params?: InputMaybe<AssociateParticipantWithClientInput>;
};

export type MutationAutogenerateSiteDocsArgs = {
  params: AutogenerateSiteDocsInput;
};

export type MutationBulkUpdateEntitiesArgs = {
  input: BulkUpdateEntitiesInput;
};

export type MutationCancelArsPayoutRunArgs = {
  params: ArsPayoutRunIdInput;
};

export type MutationChangeWorkflowVersionActiveStateArgs = {
  input: ChangeWorkflowVersionActiveStateInput;
};

export type MutationCheckCgCustomDomainNowArgs = {
  input: CgCustomDomainInput;
};

export type MutationCheckSmsDeliverabilityArgs = {
  input: CheckSmsDeliverabilityInput;
};

export type MutationClientGatewayAcceptTermsOfServiceArgs = {
  addressId: Scalars['String']['input'];
};

export type MutationClientGatewayGenerateLandingPageCheckoutUrlArgs = {
  input: ClientGatewayGenerateLandingPageCheckoutUrlInput;
};

export type MutationClientGatewayGenerateStripeBillingPortalUrlArgs = {
  input: GenerateStripeBillingPortalUrlInput;
};

export type MutationClientGatewayGenerateStripeCheckoutUrlArgs = {
  input: GenerateStripeCheckoutUrlInput;
};

export type MutationClientGatewayGetActivationFlowTokenArgs = {
  addressId: Scalars['String']['input'];
};

export type MutationClientGatewayGetAuthTokenArgs = {
  input: ClientGatewayGetAuthTokenInput;
};

export type MutationClientGatewayRequestCodeArgs = {
  email: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
};

export type MutationClientGatewaySendConversationMessageArgs = {
  input: ClientGatewaySendConversationMessageInput;
};

export type MutationContactSupportArgs = {
  params: ContactSupportInput;
};

export type MutationCopyActivationFlowConfigArgs = {
  input: CopyActivationFlowConfigInput;
};

export type MutationCreateActivationFlowConfigArgs = {
  data?: InputMaybe<ActivationFlowConfigDataInput>;
};

export type MutationCreateActivationFlowConfigToPriceArgs = {
  data?: InputMaybe<ActivationFlowConfigToPriceDataInput>;
};

export type MutationCreateActiveMembershipFeatureArgs = {
  data?: InputMaybe<ActiveMembershipFeatureDataInput>;
};

export type MutationCreateActivityArgs = {
  data?: InputMaybe<ActivityDataInput>;
};

export type MutationCreateActivityReferenceArgs = {
  data?: InputMaybe<ActivityReferenceDataInput>;
};

export type MutationCreateActivityTextTemplateArgs = {
  data?: InputMaybe<ActivityTextTemplateDataInput>;
};

export type MutationCreateAddressArgs = {
  data?: InputMaybe<AddressDataInput>;
};

export type MutationCreateAddressFileArgs = {
  data?: InputMaybe<AddressFileDataInput>;
};

export type MutationCreateAddressSubscriptionArgs = {
  data?: InputMaybe<AddressSubscriptionDataInput>;
};

export type MutationCreateAddressSummaryArgs = {
  data?: InputMaybe<AddressSummaryDataInput>;
};

export type MutationCreateAiAgentConversationArgs = {
  data?: InputMaybe<AiAgentConversationDataInput>;
};

export type MutationCreateAiAgentModelCallArgs = {
  data?: InputMaybe<AiAgentModelCallDataInput>;
};

export type MutationCreateAiAgentRunArgs = {
  data?: InputMaybe<AiAgentRunDataInput>;
};

export type MutationCreateAiAgentToolCallArgs = {
  data?: InputMaybe<AiAgentToolCallDataInput>;
};

export type MutationCreateAiHelpLogArgs = {
  data?: InputMaybe<AiHelpLogDataInput>;
};

export type MutationCreateAiPromptArgs = {
  data?: InputMaybe<AiPromptDataInput>;
};

export type MutationCreateAiPromptToUserGroupArgs = {
  data?: InputMaybe<AiPromptToUserGroupDataInput>;
};

export type MutationCreateArsPayoutRunArgs = {
  data?: InputMaybe<ArsPayoutRunDataInput>;
};

export type MutationCreateArsRunReportArgs = {
  data?: InputMaybe<ArsRunReportDataInput>;
};

export type MutationCreateArsTransferArgs = {
  data?: InputMaybe<ArsTransferDataInput>;
};

export type MutationCreateBehaviorArgs = {
  data?: InputMaybe<BehaviorDataInput>;
};

export type MutationCreateBehaviorSequenceArgs = {
  data?: InputMaybe<BehaviorSequenceDataInput>;
};

export type MutationCreateBlockedEmailArgs = {
  data?: InputMaybe<BlockedEmailDataInput>;
};

export type MutationCreateBlockedPhoneNumberArgs = {
  data?: InputMaybe<BlockedPhoneNumberDataInput>;
};

export type MutationCreateBrandArgs = {
  data?: InputMaybe<BrandDataInput>;
};

export type MutationCreateBrandGroupArgs = {
  data?: InputMaybe<BrandGroupDataInput>;
};

export type MutationCreateCallTranscriptionArgs = {
  data?: InputMaybe<CallTranscriptionDataInput>;
};

export type MutationCreateCallTranscriptionSegmentArgs = {
  data?: InputMaybe<CallTranscriptionSegmentDataInput>;
};

export type MutationCreateCallTranscriptionToPlatformUserArgs = {
  data?: InputMaybe<CallTranscriptionToPlatformUserDataInput>;
};

export type MutationCreateClientArgs = {
  data?: InputMaybe<ClientDataInput>;
};

export type MutationCreateClientEmailArgs = {
  data?: InputMaybe<ClientEmailDataInput>;
};

export type MutationCreateClientEmailLabelsArgs = {
  data?: InputMaybe<ClientEmailLabelsDataInput>;
};

export type MutationCreateClientPhoneLabelsArgs = {
  data?: InputMaybe<ClientPhoneLabelsDataInput>;
};

export type MutationCreateClientPhoneNumberArgs = {
  data?: InputMaybe<ClientPhoneNumberDataInput>;
};

export type MutationCreateClientToAddressArgs = {
  data?: InputMaybe<ClientToAddressDataInput>;
};

export type MutationCreateConversationArgs = {
  data?: InputMaybe<ConversationDataInput>;
};

export type MutationCreateConversationAssigneeGroupArgs = {
  data?: InputMaybe<ConversationAssigneeGroupDataInput>;
};

export type MutationCreateConversationAssigneeToGroupArgs = {
  data?: InputMaybe<ConversationAssigneeToGroupDataInput>;
};

export type MutationCreateConversationAttachmentArgs = {
  data?: InputMaybe<ConversationAttachmentDataInput>;
};

export type MutationCreateConversationAttachmentDistributionArgs = {
  data?: InputMaybe<ConversationAttachmentDistributionDataInput>;
};

export type MutationCreateConversationChannelArgs = {
  data?: InputMaybe<ConversationChannelDataInput>;
};

export type MutationCreateConversationChannelTypeArgs = {
  data?: InputMaybe<ConversationChannelTypeDataInput>;
};

export type MutationCreateConversationCounterArgs = {
  data?: InputMaybe<ConversationCounterDataInput>;
};

export type MutationCreateConversationEmailArgs = {
  data?: InputMaybe<ConversationEmailDataInput>;
};

export type MutationCreateConversationEmailDispatchArgs = {
  data?: InputMaybe<ConversationEmailDispatchDataInput>;
};

export type MutationCreateConversationMessageArgs = {
  data?: InputMaybe<ConversationMessageDataInput>;
};

export type MutationCreateConversationMessageAssigneeGroupMentionArgs = {
  data?: InputMaybe<ConversationMessageAssigneeGroupMentionDataInput>;
};

export type MutationCreateConversationMessageDispatchArgs = {
  data?: InputMaybe<ConversationMessageDispatchDataInput>;
};

export type MutationCreateConversationMessageDraftArgs = {
  data?: InputMaybe<ConversationMessageDraftDataInput>;
};

export type MutationCreateConversationMessageReactionArgs = {
  data?: InputMaybe<ConversationMessageReactionDataInput>;
};

export type MutationCreateConversationMessageThreadArgs = {
  data?: InputMaybe<ConversationMessageThreadDataInput>;
};

export type MutationCreateConversationMessageUserMentionArgs = {
  data?: InputMaybe<ConversationMessageUserMentionDataInput>;
};

export type MutationCreateConversationParticipantArgs = {
  data?: InputMaybe<ConversationParticipantDataInput>;
};

export type MutationCreateConversationParticipationArgs = {
  data?: InputMaybe<ConversationParticipationDataInput>;
};

export type MutationCreateConversationSeenStateArgs = {
  data?: InputMaybe<ConversationSeenStateDataInput>;
};

export type MutationCreateConversationSmsArgs = {
  data?: InputMaybe<ConversationSmsDataInput>;
};

export type MutationCreateConversationSmsDispatchArgs = {
  data?: InputMaybe<ConversationSmsDispatchDataInput>;
};

export type MutationCreateConversationSmsSessionArgs = {
  data?: InputMaybe<ConversationSmsSessionDataInput>;
};

export type MutationCreateConversationSmsSessionRecipientArgs = {
  data?: InputMaybe<ConversationSmsSessionRecipientDataInput>;
};

export type MutationCreateConversationStatusArgs = {
  data?: InputMaybe<ConversationStatusDataInput>;
};

export type MutationCreateConversationSummaryArgs = {
  data?: InputMaybe<ConversationSummaryDataInput>;
};

export type MutationCreateConversationToAddressArgs = {
  data?: InputMaybe<ConversationToAddressDataInput>;
};

export type MutationCreateConversationToAssigneeArgs = {
  data?: InputMaybe<ConversationToAssigneeDataInput>;
};

export type MutationCreateConversationToCallTranscriptionArgs = {
  data?: InputMaybe<ConversationToCallTranscriptionDataInput>;
};

export type MutationCreateConversationTriageArgs = {
  data?: InputMaybe<ConversationTriageDataInput>;
};

export type MutationCreateConversationTriageRunArgs = {
  data?: InputMaybe<ConversationTriageRunDataInput>;
};

export type MutationCreateConversationTriageRunActionArgs = {
  data?: InputMaybe<ConversationTriageRunActionDataInput>;
};

export type MutationCreateConversationTriageRunStepArgs = {
  data?: InputMaybe<ConversationTriageRunStepDataInput>;
};

export type MutationCreateConversationUrgencyArgs = {
  data?: InputMaybe<ConversationUrgencyDataInput>;
};

export type MutationCreateCustomAttributeDefinitionArgs = {
  data?: InputMaybe<CustomAttributeDefinitionDataInput>;
};

export type MutationCreateCustomViewArgs = {
  data?: InputMaybe<CustomViewDataInput>;
};

export type MutationCreateCustomViewAccessArgs = {
  data?: InputMaybe<CustomViewAccessDataInput>;
};

export type MutationCreateDraftWorkflowVersionArgs = {
  input: CreateDraftWorkflowVersionInput;
};

export type MutationCreateEmailCampaignArgs = {
  data?: InputMaybe<EmailCampaignDataInput>;
};

export type MutationCreateInitialMembershipsConfigArgs = {
  input: CreateInitialMembershipsConfigInput;
};

export type MutationCreateIntegrationDriverArgs = {
  data?: InputMaybe<IntegrationDriverDataInput>;
};

export type MutationCreateLabelArgs = {
  data?: InputMaybe<LabelDataInput>;
};

export type MutationCreateLabelAssignmentArgs = {
  data?: InputMaybe<LabelAssignmentDataInput>;
};

export type MutationCreateLabelAssociationArgs = {
  data?: InputMaybe<LabelAssociationDataInput>;
};

export type MutationCreateLabelGroupArgs = {
  data?: InputMaybe<LabelGroupDataInput>;
};

export type MutationCreateLandingPageConfigArgs = {
  data?: InputMaybe<LandingPageConfigDataInput>;
};

export type MutationCreateLegalDocumentArgs = {
  data?: InputMaybe<LegalDocumentDataInput>;
};

export type MutationCreateMacroArgs = {
  data?: InputMaybe<MacroDataInput>;
};

export type MutationCreateMacroToConversationAssigneeGroupArgs = {
  data?: InputMaybe<MacroToConversationAssigneeGroupDataInput>;
};

export type MutationCreateMacroToUserGroupArgs = {
  data?: InputMaybe<MacroToUserGroupDataInput>;
};

export type MutationCreateMembershipArgs = {
  data?: InputMaybe<MembershipDataInput>;
};

export type MutationCreateMembershipFeatureArgs = {
  data?: InputMaybe<MembershipFeatureDataInput>;
};

export type MutationCreateNotificationArgs = {
  data?: InputMaybe<NotificationDataInput>;
};

export type MutationCreateNotificationChannelArgs = {
  data?: InputMaybe<NotificationChannelDataInput>;
};

export type MutationCreateNotificationEventArgs = {
  data?: InputMaybe<NotificationEventDataInput>;
};

export type MutationCreateNotificationEventToRoleArgs = {
  data?: InputMaybe<NotificationEventToRoleDataInput>;
};

export type MutationCreateNotificationPreferenceArgs = {
  data?: InputMaybe<NotificationPreferenceDataInput>;
};

export type MutationCreateNotificationRoleArgs = {
  data?: InputMaybe<NotificationRoleDataInput>;
};

export type MutationCreateOncallManagementScheduleArgs = {
  data?: InputMaybe<OncallManagementScheduleDataInput>;
};

export type MutationCreateOvAnnouncementsSlackAppArgs = {
  data?: InputMaybe<OvAnnouncementsSlackAppDataInput>;
};

export type MutationCreateParticipantWithRelatedDataArgs = {
  params: CreateParticipantWithRelatedDataInput;
};

export type MutationCreatePartnerArgs = {
  data?: InputMaybe<PartnerDataInput>;
};

export type MutationCreatePartnerBusinessHoursArgs = {
  data?: InputMaybe<PartnerBusinessHoursDataInput>;
};

export type MutationCreatePartnerCustomDomainArgs = {
  data?: InputMaybe<PartnerCustomDomainDataInput>;
};

export type MutationCreatePartnerDomainArgs = {
  data?: InputMaybe<PartnerDomainDataInput>;
};

export type MutationCreatePartnerGroupArgs = {
  data?: InputMaybe<PartnerGroupDataInput>;
};

export type MutationCreatePartnerGroupRuleArgs = {
  data?: InputMaybe<PartnerGroupRuleDataInput>;
};

export type MutationCreatePartnerGroupRuleValueArgs = {
  data?: InputMaybe<PartnerGroupRuleValueDataInput>;
};

export type MutationCreatePartnerHolidayArgs = {
  data?: InputMaybe<PartnerHolidayDataInput>;
};

export type MutationCreatePartnerNotificationRoleArgs = {
  data?: InputMaybe<PartnerNotificationRoleDataInput>;
};

export type MutationCreatePartnerOnesheetArgs = {
  data?: InputMaybe<PartnerOnesheetDataInput>;
};

export type MutationCreatePartnerProductArgs = {
  data?: InputMaybe<PartnerProductDataInput>;
};

export type MutationCreatePartnerProductPriceArgs = {
  data?: InputMaybe<PartnerProductPriceDataInput>;
};

export type MutationCreatePartnerSettingArgs = {
  data?: InputMaybe<PartnerSettingDataInput>;
};

export type MutationCreatePartnerSettingValueArgs = {
  data?: InputMaybe<PartnerSettingValueDataInput>;
};

export type MutationCreatePartnerToPartnerGroupArgs = {
  data?: InputMaybe<PartnerToPartnerGroupDataInput>;
};

export type MutationCreatePartnerWithRelatedDataArgs = {
  params: CreatePartnerWithRelatedDataInput;
};

export type MutationCreatePhoneCallArgs = {
  data?: InputMaybe<PhoneCallDataInput>;
};

export type MutationCreatePhoneCallFileArgs = {
  data?: InputMaybe<PhoneCallFileDataInput>;
};

export type MutationCreatePhoneCallParticipationArgs = {
  data?: InputMaybe<PhoneCallParticipationDataInput>;
};

export type MutationCreatePhoneCallToConversationArgs = {
  data?: InputMaybe<PhoneCallToConversationDataInput>;
};

export type MutationCreatePlatformEntityArgs = {
  data?: InputMaybe<PlatformEntityDataInput>;
};

export type MutationCreatePlatformSlaArgs = {
  data?: InputMaybe<PlatformSlaDataInput>;
};

export type MutationCreatePlatformUserArgs = {
  data?: InputMaybe<PlatformUserDataInput>;
};

export type MutationCreatePreSoldMembershipArgs = {
  data?: InputMaybe<PreSoldMembershipDataInput>;
};

export type MutationCreateProjectArgs = {
  data?: InputMaybe<ProjectDataInput>;
};

export type MutationCreateProjectLostReasonArgs = {
  data?: InputMaybe<ProjectLostReasonDataInput>;
};

export type MutationCreateProjectStageArgs = {
  data?: InputMaybe<ProjectStageDataInput>;
};

export type MutationCreateProjectWithSideEffectsArgs = {
  params: CreateProjectWithSideEffectsInput;
};

export type MutationCreatePublicApiKeyArgs = {
  params: CreatePublicApiKeyInput;
};

export type MutationCreatePublicApiUsagePlanArgs = {
  params: CreatePublicApiUsagePlanInput;
};

export type MutationCreatePushNotificationSubscriptionArgs = {
  data?: InputMaybe<PushNotificationSubscriptionDataInput>;
};

export type MutationCreateRecordFolderArgs = {
  data?: InputMaybe<RecordFolderDataInput>;
};

export type MutationCreateRecordFolderAssignmentArgs = {
  data?: InputMaybe<RecordFolderAssignmentDataInput>;
};

export type MutationCreateRsmEmailArgs = {
  data?: InputMaybe<RsmEmailDataInput>;
};

export type MutationCreateSearchableTextArgs = {
  data?: InputMaybe<SearchableTextDataInput>;
};

export type MutationCreateSearchableTextMetaArgs = {
  data?: InputMaybe<SearchableTextMetaDataInput>;
};

export type MutationCreateSearchableTextReferenceArgs = {
  data?: InputMaybe<SearchableTextReferenceDataInput>;
};

export type MutationCreateSidekickAiAgentConversationArgs = {
  data?: InputMaybe<SidekickAiAgentConversationDataInput>;
};

export type MutationCreateSidekickConfigurationArgs = {
  data?: InputMaybe<SidekickConfigurationDataInput>;
};

export type MutationCreateSidekickRunArgs = {
  data?: InputMaybe<SidekickRunDataInput>;
};

export type MutationCreateSidekickRunMessageArgs = {
  data?: InputMaybe<SidekickRunMessageDataInput>;
};

export type MutationCreateSignalBusinessHoursArgs = {
  data?: InputMaybe<SignalBusinessHoursDataInput>;
};

export type MutationCreateSignalIncidentArgs = {
  data?: InputMaybe<SignalIncidentDataInput>;
};

export type MutationCreateSignalIncidentSlackMessageArgs = {
  data?: InputMaybe<SignalIncidentSlackMessageDataInput>;
};

export type MutationCreateStoredFileArgs = {
  data?: InputMaybe<StoredFileDataInput>;
};

export type MutationCreateSubscriptionScheduleArgs = {
  params: CreateSubscriptionScheduleInput;
};

export type MutationCreateSupportPolicyArgs = {
  data?: InputMaybe<SupportPolicyDataInput>;
};

export type MutationCreateSupportPolicyToUserGroupArgs = {
  data?: InputMaybe<SupportPolicyToUserGroupDataInput>;
};

export type MutationCreateSupportPolicyWithGroupsArgs = {
  data: CreateSupportPolicyWithGroupsInput;
};

export type MutationCreateUserArgs = {
  params: PlatformUserDataInput;
};

export type MutationCreateUserCommunicationPreferenceArgs = {
  data?: InputMaybe<UserCommunicationPreferenceDataInput>;
};

export type MutationCreateUserGroupArgs = {
  data?: InputMaybe<UserGroupDataInput>;
};

export type MutationCreateUserGroupRuleArgs = {
  data?: InputMaybe<UserGroupRuleDataInput>;
};

export type MutationCreateUserGroupRuleValueArgs = {
  data?: InputMaybe<UserGroupRuleValueDataInput>;
};

export type MutationCreateUserGroupSettingValueArgs = {
  data?: InputMaybe<UserGroupSettingValueDataInput>;
};

export type MutationCreateUserNotificationRoleArgs = {
  data?: InputMaybe<UserNotificationRoleDataInput>;
};

export type MutationCreateUserSettingArgs = {
  data?: InputMaybe<UserSettingDataInput>;
};

export type MutationCreateUserSettingValueArgs = {
  data?: InputMaybe<UserSettingValueDataInput>;
};

export type MutationCreateUserToUserGroupArgs = {
  data?: InputMaybe<UserToUserGroupDataInput>;
};

export type MutationCreateWorkflowArgs = {
  data?: InputMaybe<WorkflowDataInput>;
};

export type MutationCreateWorkflowAssignmentArgs = {
  data?: InputMaybe<WorkflowAssignmentDataInput>;
};

export type MutationCreateWorkflowExecutionArgs = {
  data?: InputMaybe<WorkflowExecutionDataInput>;
};

export type MutationCreateWorkflowExecutionLogArgs = {
  data?: InputMaybe<WorkflowExecutionLogDataInput>;
};

export type MutationCreateWorkflowVersionArgs = {
  data?: InputMaybe<WorkflowVersionDataInput>;
};

export type MutationCreateWorkflowWithFirstVersionArgs = {
  input: CreateWorkflowWithFirstVersionInput;
};

export type MutationDeactivatePushNotificationSubscriptionArgs = {
  endpoint: Scalars['String']['input'];
};

export type MutationDeleteActivationFlowConfigArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteActivationFlowConfigToPriceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteActiveMembershipFeatureArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteActivityArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteActivityReferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteActivityTextTemplateArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAddressArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAddressFileArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAddressSubscriptionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAddressSummaryArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAddressWithRelatedDataArgs = {
  params: DeleteAddressWithRelatedDataInput;
};

export type MutationDeleteAiAgentConversationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAiAgentModelCallArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAiAgentRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAiAgentToolCallArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAiHelpLogArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAiPromptArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteAiPromptToUserGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteArsPayoutRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteArsRunReportArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteArsTransferArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteBehaviorArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteBehaviorSequenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteBlockedEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteBlockedPhoneNumberArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteBrandArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteBrandGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteBrandWithRelatedDataArgs = {
  params: DeleteBrandWithRelatedDataInput;
};

export type MutationDeleteCallTranscriptionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteCallTranscriptionSegmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteCallTranscriptionToPlatformUserArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteClientArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteClientEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteClientEmailLabelsArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteClientPhoneLabelsArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteClientPhoneNumberArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteClientToAddressArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteClientWithRelatedDataArgs = {
  params: DeleteClientWithRelatedDataInput;
};

export type MutationDeleteConversationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationAssigneeGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationAssigneeToGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationAttachmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationAttachmentDistributionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationChannelArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationChannelTypeArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationCounterArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationEmailDispatchArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationMessageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationMessageAssigneeGroupMentionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationMessageDispatchArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationMessageDraftArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationMessageReactionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationMessageThreadArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationMessageUserMentionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationParticipantArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationParticipationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationSeenStateArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationSmsArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationSmsDispatchArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationSmsSessionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationSmsSessionRecipientArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationStatusArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationSummaryArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationToAddressArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationToAssigneeArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationToCallTranscriptionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationTriageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationTriageRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationTriageRunActionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationTriageRunStepArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationUrgencyArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteConversationWithRelatedDataArgs = {
  params: DeleteConversationWithRelatedDataInput;
};

export type MutationDeleteCustomAttributeDefinitionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteCustomViewArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteCustomViewAccessArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteEmailCampaignArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteIntegrationDriverArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteLabelArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteLabelAssignmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteLabelAssociationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteLabelGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteLabelToClientToAddressArgs = {
  condition?: InputMaybe<DeleteLabelToClientToAddressInput>;
};

export type MutationDeleteLabelWithRelatedDataArgs = {
  params: DeleteLabelWithRelatedDataInput;
};

export type MutationDeleteLandingPageConfigArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteLegalDocumentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteLegalDocumentVersionArgs = {
  input: DeleteLegalDocumentVersionInput;
};

export type MutationDeleteMacroArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteMacroToConversationAssigneeGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteMacroToUserGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteMacroWithRelatedDataArgs = {
  params: DeleteMacroWithRelatedDataInput;
};

export type MutationDeleteMembershipArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteMembershipFeatureArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteNotificationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteNotificationChannelArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteNotificationEventArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteNotificationEventToRoleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteNotificationPreferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteNotificationRoleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteOncallManagementScheduleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteOvAnnouncementsSlackAppArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerBusinessHoursArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerCustomDomainArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerDomainArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerGroupRuleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerGroupRuleValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerHolidayArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerNotificationRoleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerOnesheetArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerProductArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerProductPriceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerSettingArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerSettingValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePartnerToPartnerGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePhoneCallArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePhoneCallFileArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePhoneCallParticipationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePhoneCallToConversationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePlatformEntityArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePlatformSlaArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePlatformUserArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeletePreSoldMembershipArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteProjectArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteProjectLostReasonArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteProjectStageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteProjectWithRelatedDataArgs = {
  params: DeleteProjectWithRelatedDataInput;
};

export type MutationDeletePublicApiKeyArgs = {
  params: DeletePublicApiKeyInput;
};

export type MutationDeletePushNotificationSubscriptionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteRecordFolderArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteRecordFolderAssignmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteRecordFolderWithAssignmentsArgs = {
  params: DeleteRecordFolderWithAssignmentsDataInput;
};

export type MutationDeleteRsmEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSearchableTextArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSearchableTextMetaArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSearchableTextReferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSidekickAiAgentConversationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSidekickConfigurationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSidekickRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSidekickRunMessageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSignalBusinessHoursArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSignalIncidentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSignalIncidentSlackMessageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteStoredFileArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSupportPolicyArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteSupportPolicyToUserGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserCommunicationPreferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserGroupRuleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserGroupRuleValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserGroupSettingValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserNotificationRoleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserSettingArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserSettingValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteUserToUserGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteWorkflowArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteWorkflowAssignmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteWorkflowExecutionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteWorkflowExecutionLogArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDeleteWorkflowVersionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type MutationDisableBehaviorArgs = {
  params: DisableBehaviorInput;
};

export type MutationDisableMacroArgs = {
  params: DisableMacroInput;
};

export type MutationDtoolsAuthenticateArgs = {
  params: DtoolsAuthenticateInput;
};

export type MutationDtoolsRevokeAuthenticationArgs = {
  params: DtoolsRevokeAuthenticationInput;
};

export type MutationEnableBehaviorArgs = {
  params: EnableBehaviorInput;
};

export type MutationEnableMacroArgs = {
  params: EnableMacroInput;
};

export type MutationEndSmsSessionArgs = {
  input: EndSmsSessionInput;
};

export type MutationExportPartnerArgs = {
  params: ExportPartnerInput;
};

export type MutationGenerateAfMagicLoginUrlArgs = {
  params: GenerateAfMagicLoginUrlInput;
};

export type MutationGenerateAddressSummaryArgs = {
  input: GenerateAddressSummaryInput;
};

export type MutationGenerateCustomMembershipCheckoutUrlArgs = {
  input: GenerateCustomMembershipCheckoutUrlInput;
};

export type MutationGenerateLandingPageLinkArgs = {
  params: GenerateLandingPageLinkInput;
};

export type MutationGenerateStripeBillingPortalUrlArgs = {
  params: PortalGenerateStripeBillingPortalUrlInput;
};

export type MutationHardDeleteConversationAttachmentArgs = {
  params: HardDeleteConversationAttachmentInput;
};

export type MutationImportPortalioProjectArgs = {
  params: ImportPortalioProjectInput;
};

export type MutationInitImportPartnerArgs = {
  params: ImportPartnerInput;
};

export type MutationManageNotificationPreferencesArgs = {
  params: ManageNotificationPreferencesInput;
};

export type MutationManageUserCommunicationPreferencesArgs = {
  params: ManageUserCommunicationPreferencesDataInput;
};

export type MutationManageUserConversationAssigneeGroupsArgs = {
  params: ManageUserConversationAssigneeGroupsDataInput;
};

export type MutationManageUserPermissionsArgs = {
  params: ManageUserPermissionsDataInput;
};

export type MutationMergeAddressArgs = {
  params: MergeAddressInput;
};

export type MutationMergeClientArgs = {
  params: MergeClientInput;
};

export type MutationMergeConversationArgs = {
  params: MergeConversationInput;
};

export type MutationMoveAttachmentToSiteFilesArgs = {
  params: MoveAttachmentToSiteFilesInput;
};

export type MutationPauseSubscriptionArgs = {
  params: PauseSubscriptionInput;
};

export type MutationPortalioAuthenticateArgs = {
  params: PortalioAuthenticateInput;
};

export type MutationPortalioRevokeAuthenticationArgs = {
  params: PortalioRevokeAuthenticationInput;
};

export type MutationPostMemberServicesFollowUpArgs = {
  params: PostMemberServicesFollowUpInput;
};

export type MutationPrepareSidekickAiAgentRequestArgs = {
  input: PrepareSidekickAiAgentRequestInput;
};

export type MutationRemoveCgCustomDomainArgs = {
  input: CgCustomDomainInput;
};

export type MutationRemoveConversationMessageReactionArgs = {
  params: ConversationMessageReactionInput;
};

export type MutationResolveConversationMessageThreadArgs = {
  params: ResolveConversationMessageThreadInput;
};

export type MutationResolveCustomMembershipPriceArgs = {
  input: ResolveCustomMembershipPriceInput;
};

export type MutationResolveSignalIncidentArgs = {
  input: ResolveSignalIncidentInput;
};

export type MutationResolveTriageActionArgs = {
  input: ResolveTriageActionInput;
};

export type MutationRestoreDeletedAddressArgs = {
  params: RestoreDeletedAddressInput;
};

export type MutationRestoreDeletedClientArgs = {
  params: RestoreDeletedClientInput;
};

export type MutationRestoreDeletedConversationArgs = {
  params: RestoreDeletedConversationInput;
};

export type MutationRestoreDeletedProjectArgs = {
  params: RestoreDeletedProjectInput;
};

export type MutationResumeArsPayoutRunArgs = {
  params: ArsPayoutRunIdInput;
};

export type MutationRotatePublicApiKeyArgs = {
  params: RotatePublicApiKeyInput;
};

export type MutationSaveActivationFlowConfigBundleArgs = {
  input: SaveActivationFlowConfigBundleInput;
};

export type MutationSaveClientWithRelatedDataArgs = {
  params?: InputMaybe<SaveClientWithRelatedDataInput>;
};

export type MutationSaveConversationForTwilioPhoneCallRecordingArgs = {
  input: SaveConversationForTwilioPhoneCallRecordingInput;
};

export type MutationSaveDraftWorkflowVersionDefinitionArgs = {
  input: SaveDraftWorkflowVersionDefinitionInput;
};

export type MutationSaveLandingPageConfigArgs = {
  input: SaveLandingPageConfigInput;
};

export type MutationSaveLegalDocumentArgs = {
  input: SaveLegalDocumentInput;
};

export type MutationSaveTwilioConversationContentArgs = {
  input: SaveTwilioConversationContentInput;
};

export type MutationSendMembershipEmailArgs = {
  params: SendMembershipEmailInput;
};

export type MutationSetCgCustomDomainSegmentsArgs = {
  input: SetCgCustomDomainSegmentsInput;
};

export type MutationSetDefaultConversationTriageArgs = {
  input: SetDefaultConversationTriageInput;
};

export type MutationSetUserPasswordArgs = {
  params: SetUserPasswordDataInput;
};

export type MutationSetWorkflowAssignmentArgs = {
  input: SetWorkflowAssignmentInput;
};

export type MutationSnoozeConversationArgs = {
  params: SnoozeConversationInput;
};

export type MutationSoftDeleteConversationTriageArgs = {
  input: SoftDeleteConversationTriageInput;
};

export type MutationSoftDeleteWorkflowArgs = {
  input: SoftDeleteWorkflowInput;
};

export type MutationSoftDeleteWorkflowVersionArgs = {
  input: SoftDeleteWorkflowVersionInput;
};

export type MutationStartArsPayoutRunArgs = {
  params: StartArsPayoutRunInput;
};

export type MutationStartConversationTriageArgs = {
  params: StartConversationTriageInput;
};

export type MutationStartDtoolsProjectImportJobArgs = {
  params: StartDtoolsProjectImportJobInput;
};

export type MutationStartSidekickRunArgs = {
  params: StartSidekickRunInput;
};

export type MutationStartSmsSessionArgs = {
  input: StartSmsSessionInput;
};

export type MutationSubmitConversationDataArgs = {
  params?: InputMaybe<SubmitConversationDataInput>;
};

export type MutationSubmitDay1Args = {
  params: SubmitDay1Input;
};

export type MutationSubmitProposalLostArgs = {
  params: SubmitProposalLostInput;
};

export type MutationSubmitProposalWonArgs = {
  params: SubmitProposalWonInput;
};

export type MutationSyncEmailBrandingCacheArgs = {
  params: SyncEmailBrandingCacheInput;
};

export type MutationSyncPartnerSlaArgs = {
  params: SyncPartnerSlaInput;
};

export type MutationTriggerIterableSyncArgs = {
  params: TriggerIterableSyncInput;
};

export type MutationTriggerPartnerInvoiceGenerationArgs = {
  params: TriggerPartnerInvoiceGenerationInput;
};

export type MutationUndoBulkUpdateEntitiesArgs = {
  input: UndoBulkUpdateEntitiesInput;
};

export type MutationUnpauseSubscriptionArgs = {
  params: UnpauseSubscriptionInput;
};

export type MutationUnresolveConversationMessageThreadArgs = {
  params: UnresolveConversationMessageThreadInput;
};

export type MutationUpdateActivationFlowConfigArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ActivationFlowConfigDataInput>;
};

export type MutationUpdateActivationFlowConfigToPriceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ActivationFlowConfigToPriceDataInput>;
};

export type MutationUpdateActiveMembershipFeatureArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ActiveMembershipFeatureDataInput>;
};

export type MutationUpdateActivityArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ActivityDataInput>;
};

export type MutationUpdateActivityReferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ActivityReferenceDataInput>;
};

export type MutationUpdateActivityTextTemplateArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ActivityTextTemplateDataInput>;
};

export type MutationUpdateAddressArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AddressDataInput>;
};

export type MutationUpdateAddressFileArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AddressFileDataInput>;
};

export type MutationUpdateAddressSubscriptionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AddressSubscriptionDataInput>;
};

export type MutationUpdateAddressSummaryArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AddressSummaryDataInput>;
};

export type MutationUpdateAiAgentConversationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AiAgentConversationDataInput>;
};

export type MutationUpdateAiAgentModelCallArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AiAgentModelCallDataInput>;
};

export type MutationUpdateAiAgentRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AiAgentRunDataInput>;
};

export type MutationUpdateAiAgentToolCallArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AiAgentToolCallDataInput>;
};

export type MutationUpdateAiHelpLogArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AiHelpLogDataInput>;
};

export type MutationUpdateAiPromptArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<AiPromptDataInput>;
};

export type MutationUpdateArsPayoutRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ArsPayoutRunDataInput>;
};

export type MutationUpdateArsRunReportArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ArsRunReportDataInput>;
};

export type MutationUpdateArsTransferArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ArsTransferDataInput>;
};

export type MutationUpdateBehaviorArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<BehaviorDataInput>;
};

export type MutationUpdateBehaviorSequenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<BehaviorSequenceDataInput>;
};

export type MutationUpdateBehaviorSortingArgs = {
  params: UpdateBehaviorSortingParams;
};

export type MutationUpdateBlockedEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<BlockedEmailDataInput>;
};

export type MutationUpdateBlockedPhoneNumberArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<BlockedPhoneNumberDataInput>;
};

export type MutationUpdateBrandArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<BrandDataInput>;
};

export type MutationUpdateBrandGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<BrandGroupDataInput>;
};

export type MutationUpdateCallTranscriptionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<CallTranscriptionDataInput>;
};

export type MutationUpdateCallTranscriptionSegmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<CallTranscriptionSegmentDataInput>;
};

export type MutationUpdateClientArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ClientDataInput>;
};

export type MutationUpdateClientEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ClientEmailDataInput>;
};

export type MutationUpdateClientEmailLabelsArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ClientEmailLabelsDataInput>;
};

export type MutationUpdateClientPhoneLabelsArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ClientPhoneLabelsDataInput>;
};

export type MutationUpdateClientPhoneNumberArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ClientPhoneNumberDataInput>;
};

export type MutationUpdateConversationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationDataInput>;
};

export type MutationUpdateConversationAsSeenArgs = {
  input: UpdateConversationAsSeenInput;
};

export type MutationUpdateConversationAssigneeGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationAssigneeGroupDataInput>;
};

export type MutationUpdateConversationAttachmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationAttachmentDataInput>;
};

export type MutationUpdateConversationAttachmentDistributionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationAttachmentDistributionDataInput>;
};

export type MutationUpdateConversationChannelArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationChannelDataInput>;
};

export type MutationUpdateConversationChannelTypeArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationChannelTypeDataInput>;
};

export type MutationUpdateConversationCounterArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationCounterDataInput>;
};

export type MutationUpdateConversationEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationEmailDataInput>;
};

export type MutationUpdateConversationEmailDispatchArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationEmailDispatchDataInput>;
};

export type MutationUpdateConversationMessageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationMessageDataInput>;
};

export type MutationUpdateConversationMessageDispatchArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationMessageDispatchDataInput>;
};

export type MutationUpdateConversationMessageDraftArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationMessageDraftDataInput>;
};

export type MutationUpdateConversationMessageReactionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationMessageReactionDataInput>;
};

export type MutationUpdateConversationMessageThreadArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationMessageThreadDataInput>;
};

export type MutationUpdateConversationParticipantArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationParticipantDataInput>;
};

export type MutationUpdateConversationParticipationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationParticipationDataInput>;
};

export type MutationUpdateConversationPrivateMessageArgs = {
  params: UpdateConversationPrivateMessageInput;
};

export type MutationUpdateConversationSeenStateArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationSeenStateDataInput>;
};

export type MutationUpdateConversationSmsArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationSmsDataInput>;
};

export type MutationUpdateConversationSmsDispatchArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationSmsDispatchDataInput>;
};

export type MutationUpdateConversationSmsSessionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationSmsSessionDataInput>;
};

export type MutationUpdateConversationSmsSessionRecipientArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationSmsSessionRecipientDataInput>;
};

export type MutationUpdateConversationStatusArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationStatusDataInput>;
};

export type MutationUpdateConversationSummaryArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationSummaryDataInput>;
};

export type MutationUpdateConversationTriageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationTriageDataInput>;
};

export type MutationUpdateConversationTriageRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationTriageRunDataInput>;
};

export type MutationUpdateConversationTriageRunActionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationTriageRunActionDataInput>;
};

export type MutationUpdateConversationTriageRunStepArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationTriageRunStepDataInput>;
};

export type MutationUpdateConversationUrgencyArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ConversationUrgencyDataInput>;
};

export type MutationUpdateCustomAttributeDefinitionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<CustomAttributeDefinitionDataInput>;
};

export type MutationUpdateCustomViewArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<CustomViewDataInput>;
};

export type MutationUpdateCustomViewAccessArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<CustomViewAccessDataInput>;
};

export type MutationUpdateEmailCampaignArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<EmailCampaignDataInput>;
};

export type MutationUpdateEntityViewerArgs = {
  params: UpdateEntityViewerInput;
};

export type MutationUpdateIntegrationDriverArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<IntegrationDriverDataInput>;
};

export type MutationUpdateLabelArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<LabelDataInput>;
};

export type MutationUpdateLabelAssignmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<LabelAssignmentDataInput>;
};

export type MutationUpdateLabelAssociationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<LabelAssociationDataInput>;
};

export type MutationUpdateLabelGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<LabelGroupDataInput>;
};

export type MutationUpdateLandingPageConfigArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<LandingPageConfigDataInput>;
};

export type MutationUpdateLegalDocumentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<LegalDocumentDataInput>;
};

export type MutationUpdateMacroArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<MacroDataInput>;
};

export type MutationUpdateMembershipArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<MembershipDataInput>;
};

export type MutationUpdateMembershipFeatureArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<MembershipFeatureDataInput>;
};

export type MutationUpdateNotificationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<NotificationDataInput>;
};

export type MutationUpdateNotificationChannelArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<NotificationChannelDataInput>;
};

export type MutationUpdateNotificationEventArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<NotificationEventDataInput>;
};

export type MutationUpdateNotificationPreferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<NotificationPreferenceDataInput>;
};

export type MutationUpdateNotificationRoleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<NotificationRoleDataInput>;
};

export type MutationUpdateOncallManagementScheduleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<OncallManagementScheduleDataInput>;
};

export type MutationUpdateOvAnnouncementsSlackAppArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<OvAnnouncementsSlackAppDataInput>;
};

export type MutationUpdatePartnerArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerDataInput>;
};

export type MutationUpdatePartnerBusinessHoursArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerBusinessHoursDataInput>;
};

export type MutationUpdatePartnerCustomDomainArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerCustomDomainDataInput>;
};

export type MutationUpdatePartnerDomainArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerDomainDataInput>;
};

export type MutationUpdatePartnerGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerGroupDataInput>;
};

export type MutationUpdatePartnerGroupRuleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerGroupRuleDataInput>;
};

export type MutationUpdatePartnerGroupRuleValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerGroupRuleValueDataInput>;
};

export type MutationUpdatePartnerHolidayArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerHolidayDataInput>;
};

export type MutationUpdatePartnerNotificationRoleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerNotificationRoleDataInput>;
};

export type MutationUpdatePartnerOnesheetArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerOnesheetDataInput>;
};

export type MutationUpdatePartnerProductArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerProductDataInput>;
};

export type MutationUpdatePartnerProductPriceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerProductPriceDataInput>;
};

export type MutationUpdatePartnerSettingArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerSettingDataInput>;
};

export type MutationUpdatePartnerSettingValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PartnerSettingValueDataInput>;
};

export type MutationUpdatePhoneCallArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PhoneCallDataInput>;
};

export type MutationUpdatePhoneCallFileArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PhoneCallFileDataInput>;
};

export type MutationUpdatePhoneCallParticipationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PhoneCallParticipationDataInput>;
};

export type MutationUpdatePlatformEntityArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PlatformEntityDataInput>;
};

export type MutationUpdatePlatformSlaArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PlatformSlaDataInput>;
};

export type MutationUpdatePlatformUserArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PlatformUserDataInput>;
};

export type MutationUpdatePreSoldMembershipArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PreSoldMembershipDataInput>;
};

export type MutationUpdateProjectArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ProjectDataInput>;
};

export type MutationUpdateProjectLostReasonArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ProjectLostReasonDataInput>;
};

export type MutationUpdateProjectStageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<ProjectStageDataInput>;
};

export type MutationUpdatePublicApiKeyArgs = {
  params: UpdatePublicApiKeyInput;
};

export type MutationUpdatePushNotificationSubscriptionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<PushNotificationSubscriptionDataInput>;
};

export type MutationUpdateRecordFolderArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<RecordFolderDataInput>;
};

export type MutationUpdateRecordFolderAssignmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<RecordFolderAssignmentDataInput>;
};

export type MutationUpdateRsmEmailArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<RsmEmailDataInput>;
};

export type MutationUpdateSearchableTextArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SearchableTextDataInput>;
};

export type MutationUpdateSearchableTextMetaArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SearchableTextMetaDataInput>;
};

export type MutationUpdateSearchableTextReferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SearchableTextReferenceDataInput>;
};

export type MutationUpdateSidekickAiAgentConversationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SidekickAiAgentConversationDataInput>;
};

export type MutationUpdateSidekickConfigurationArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SidekickConfigurationDataInput>;
};

export type MutationUpdateSidekickRunArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SidekickRunDataInput>;
};

export type MutationUpdateSidekickRunMessageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SidekickRunMessageDataInput>;
};

export type MutationUpdateSignalBusinessHoursArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SignalBusinessHoursDataInput>;
};

export type MutationUpdateSignalIncidentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SignalIncidentDataInput>;
};

export type MutationUpdateSignalIncidentSlackMessageArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SignalIncidentSlackMessageDataInput>;
};

export type MutationUpdateStoredFileArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<StoredFileDataInput>;
};

export type MutationUpdateSupportPolicyArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SupportPolicyDataInput>;
};

export type MutationUpdateSupportPolicyToUserGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<SupportPolicyToUserGroupDataInput>;
};

export type MutationUpdateSupportPolicyWithGroupsArgs = {
  data: UpdateSupportPolicyWithGroupsInput;
};

export type MutationUpdateUserActiveStateArgs = {
  params: UpdateUserActiveStateDataInput;
};

export type MutationUpdateUserCommunicationPreferenceArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserCommunicationPreferenceDataInput>;
};

export type MutationUpdateUserGroupArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserGroupDataInput>;
};

export type MutationUpdateUserGroupRuleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserGroupRuleDataInput>;
};

export type MutationUpdateUserGroupRuleValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserGroupRuleValueDataInput>;
};

export type MutationUpdateUserGroupSettingValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserGroupSettingValueDataInput>;
};

export type MutationUpdateUserNotificationRoleArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserNotificationRoleDataInput>;
};

export type MutationUpdateUserPresenceArgs = {
  params: UpdateUserPresenceInput;
};

export type MutationUpdateUserSettingArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserSettingDataInput>;
};

export type MutationUpdateUserSettingValueArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<UserSettingValueDataInput>;
};

export type MutationUpdateWorkflowArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<WorkflowDataInput>;
};

export type MutationUpdateWorkflowAssignmentArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<WorkflowAssignmentDataInput>;
};

export type MutationUpdateWorkflowExecutionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<WorkflowExecutionDataInput>;
};

export type MutationUpdateWorkflowExecutionLogArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<WorkflowExecutionLogDataInput>;
};

export type MutationUpdateWorkflowVersionArgs = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  data?: InputMaybe<WorkflowVersionDataInput>;
};

export type MutationUpsertConversationMessageDraftArgs = {
  params: UpsertConversationMessageDraftInput;
};

export type MutationUpsertPushNotificationSubscriptionArgs = {
  input: PushNotificationSubscriptionInput;
};

export type NewConversationMessageIds = {
  __typename?: 'NewConversationMessageIds';
  conversationId: Scalars['String']['output'];
  conversationMessageId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  channel?: Maybe<NotificationChannel>;
  clientFlowInitiator?: Maybe<Client>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  entity?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  flowInitiatorEntity?: Maybe<Scalars['String']['output']>;
  flowInitiatorEntityId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  notificationChannelId: Scalars['String']['output'];
  notificationEvent?: Maybe<NotificationEvent>;
  notificationEventId: Scalars['String']['output'];
  notificationId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  platformEntity?: Maybe<PlatformEntity>;
  platformUser?: Maybe<PlatformUser>;
  platformUserFlowInitiator?: Maybe<PlatformUser>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type NotificationDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notificationChannelId: Scalars['String']['output'];
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
};

export type NotificationChannelDataInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationChannelId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationChannelDataResponse = {
  __typename?: 'NotificationChannelDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationChannel>>>;
};

export type NotificationChannelSearchResponse = {
  __typename?: 'NotificationChannelSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationChannel>>>;
};

export type NotificationDataInput = {
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  flowInitiatorEntity?: InputMaybe<Scalars['String']['input']>;
  flowInitiatorEntityId?: InputMaybe<Scalars['String']['input']>;
  notificationChannelId?: InputMaybe<Scalars['String']['input']>;
  notificationEventId?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationDataResponse = {
  __typename?: 'NotificationDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Notification>>>;
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  defaultRoles?: Maybe<Array<Maybe<NotificationRole>>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notificationEventId: Scalars['String']['output'];
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  roles?: Maybe<Array<Maybe<NotificationRole>>>;
};

export type NotificationEventDataInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationEventId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationEventDataResponse = {
  __typename?: 'NotificationEventDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationEvent>>>;
};

export type NotificationEventSearchResponse = {
  __typename?: 'NotificationEventSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationEvent>>>;
};

export type NotificationEventToRole = {
  __typename?: 'NotificationEventToRole';
  isDefault: Scalars['Boolean']['output'];
  notificationEventId: Scalars['String']['output'];
  notificationRoleId: Scalars['String']['output'];
};

export type NotificationEventToRoleDataInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEventId?: InputMaybe<Scalars['String']['input']>;
  notificationRoleId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  channel?: Maybe<NotificationChannel>;
  config?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  notificationChannelId: Scalars['String']['output'];
  notificationEvent?: Maybe<NotificationEvent>;
  notificationEventId: Scalars['String']['output'];
  notificationPreferenceId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerNotificationRole?: Maybe<Array<Maybe<PartnerNotificationRole>>>;
  platformUser?: Maybe<PlatformUser>;
  updatedAt: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  userNotificationRole?: Maybe<Array<Maybe<UserNotificationRole>>>;
};

export type NotificationPreferenceDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationPreferenceDataInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notificationChannelId?: InputMaybe<Scalars['String']['input']>;
  notificationEventId?: InputMaybe<Scalars['String']['input']>;
  notificationPreferenceId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationPreferenceDataResponse = {
  __typename?: 'NotificationPreferenceDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationPreference>>>;
};

export type NotificationPreferenceSearchResponse = {
  __typename?: 'NotificationPreferenceSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationPreference>>>;
};

export type NotificationRole = {
  __typename?: 'NotificationRole';
  category: Scalars['String']['output'];
  conversationAssigneeGroup?: Maybe<ConversationAssigneeGroup>;
  conversationAssigneeGroupId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  name: Scalars['String']['output'];
  notificationRoleId: Scalars['String']['output'];
  partnerNotificationRoles?: Maybe<Array<Maybe<PartnerNotificationRole>>>;
  userNotificationRoles?: Maybe<Array<Maybe<UserNotificationRole>>>;
};

export type NotificationRoleDataInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  conversationAssigneeGroupId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationRoleId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationRoleDataResponse = {
  __typename?: 'NotificationRoleDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationRole>>>;
};

export type NotificationRoleSearchResponse = {
  __typename?: 'NotificationRoleSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<NotificationRole>>>;
};

export type NotificationSearchResponse = {
  __typename?: 'NotificationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Notification>>>;
};

export type OncallManagementSchedule = {
  __typename?: 'OncallManagementSchedule';
  conditions?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  endTime: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  oncallManagementScheduleId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  primaryAgent?: Maybe<PlatformUser>;
  primaryAgentId: Scalars['String']['output'];
  recurrence: Scalars['String']['output'];
  recurrenceInterval?: Maybe<Scalars['String']['output']>;
  recurrenceUntil?: Maybe<Scalars['String']['output']>;
  secondaryAgent?: Maybe<PlatformUser>;
  secondaryAgentId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  updateSequence: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type OncallManagementScheduleDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OncallManagementScheduleDataInput = {
  conditions?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  oncallManagementScheduleId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  primaryAgentId?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Scalars['String']['input']>;
  recurrenceInterval?: InputMaybe<Scalars['String']['input']>;
  recurrenceUntil?: InputMaybe<Scalars['String']['input']>;
  secondaryAgentId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  updateSequence?: InputMaybe<Scalars['Int']['input']>;
};

export type OncallManagementScheduleDataResponse = {
  __typename?: 'OncallManagementScheduleDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<OncallManagementSchedule>>>;
};

export type OncallManagementScheduleSearchResponse = {
  __typename?: 'OncallManagementScheduleSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<OncallManagementSchedule>>>;
};

export type OvAnnouncementsSlackApp = {
  __typename?: 'OvAnnouncementsSlackApp';
  id?: Maybe<Scalars['Int']['output']>;
  ovAnnouncementsSlackAppId: Scalars['Int']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type OvAnnouncementsSlackAppDataInput = {
  ovAnnouncementsSlackAppId?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type OvAnnouncementsSlackAppDataResponse = {
  __typename?: 'OvAnnouncementsSlackAppDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<OvAnnouncementsSlackApp>>>;
};

export type OvAnnouncementsSlackAppSearchResponse = {
  __typename?: 'OvAnnouncementsSlackAppSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<OvAnnouncementsSlackApp>>>;
};

export type Partner = {
  __typename?: 'Partner';
  activationFlowConfigs?: Maybe<Array<Maybe<ActivationFlowConfig>>>;
  activeMembershipFeatures?: Maybe<Array<Maybe<ActiveMembershipFeature>>>;
  activityRecords?: Maybe<Array<Maybe<Activity>>>;
  activityReferences?: Maybe<Array<Maybe<ActivityReference>>>;
  address?: Maybe<Scalars['String']['output']>;
  addressFiles?: Maybe<Array<Maybe<AddressFile>>>;
  addressSubscriptions?: Maybe<Array<Maybe<AddressSubscription>>>;
  addressSummaryRecordsViaPartnerIdPartnerId?: Maybe<Array<Maybe<AddressSummary>>>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  aiAgentConversations?: Maybe<Array<Maybe<AiAgentConversation>>>;
  aiAgentModelCalls?: Maybe<Array<Maybe<AiAgentModelCall>>>;
  aiAgentRuns?: Maybe<Array<Maybe<AiAgentRun>>>;
  aiAgentToolCalls?: Maybe<Array<Maybe<AiAgentToolCall>>>;
  aiHelpLogs?: Maybe<Array<Maybe<AiHelpLog>>>;
  aiPrompts?: Maybe<Array<Maybe<AiPrompt>>>;
  announcementsSlackApps?: Maybe<Array<Maybe<OvAnnouncementsSlackApp>>>;
  annual?: Maybe<Scalars['Boolean']['output']>;
  arsPayoutRuns?: Maybe<Array<Maybe<ArsPayoutRun>>>;
  arsRunReportRecordsViaPartnerIdPartnerId?: Maybe<Array<Maybe<ArsRunReport>>>;
  arsTransferRecordsViaPartnerIdPartnerId?: Maybe<Array<Maybe<ArsTransfer>>>;
  behaviorSequences?: Maybe<Array<Maybe<BehaviorSequence>>>;
  behaviors?: Maybe<Array<Maybe<Behavior>>>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingEmail2?: Maybe<Scalars['String']['output']>;
  blockedEmails?: Maybe<Array<Maybe<BlockedEmail>>>;
  blockedPhoneNumbers?: Maybe<Array<Maybe<BlockedPhoneNumber>>>;
  brandGroups?: Maybe<Array<Maybe<BrandGroup>>>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  businessName?: Maybe<Scalars['String']['output']>;
  buyNow?: Maybe<Scalars['String']['output']>;
  callTranscriptionSegments?: Maybe<Array<Maybe<CallTranscriptionSegment>>>;
  callTranscriptions?: Maybe<Array<Maybe<CallTranscription>>>;
  city?: Maybe<Scalars['String']['output']>;
  clientEmails?: Maybe<Array<Maybe<ClientEmail>>>;
  clientPhoneNumbers?: Maybe<Array<Maybe<ClientPhoneNumber>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  commercial?: Maybe<Scalars['String']['output']>;
  contractSignedDate?: Maybe<Scalars['String']['output']>;
  conversationAssigneeGroups?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
  conversationAttachmentDistributions?: Maybe<
    Array<Maybe<ConversationAttachmentDistribution>>
  >;
  conversationAttachments?: Maybe<Array<Maybe<ConversationAttachment>>>;
  conversationChannels?: Maybe<Array<Maybe<ConversationChannel>>>;
  conversationCounterRecordsViaPartnerIdPartnerId?: Maybe<Array<Maybe<ConversationCounter>>>;
  conversationEmailDispatches?: Maybe<Array<Maybe<ConversationEmailDispatch>>>;
  conversationEmails?: Maybe<Array<Maybe<ConversationEmail>>>;
  conversationMessageDispatches?: Maybe<Array<Maybe<ConversationMessageDispatch>>>;
  conversationMessageReactions?: Maybe<Array<Maybe<ConversationMessageReaction>>>;
  conversationMessageThreads?: Maybe<Array<Maybe<ConversationMessageThread>>>;
  conversationMessages?: Maybe<Array<Maybe<ConversationMessage>>>;
  conversationParticipants?: Maybe<Array<Maybe<ConversationParticipation>>>;
  conversationSmsDispatches?: Maybe<Array<Maybe<ConversationSmsDispatch>>>;
  conversationSmsRecords?: Maybe<Array<Maybe<ConversationSms>>>;
  conversationSmsSessionRecipients?: Maybe<Array<Maybe<ConversationSmsSessionRecipient>>>;
  conversationSmsSessions?: Maybe<Array<Maybe<ConversationSmsSession>>>;
  conversationSummaryRecordsViaPartnerIdPartnerId?: Maybe<Array<Maybe<ConversationSummary>>>;
  conversationTriageRuns?: Maybe<Array<Maybe<ConversationTriageRun>>>;
  conversationTriages?: Maybe<Array<Maybe<ConversationTriage>>>;
  conversationUrgencies?: Maybe<Array<Maybe<ConversationUrgency>>>;
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  createdAt: Scalars['String']['output'];
  currentMembershipStructure?: Maybe<Scalars['String']['output']>;
  currentPartner?: Maybe<Scalars['String']['output']>;
  customAttributeDefinitions?: Maybe<Array<Maybe<CustomAttributeDefinition>>>;
  customAttributes?: Maybe<Scalars['String']['output']>;
  customDomains?: Maybe<Array<Maybe<PartnerCustomDomain>>>;
  customViewAccesses?: Maybe<Array<Maybe<CustomViewAccess>>>;
  customViews?: Maybe<Array<Maybe<CustomView>>>;
  dangerZone?: Maybe<Scalars['String']['output']>;
  directorOfService?: Maybe<Scalars['String']['output']>;
  docsendUrl?: Maybe<Scalars['String']['output']>;
  dosCalendly?: Maybe<Scalars['String']['output']>;
  drafts?: Maybe<Array<Maybe<ConversationMessageDraft>>>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  emailCampaigns?: Maybe<Array<Maybe<EmailCampaign>>>;
  externalConversationParticipants?: Maybe<Array<Maybe<ConversationParticipant>>>;
  globalNotificationEmail?: Maybe<Scalars['String']['output']>;
  guruUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  integrationDriver?: Maybe<Array<Maybe<IntegrationDriver>>>;
  iterableTestUserId?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  labelAssociations?: Maybe<Array<Maybe<LabelAssociation>>>;
  labelGroups?: Maybe<Array<Maybe<LabelGroup>>>;
  labels?: Maybe<Array<Maybe<Label>>>;
  landingPageConfigs?: Maybe<Array<Maybe<LandingPageConfig>>>;
  legalDocuments?: Maybe<Array<Maybe<LegalDocument>>>;
  litsDate?: Maybe<Scalars['String']['output']>;
  macros?: Maybe<Array<Maybe<Macro>>>;
  marketingLaunchDate?: Maybe<Scalars['String']['output']>;
  membershipEmail?: Maybe<Scalars['String']['output']>;
  membershipFeatures?: Maybe<Array<Maybe<MembershipFeature>>>;
  membershipSalesCalendlyLink?: Maybe<Scalars['String']['output']>;
  membershipUrlComNew?: Maybe<Scalars['String']['output']>;
  membershipUrlNew?: Maybe<Scalars['String']['output']>;
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notionBoardUrl?: Maybe<Scalars['String']['output']>;
  onBehalfOf?: Maybe<Scalars['Boolean']['output']>;
  oncallManagementSchedules?: Maybe<Array<Maybe<OncallManagementSchedule>>>;
  ownerId?: Maybe<Scalars['String']['output']>;
  partnerBusinessHours?: Maybe<Array<Maybe<PartnerBusinessHours>>>;
  partnerDomains?: Maybe<Array<Maybe<PartnerDomain>>>;
  partnerGroups?: Maybe<Array<Maybe<PartnerGroup>>>;
  partnerHolidays?: Maybe<Array<Maybe<PartnerHoliday>>>;
  partnerId: Scalars['Int']['output'];
  partnerNotificationRoles?: Maybe<Array<Maybe<PartnerNotificationRole>>>;
  partnerOnesheet?: Maybe<Array<Maybe<PartnerOnesheet>>>;
  partnerProductPrices?: Maybe<Array<Maybe<PartnerProductPrice>>>;
  partnerProducts?: Maybe<Array<Maybe<PartnerProduct>>>;
  partnerSettingValues?: Maybe<Array<Maybe<PartnerSettingValue>>>;
  phoneCallFiles?: Maybe<Array<Maybe<PhoneCallFile>>>;
  phoneCallParticipations?: Maybe<Array<Maybe<PhoneCallParticipation>>>;
  phoneCalls?: Maybe<Array<Maybe<PhoneCall>>>;
  platformUser?: Maybe<PlatformUser>;
  platformUsers?: Maybe<Array<Maybe<PlatformUser>>>;
  preSoldMemberships?: Maybe<Array<Maybe<PreSoldMembership>>>;
  projects?: Maybe<Array<Maybe<Project>>>;
  pushNotificationSubscriptions?: Maybe<Array<Maybe<PushNotificationSubscription>>>;
  recordFolderAssignments?: Maybe<Array<Maybe<RecordFolderAssignment>>>;
  recordFolders?: Maybe<Array<Maybe<RecordFolder>>>;
  revenueShare?: Maybe<Scalars['Float']['output']>;
  rsmEmails?: Maybe<Array<Maybe<RsmEmail>>>;
  seenState?: Maybe<Array<Maybe<ConversationSeenState>>>;
  sidekickAiAgentConversations?: Maybe<Array<Maybe<SidekickAiAgentConversation>>>;
  sidekickConfigurations?: Maybe<Array<Maybe<SidekickConfiguration>>>;
  sidekickRunMessages?: Maybe<Array<Maybe<SidekickRunMessage>>>;
  sidekickRuns?: Maybe<Array<Maybe<SidekickRun>>>;
  signalBusinessHours?: Maybe<Array<Maybe<SignalBusinessHours>>>;
  signalIncidentSlackMessages?: Maybe<Array<Maybe<SignalIncidentSlackMessage>>>;
  signalIncidents?: Maybe<Array<Maybe<SignalIncident>>>;
  signatureEmail?: Maybe<Scalars['String']['output']>;
  signaturePhone?: Maybe<Scalars['String']['output']>;
  slackTeamLink?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  storedFiles?: Maybe<Array<Maybe<StoredFile>>>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportLiveDate?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  supportPolicies?: Maybe<Array<Maybe<SupportPolicy>>>;
  supportPolicyToUserGroupRecordsViaPartnerIdPartnerId?: Maybe<
    Array<Maybe<SupportPolicyToUserGroup>>
  >;
  timeZone?: Maybe<Scalars['String']['output']>;
  tos?: Maybe<Scalars['String']['output']>;
  twilioScreenPopActive?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['String']['output'];
  userCommunicationPreferences?: Maybe<Array<Maybe<UserCommunicationPreference>>>;
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  userNotificationRoles?: Maybe<Array<Maybe<UserNotificationRole>>>;
  userSettingValues?: Maybe<Array<Maybe<UserSettingValue>>>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  workflowAssignments?: Maybe<Array<Maybe<WorkflowAssignment>>>;
  workflowExecutionLogs?: Maybe<Array<Maybe<WorkflowExecutionLog>>>;
  workflowExecutions?: Maybe<Array<Maybe<WorkflowExecution>>>;
  workflowVersions?: Maybe<Array<Maybe<WorkflowVersion>>>;
  workflows?: Maybe<Array<Maybe<Workflow>>>;
  zendeskDomain?: Maybe<Scalars['String']['output']>;
  zendeskUrl?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PartnerDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerBusinessHours = {
  __typename?: 'PartnerBusinessHours';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerBusinessHoursId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  timeFrom: Scalars['String']['output'];
  timeTo: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  weekDay?: Maybe<Scalars['Int']['output']>;
};

export type PartnerBusinessHoursDataInput = {
  partnerBusinessHoursId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  timeFrom?: InputMaybe<Scalars['String']['input']>;
  timeTo?: InputMaybe<Scalars['String']['input']>;
  weekDay?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerBusinessHoursDataResponse = {
  __typename?: 'PartnerBusinessHoursDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerBusinessHours>>>;
};

export type PartnerBusinessHoursSearchResponse = {
  __typename?: 'PartnerBusinessHoursSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerBusinessHours>>>;
};

export type PartnerCustomDomain = {
  __typename?: 'PartnerCustomDomain';
  acmCertificateArn?: Maybe<Scalars['String']['output']>;
  activatedAt?: Maybe<Scalars['String']['output']>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  cloudfrontTenantId?: Maybe<Scalars['String']['output']>;
  cnameTarget: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  hostname: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  lastCheckResult?: Maybe<Scalars['String']['output']>;
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerCustomDomainId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  validationMode: Scalars['String']['output'];
  validationRecordName?: Maybe<Scalars['String']['output']>;
  validationRecordValue?: Maybe<Scalars['String']['output']>;
};

export type PartnerCustomDomainDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerCustomDomainDataInput = {
  acmCertificateArn?: InputMaybe<Scalars['String']['input']>;
  activatedAt?: InputMaybe<Scalars['String']['input']>;
  cloudfrontTenantId?: InputMaybe<Scalars['String']['input']>;
  cnameTarget?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  lastCheckResult?: InputMaybe<Scalars['String']['input']>;
  lastCheckedAt?: InputMaybe<Scalars['String']['input']>;
  partnerCustomDomainId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  validationMode?: InputMaybe<Scalars['String']['input']>;
  validationRecordName?: InputMaybe<Scalars['String']['input']>;
  validationRecordValue?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerCustomDomainDataResponse = {
  __typename?: 'PartnerCustomDomainDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerCustomDomain>>>;
};

export type PartnerCustomDomainSearchResponse = {
  __typename?: 'PartnerCustomDomainSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerCustomDomain>>>;
};

export type PartnerDataInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  annual?: InputMaybe<Scalars['Boolean']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEmail2?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  buyNow?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  commercial?: InputMaybe<Scalars['String']['input']>;
  contractSignedDate?: InputMaybe<Scalars['String']['input']>;
  currentMembershipStructure?: InputMaybe<Scalars['String']['input']>;
  currentPartner?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Scalars['String']['input']>;
  dangerZone?: InputMaybe<Scalars['String']['input']>;
  directorOfService?: InputMaybe<Scalars['String']['input']>;
  docsendUrl?: InputMaybe<Scalars['String']['input']>;
  dosCalendly?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  globalNotificationEmail?: InputMaybe<Scalars['String']['input']>;
  guruUrl?: InputMaybe<Scalars['String']['input']>;
  iterableTestUserId?: InputMaybe<Scalars['String']['input']>;
  litsDate?: InputMaybe<Scalars['String']['input']>;
  marketingLaunchDate?: InputMaybe<Scalars['String']['input']>;
  membershipEmail?: InputMaybe<Scalars['String']['input']>;
  membershipSalesCalendlyLink?: InputMaybe<Scalars['String']['input']>;
  membershipUrlComNew?: InputMaybe<Scalars['String']['input']>;
  membershipUrlNew?: InputMaybe<Scalars['String']['input']>;
  notionBoardUrl?: InputMaybe<Scalars['String']['input']>;
  onBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  revenueShare?: InputMaybe<Scalars['Float']['input']>;
  signatureEmail?: InputMaybe<Scalars['String']['input']>;
  signaturePhone?: InputMaybe<Scalars['String']['input']>;
  slackTeamLink?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportLiveDate?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  tos?: InputMaybe<Scalars['String']['input']>;
  twilioScreenPopActive?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  zendeskDomain?: InputMaybe<Scalars['String']['input']>;
  zendeskUrl?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerDataResponse = {
  __typename?: 'PartnerDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Partner>>>;
};

export type PartnerDomain = {
  __typename?: 'PartnerDomain';
  createdAt: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerDomainId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PartnerDomainDataInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  partnerDomainId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerDomainDataResponse = {
  __typename?: 'PartnerDomainDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerDomain>>>;
};

export type PartnerDomainSearchResponse = {
  __typename?: 'PartnerDomainSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerDomain>>>;
};

export type PartnerGroup = {
  __typename?: 'PartnerGroup';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Array<Maybe<Partner>>>;
  partnerGroupId: Scalars['String']['output'];
  ruleValues?: Maybe<Array<Maybe<PartnerGroupRuleValue>>>;
  updatedAt: Scalars['String']['output'];
};

export type PartnerGroupDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerGroupDataResponse = {
  __typename?: 'PartnerGroupDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerGroup>>>;
};

export type PartnerGroupRule = {
  __typename?: 'PartnerGroupRule';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerGroupRuleId: Scalars['String']['output'];
  partnerGroupRuleValues?: Maybe<Array<Maybe<PartnerGroupRuleValue>>>;
  updatedAt: Scalars['String']['output'];
};

export type PartnerGroupRuleDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerGroupRuleId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerGroupRuleDataResponse = {
  __typename?: 'PartnerGroupRuleDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerGroupRule>>>;
};

export type PartnerGroupRuleSearchResponse = {
  __typename?: 'PartnerGroupRuleSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerGroupRule>>>;
};

export type PartnerGroupRuleValue = {
  __typename?: 'PartnerGroupRuleValue';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partnerGroup?: Maybe<PartnerGroup>;
  partnerGroupId: Scalars['String']['output'];
  partnerGroupRule?: Maybe<PartnerGroupRule>;
  partnerGroupRuleId: Scalars['String']['output'];
  partnerGroupRuleValueId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type PartnerGroupRuleValueDataInput = {
  partnerGroupId?: InputMaybe<Scalars['String']['input']>;
  partnerGroupRuleId?: InputMaybe<Scalars['String']['input']>;
  partnerGroupRuleValueId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerGroupRuleValueDataResponse = {
  __typename?: 'PartnerGroupRuleValueDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerGroupRuleValue>>>;
};

export type PartnerGroupRuleValueSearchResponse = {
  __typename?: 'PartnerGroupRuleValueSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerGroupRuleValue>>>;
};

export type PartnerGroupSearchResponse = {
  __typename?: 'PartnerGroupSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerGroup>>>;
};

export type PartnerHoliday = {
  __typename?: 'PartnerHoliday';
  createdAt: Scalars['String']['output'];
  holidayEnd: Scalars['String']['output'];
  holidayName?: Maybe<Scalars['String']['output']>;
  holidayStart: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerHolidayId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  submitterId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type PartnerHolidayDataInput = {
  holidayEnd?: InputMaybe<Scalars['String']['input']>;
  holidayName?: InputMaybe<Scalars['String']['input']>;
  holidayStart?: InputMaybe<Scalars['String']['input']>;
  partnerHolidayId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  submitterId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerHolidayDataResponse = {
  __typename?: 'PartnerHolidayDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerHoliday>>>;
};

export type PartnerHolidaySearchResponse = {
  __typename?: 'PartnerHolidaySearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerHoliday>>>;
};

export type PartnerInvoice = {
  __typename?: 'PartnerInvoice';
  created: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type PartnerNotificationRole = {
  __typename?: 'PartnerNotificationRole';
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  notificationPreference?: Maybe<NotificationPreference>;
  notificationPreferenceId?: Maybe<Scalars['String']['output']>;
  notificationRole?: Maybe<NotificationRole>;
  notificationRoleId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerNotificationRoleId: Scalars['String']['output'];
};

export type PartnerNotificationRoleDataInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notificationPreferenceId?: InputMaybe<Scalars['String']['input']>;
  notificationRoleId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerNotificationRoleId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerNotificationRoleDataResponse = {
  __typename?: 'PartnerNotificationRoleDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerNotificationRole>>>;
};

export type PartnerNotificationRoleSearchResponse = {
  __typename?: 'PartnerNotificationRoleSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerNotificationRole>>>;
};

export type PartnerOnesheet = {
  __typename?: 'PartnerOnesheet';
  additionalNotesAboutYourCompanyAsItRelatesToSupport?: Maybe<Scalars['String']['output']>;
  alarmsecurityMonitoringInformation?: Maybe<Scalars['String']['output']>;
  asTransferForBusinessHoursOnly?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  doYouHaveAShowroom?: Maybe<Scalars['String']['output']>;
  doYouHaveProjectsWhereYouOnlyInstallASecuritySystem?: Maybe<Scalars['String']['output']>;
  doYouOfferEquipmentRepair?: Maybe<Scalars['String']['output']>;
  escalationPolicy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  internalSupportNotes?: Maybe<Scalars['String']['output']>;
  mainOfficePhone?: Maybe<Scalars['String']['output']>;
  officeAddress1?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  primaryAudioInterface?: Maybe<Scalars['String']['output']>;
  primaryControlSystemUsed?: Maybe<Scalars['String']['output']>;
  primaryDoorbellBrand?: Maybe<Scalars['String']['output']>;
  primaryIsp?: Maybe<Scalars['String']['output']>;
  primaryLightingSystemInstalled?: Maybe<Scalars['String']['output']>;
  primaryNetworkingEquipmentInstalled?: Maybe<Scalars['String']['output']>;
  primaryRsmTool?: Maybe<Scalars['String']['output']>;
  primaryStreamingDeviceInstalled?: Maybe<Scalars['String']['output']>;
  primaryThermostatBrand?: Maybe<Scalars['String']['output']>;
  primaryVideoSurveillanceBrand?: Maybe<Scalars['String']['output']>;
  recentAnnouncements?: Maybe<Scalars['String']['output']>;
  secondaryAudioInterface?: Maybe<Scalars['String']['output']>;
  secondaryControlSystemUsed?: Maybe<Scalars['String']['output']>;
  secondaryDoorbellBrand?: Maybe<Scalars['String']['output']>;
  secondaryIsp?: Maybe<Scalars['String']['output']>;
  secondaryLightingSystemInstalled?: Maybe<Scalars['String']['output']>;
  secondaryNetworkingEquipmentInstalled?: Maybe<Scalars['String']['output']>;
  secondaryRsmTool?: Maybe<Scalars['String']['output']>;
  secondaryStreamingDeviceInstalled?: Maybe<Scalars['String']['output']>;
  secondaryThermostatBrand?: Maybe<Scalars['String']['output']>;
  secondaryVideoSurveillanceBrand?: Maybe<Scalars['String']['output']>;
  showroomFriday?: Maybe<Scalars['String']['output']>;
  showroomMonday?: Maybe<Scalars['String']['output']>;
  showroomSaturday?: Maybe<Scalars['String']['output']>;
  showroomSunday?: Maybe<Scalars['String']['output']>;
  showroomThursday?: Maybe<Scalars['String']['output']>;
  showroomTuesday?: Maybe<Scalars['String']['output']>;
  showroomWednesday?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submitterEmail?: Maybe<Scalars['String']['output']>;
  travelCharges?: Maybe<Scalars['String']['output']>;
  whatIsYourEquipmentRepairPolicy?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PartnerOnesheetDataInput = {
  additionalNotesAboutYourCompanyAsItRelatesToSupport?: InputMaybe<Scalars['String']['input']>;
  alarmsecurityMonitoringInformation?: InputMaybe<Scalars['String']['input']>;
  asTransferForBusinessHoursOnly?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  doYouHaveAShowroom?: InputMaybe<Scalars['String']['input']>;
  doYouHaveProjectsWhereYouOnlyInstallASecuritySystem?: InputMaybe<Scalars['String']['input']>;
  doYouOfferEquipmentRepair?: InputMaybe<Scalars['String']['input']>;
  escalationPolicy?: InputMaybe<Scalars['String']['input']>;
  internalSupportNotes?: InputMaybe<Scalars['String']['input']>;
  mainOfficePhone?: InputMaybe<Scalars['String']['input']>;
  officeAddress1?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  primaryAudioInterface?: InputMaybe<Scalars['String']['input']>;
  primaryControlSystemUsed?: InputMaybe<Scalars['String']['input']>;
  primaryDoorbellBrand?: InputMaybe<Scalars['String']['input']>;
  primaryIsp?: InputMaybe<Scalars['String']['input']>;
  primaryLightingSystemInstalled?: InputMaybe<Scalars['String']['input']>;
  primaryNetworkingEquipmentInstalled?: InputMaybe<Scalars['String']['input']>;
  primaryRsmTool?: InputMaybe<Scalars['String']['input']>;
  primaryStreamingDeviceInstalled?: InputMaybe<Scalars['String']['input']>;
  primaryThermostatBrand?: InputMaybe<Scalars['String']['input']>;
  primaryVideoSurveillanceBrand?: InputMaybe<Scalars['String']['input']>;
  recentAnnouncements?: InputMaybe<Scalars['String']['input']>;
  secondaryAudioInterface?: InputMaybe<Scalars['String']['input']>;
  secondaryControlSystemUsed?: InputMaybe<Scalars['String']['input']>;
  secondaryDoorbellBrand?: InputMaybe<Scalars['String']['input']>;
  secondaryIsp?: InputMaybe<Scalars['String']['input']>;
  secondaryLightingSystemInstalled?: InputMaybe<Scalars['String']['input']>;
  secondaryNetworkingEquipmentInstalled?: InputMaybe<Scalars['String']['input']>;
  secondaryRsmTool?: InputMaybe<Scalars['String']['input']>;
  secondaryStreamingDeviceInstalled?: InputMaybe<Scalars['String']['input']>;
  secondaryThermostatBrand?: InputMaybe<Scalars['String']['input']>;
  secondaryVideoSurveillanceBrand?: InputMaybe<Scalars['String']['input']>;
  showroomFriday?: InputMaybe<Scalars['String']['input']>;
  showroomMonday?: InputMaybe<Scalars['String']['input']>;
  showroomSaturday?: InputMaybe<Scalars['String']['input']>;
  showroomSunday?: InputMaybe<Scalars['String']['input']>;
  showroomThursday?: InputMaybe<Scalars['String']['input']>;
  showroomTuesday?: InputMaybe<Scalars['String']['input']>;
  showroomWednesday?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  submitterEmail?: InputMaybe<Scalars['String']['input']>;
  travelCharges?: InputMaybe<Scalars['String']['input']>;
  whatIsYourEquipmentRepairPolicy?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerOnesheetDataResponse = {
  __typename?: 'PartnerOnesheetDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerOnesheet>>>;
};

export type PartnerOnesheetSearchResponse = {
  __typename?: 'PartnerOnesheetSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerOnesheet>>>;
};

export type PartnerProduct = {
  __typename?: 'PartnerProduct';
  activeMembershipFeatures?: Maybe<Array<Maybe<ActiveMembershipFeature>>>;
  addressSubscriptions?: Maybe<Array<Maybe<AddressSubscription>>>;
  callForPricing: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerProductId: Scalars['String']['output'];
  platformSla?: Maybe<PlatformSla>;
  platformSlaId?: Maybe<Scalars['String']['output']>;
  preSoldMemberships?: Maybe<Array<Maybe<PreSoldMembership>>>;
  prices?: Maybe<Array<Maybe<PartnerProductPrice>>>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PartnerProductDataInput = {
  callForPricing?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  platformSlaId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerProductDataResponse = {
  __typename?: 'PartnerProductDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerProduct>>>;
};

export type PartnerProductPrice = {
  __typename?: 'PartnerProductPrice';
  activationFlowConfigs?: Maybe<Array<Maybe<ActivationFlowConfigToPrice>>>;
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  intervalCount: Scalars['Int']['output'];
  intervalUnit: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerProduct?: Maybe<PartnerProduct>;
  partnerProductId: Scalars['String']['output'];
  partnerProductPriceId: Scalars['String']['output'];
  stripePriceId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PartnerProductPriceDataInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  intervalUnit?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  partnerProductPriceId?: InputMaybe<Scalars['String']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerProductPriceDataResponse = {
  __typename?: 'PartnerProductPriceDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerProductPrice>>>;
};

export type PartnerProductPriceSearchResponse = {
  __typename?: 'PartnerProductPriceSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerProductPrice>>>;
};

export type PartnerProductSearchResponse = {
  __typename?: 'PartnerProductSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerProduct>>>;
};

export type PartnerSearchResponse = {
  __typename?: 'PartnerSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Partner>>>;
};

export type PartnerSetting = {
  __typename?: 'PartnerSetting';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerSettingId: Scalars['String']['output'];
  partnerSettingValues?: Maybe<Array<Maybe<PartnerSettingValue>>>;
  updatedAt: Scalars['String']['output'];
  valueType?: Maybe<Scalars['String']['output']>;
};

export type PartnerSettingDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerSettingId?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerSettingDataResponse = {
  __typename?: 'PartnerSettingDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerSetting>>>;
};

export type PartnerSettingSearchResponse = {
  __typename?: 'PartnerSettingSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerSetting>>>;
};

export type PartnerSettingValue = {
  __typename?: 'PartnerSettingValue';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerSetting?: Maybe<PartnerSetting>;
  partnerSettingId: Scalars['String']['output'];
  partnerSettingValueId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PartnerSettingValueDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerSettingId?: InputMaybe<Scalars['String']['input']>;
  partnerSettingValueId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerSettingValueDataResponse = {
  __typename?: 'PartnerSettingValueDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerSettingValue>>>;
};

export type PartnerSettingValueSearchResponse = {
  __typename?: 'PartnerSettingValueSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PartnerSettingValue>>>;
};

export type PartnerToPartnerGroup = {
  __typename?: 'PartnerToPartnerGroup';
  createdAt: Scalars['String']['output'];
  partnerGroupId: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
};

export type PartnerToPartnerGroupDataInput = {
  partnerGroupId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type PauseSubscriptionInput = {
  addressId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  pauseUntil: Scalars['String']['input'];
};

export type PauseSubscriptionResponse = {
  __typename?: 'PauseSubscriptionResponse';
  success: Scalars['Boolean']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  bankName?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PhoneCall = {
  __typename?: 'PhoneCall';
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  externalCallId: Scalars['String']['output'];
  files?: Maybe<Array<Maybe<StoredFile>>>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  participations?: Maybe<Array<Maybe<PhoneCallParticipation>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  phoneCallFiles?: Maybe<Array<Maybe<PhoneCallFile>>>;
  phoneCallId: Scalars['String']['output'];
  toNumber?: Maybe<Scalars['String']['output']>;
  transcriptions?: Maybe<Array<Maybe<CallTranscription>>>;
  updatedAt: Scalars['String']['output'];
};

export type PhoneCallDataInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  externalCallId?: InputMaybe<Scalars['String']['input']>;
  fromNumber?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  phoneCallId?: InputMaybe<Scalars['String']['input']>;
  toNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneCallDataResponse = {
  __typename?: 'PhoneCallDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PhoneCall>>>;
};

export type PhoneCallFile = {
  __typename?: 'PhoneCallFile';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  phoneCall?: Maybe<PhoneCall>;
  phoneCallId: Scalars['String']['output'];
  storedFile?: Maybe<StoredFile>;
  storedFileId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PhoneCallFileDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  phoneCallId?: InputMaybe<Scalars['String']['input']>;
  storedFileId?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneCallFileDataResponse = {
  __typename?: 'PhoneCallFileDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PhoneCallFile>>>;
};

export type PhoneCallFileSearchResponse = {
  __typename?: 'PhoneCallFileSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PhoneCallFile>>>;
};

export type PhoneCallParticipation = {
  __typename?: 'PhoneCallParticipation';
  channel?: Maybe<ConversationChannel>;
  conversationChannelId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  phoneCall?: Maybe<PhoneCall>;
  phoneCallId: Scalars['String']['output'];
  phoneCallParticipationId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PhoneCallParticipationDataInput = {
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  phoneCallId?: InputMaybe<Scalars['String']['input']>;
  phoneCallParticipationId?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneCallParticipationDataResponse = {
  __typename?: 'PhoneCallParticipationDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PhoneCallParticipation>>>;
};

export type PhoneCallParticipationSearchResponse = {
  __typename?: 'PhoneCallParticipationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PhoneCallParticipation>>>;
};

export type PhoneCallSearchResponse = {
  __typename?: 'PhoneCallSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PhoneCall>>>;
};

export type PhoneCallToConversation = {
  __typename?: 'PhoneCallToConversation';
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  phoneCallId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PhoneCallToConversationDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  phoneCallId?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformEntity = {
  __typename?: 'PlatformEntity';
  createdAt: Scalars['String']['output'];
  customAttributeDefinitions?: Maybe<Array<Maybe<CustomAttributeDefinition>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  labelAssociations?: Maybe<Array<Maybe<LabelAssociation>>>;
  notificationFlowInitiators?: Maybe<Array<Maybe<Notification>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  recordFolderAssignments?: Maybe<Array<Maybe<RecordFolderAssignment>>>;
};

export type PlatformEntityDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformEntityDataResponse = {
  __typename?: 'PlatformEntityDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PlatformEntity>>>;
};

export type PlatformEntitySearchResponse = {
  __typename?: 'PlatformEntitySearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PlatformEntity>>>;
};

export type PlatformSla = {
  __typename?: 'PlatformSla';
  addresses?: Maybe<Array<Maybe<Address>>>;
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  partnerProductRecordsViaPlatformSlaIdPlatformSlaId?: Maybe<Array<Maybe<PartnerProduct>>>;
  platformSlaId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PlatformSlaDataInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  platformSlaId?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformSlaDataResponse = {
  __typename?: 'PlatformSlaDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PlatformSla>>>;
};

export type PlatformSlaSearchResponse = {
  __typename?: 'PlatformSlaSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PlatformSla>>>;
};

export type PlatformUser = {
  __typename?: 'PlatformUser';
  addressFiles?: Maybe<Array<Maybe<AddressFile>>>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  aiPrompts?: Maybe<Array<Maybe<AiPrompt>>>;
  avatarFileKey?: Maybe<Scalars['String']['output']>;
  blockedEmails?: Maybe<Array<Maybe<BlockedEmail>>>;
  blockedPhoneNumbers?: Maybe<Array<Maybe<BlockedPhoneNumber>>>;
  cognitoUsername?: Maybe<Scalars['String']['output']>;
  conversationAssigneeGroups?: Maybe<Array<Maybe<ConversationAssigneeGroup>>>;
  conversationMessageReactions?: Maybe<Array<Maybe<ConversationMessageReaction>>>;
  conversationParticipant?: Maybe<ConversationParticipant>;
  conversationTriageRunActions?: Maybe<Array<Maybe<ConversationTriageRunAction>>>;
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  createdArsPayoutRuns?: Maybe<Array<Maybe<ArsPayoutRun>>>;
  createdAt: Scalars['String']['output'];
  customViewAccesses?: Maybe<Array<Maybe<CustomViewAccess>>>;
  customViews?: Maybe<Array<Maybe<CustomView>>>;
  drafts?: Maybe<Array<Maybe<ConversationMessageDraft>>>;
  email: Scalars['String']['output'];
  emailCampaigns?: Maybe<Array<Maybe<EmailCampaign>>>;
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  lastName: Scalars['String']['output'];
  macros?: Maybe<Array<Maybe<Macro>>>;
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  notificationRoles?: Maybe<Array<Maybe<UserNotificationRole>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  oncallManagementSchedules?: Maybe<Array<Maybe<OncallManagementSchedule>>>;
  openedSmsSessions?: Maybe<Array<Maybe<ConversationSmsSession>>>;
  owner?: Maybe<Array<Maybe<Partner>>>;
  partner?: Maybe<Partner>;
  partnerHolidayRecords?: Maybe<Array<Maybe<PartnerHoliday>>>;
  partnerId: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Array<Maybe<Project>>>;
  pushNotificationSubscriptions?: Maybe<Array<Maybe<PushNotificationSubscription>>>;
  recordFolders?: Maybe<Array<Maybe<RecordFolder>>>;
  resolvedConversationMessageThreads?: Maybe<Array<Maybe<ConversationMessageThread>>>;
  resolvedSignalIncidents?: Maybe<Array<Maybe<SignalIncident>>>;
  seenState?: Maybe<Array<Maybe<ConversationSeenState>>>;
  sidekickAiAgentConversations?: Maybe<Array<Maybe<SidekickAiAgentConversation>>>;
  sidekickRuns?: Maybe<Array<Maybe<SidekickRun>>>;
  supportPolicies?: Maybe<Array<Maybe<SupportPolicy>>>;
  updatedAt: Scalars['String']['output'];
  userCommunicationPreferences?: Maybe<Array<Maybe<UserCommunicationPreference>>>;
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  userId: Scalars['String']['output'];
  userSettingValues?: Maybe<Array<Maybe<UserSettingValue>>>;
};

export type PlatformUserAvatarUploadInfo = {
  __typename?: 'PlatformUserAvatarUploadInfo';
  fileKey: Scalars['String']['output'];
  putURL: Scalars['String']['output'];
};

export type PlatformUserAvatarUploadInfoInput = {
  contentType: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type PlatformUserDataInput = {
  avatarFileKey?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUserDataResponse = {
  __typename?: 'PlatformUserDataResponse';
  metadata: MetaDataWithSearch;
  records?: Maybe<Array<Maybe<PlatformUser>>>;
};

export type PlatformUserSearchResponse = {
  __typename?: 'PlatformUserSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PlatformUser>>>;
};

export type PortalGenerateStripeBillingPortalUrlInput = {
  addressId: Scalars['String']['input'];
};

export type PortalGenerateStripeBillingPortalUrlResponse = {
  __typename?: 'PortalGenerateStripeBillingPortalUrlResponse';
  url: Scalars['String']['output'];
};

export type PortalioAuthDetails = {
  __typename?: 'PortalioAuthDetails';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  portalioUserName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type PortalioAuthResponse = {
  __typename?: 'PortalioAuthResponse';
  authDetails?: Maybe<PortalioAuthDetails>;
};

export type PortalioAuthenticateInput = {
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type PortalioProposalInfo = {
  __typename?: 'PortalioProposalInfo';
  createdDate: Scalars['String']['output'];
  customer?: Maybe<PortalioProposalInfoCustomer>;
  id: Scalars['Int']['output'];
  lastModifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  proposalNumber: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type PortalioProposalInfoCustomer = {
  __typename?: 'PortalioProposalInfoCustomer';
  companyName?: Maybe<Scalars['String']['output']>;
  contactCategory?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactEmailCC?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactType: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PortalioRevokeAuthenticationInput = {
  userId: Scalars['String']['input'];
};

export type PortalioRevokeAuthenticationResponse = {
  __typename?: 'PortalioRevokeAuthenticationResponse';
  userId: Scalars['String']['output'];
};

export type PostMemberServicesFollowUpInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  addressId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type PostMemberServicesFollowUpResponse = {
  __typename?: 'PostMemberServicesFollowUpResponse';
  success: Scalars['Boolean']['output'];
};

export type PreSoldMembership = {
  __typename?: 'PreSoldMembership';
  address?: Maybe<Address>;
  addressId: Scalars['String']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intervalCount: Scalars['Int']['output'];
  intervalUnit?: Maybe<Scalars['String']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  partnerProduct?: Maybe<PartnerProduct>;
  partnerProductId?: Maybe<Scalars['String']['output']>;
  preSoldMembershipId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type PreSoldMembershipDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  intervalUnit?: InputMaybe<Scalars['String']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  partnerProductId?: InputMaybe<Scalars['String']['input']>;
  preSoldMembershipId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type PreSoldMembershipDataResponse = {
  __typename?: 'PreSoldMembershipDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PreSoldMembership>>>;
};

export type PreSoldMembershipSearchResponse = {
  __typename?: 'PreSoldMembershipSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PreSoldMembership>>>;
};

export type PrepareSidekickAiAgentRequestInput = {
  idempotencyKey: Scalars['String']['input'];
  input: Array<SidekickAiAgentInputItem>;
  partnerId: Scalars['Int']['input'];
  sidekickAiAgentConversationId?: InputMaybe<Scalars['String']['input']>;
};

export type PrepareSidekickAiAgentRequestResponse = {
  __typename?: 'PrepareSidekickAiAgentRequestResponse';
  aiAgentConversationId: Scalars['String']['output'];
  request: AiAgentInvocationRequest;
  sidekickAiAgentConversationId: Scalars['String']['output'];
};

export type Project = {
  __typename?: 'Project';
  address?: Maybe<Address>;
  addressId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  customAttributes?: Maybe<Scalars['String']['output']>;
  day1StartDate?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  estimatedDay1Date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDay1DateFinalized?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  lostReasonNotes?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  price?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
  projectLostReason?: Maybe<ProjectLostReason>;
  projectLostReasonId?: Maybe<Scalars['Int']['output']>;
  projectStage?: Maybe<ProjectStage>;
  projectStageId?: Maybe<Scalars['Int']['output']>;
  signingDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  warrantyExpirationDate?: Maybe<Scalars['String']['output']>;
  warrantyLength?: Maybe<Scalars['Int']['output']>;
};

export type ProjectDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectDataInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Scalars['String']['input']>;
  day1StartDate?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  estimatedDay1Date?: InputMaybe<Scalars['String']['input']>;
  isDay1DateFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  lostReasonNotes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  projectLostReasonId?: InputMaybe<Scalars['Int']['input']>;
  projectStageId?: InputMaybe<Scalars['Int']['input']>;
  signingDate?: InputMaybe<Scalars['String']['input']>;
  warrantyExpirationDate?: InputMaybe<Scalars['String']['input']>;
  warrantyLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectDataResponse = {
  __typename?: 'ProjectDataResponse';
  metadata: MetaDataWithSearch;
  records?: Maybe<Array<Maybe<Project>>>;
};

export type ProjectLostReason = {
  __typename?: 'ProjectLostReason';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  projectLostReasonId: Scalars['Int']['output'];
  projects?: Maybe<Array<Maybe<Project>>>;
  updatedAt: Scalars['String']['output'];
};

export type ProjectLostReasonDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectLostReasonId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectLostReasonDataResponse = {
  __typename?: 'ProjectLostReasonDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ProjectLostReason>>>;
};

export type ProjectLostReasonSearchResponse = {
  __typename?: 'ProjectLostReasonSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ProjectLostReason>>>;
};

export type ProjectSearchResponse = {
  __typename?: 'ProjectSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Project>>>;
};

export type ProjectStage = {
  __typename?: 'ProjectStage';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  projectStageId: Scalars['Int']['output'];
  projects?: Maybe<Array<Maybe<Project>>>;
  updatedAt: Scalars['String']['output'];
};

export type ProjectStageDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectStageId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectStageDataResponse = {
  __typename?: 'ProjectStageDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ProjectStage>>>;
};

export type ProjectStageSearchResponse = {
  __typename?: 'ProjectStageSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<ProjectStage>>>;
};

export type PublicApiAllowedOperation = {
  __typename?: 'PublicApiAllowedOperation';
  operations: Array<Maybe<Scalars['String']['output']>>;
  resource: Scalars['String']['output'];
};

export type PublicApiAllowedOperationInput = {
  operations: Array<InputMaybe<Scalars['String']['input']>>;
  resource: Scalars['String']['input'];
};

export enum PublicApiKeyDisabledReason {
  Deleted = 'deleted',
  Rotated = 'rotated',
}

export type PublicApiKeyItem = {
  __typename?: 'PublicApiKeyItem';
  allowedOperations: Array<Maybe<PublicApiAllowedOperation>>;
  apiKey: Scalars['String']['output'];
  apiKeyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  disabledAt?: Maybe<Scalars['String']['output']>;
  disabledReason?: Maybe<PublicApiKeyDisabledReason>;
  id: Scalars['String']['output'];
  maskedApiKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  rotatedToApiKeyId?: Maybe<Scalars['String']['output']>;
  usagePlanId: Scalars['String']['output'];
};

export type PublicApiKeyRotatedResponse = {
  __typename?: 'PublicApiKeyRotatedResponse';
  id: Scalars['String']['output'];
  newApiKeyId: Scalars['String']['output'];
  newApiKeyValue: Scalars['String']['output'];
  oldApiKeyId: Scalars['String']['output'];
  usagePlanId: Scalars['String']['output'];
};

export type PublicApiPermissionItem = {
  __typename?: 'PublicApiPermissionItem';
  children: Array<Maybe<Scalars['String']['output']>>;
  operations: Array<Maybe<Scalars['String']['output']>>;
  parent?: Maybe<Scalars['String']['output']>;
  resource: Scalars['String']['output'];
};

export type PublicApiUsagePlanCreatedResponse = {
  __typename?: 'PublicApiUsagePlanCreatedResponse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  usagePlanId: Scalars['String']['output'];
};

export type PushNotificationCapability = {
  __typename?: 'PushNotificationCapability';
  subscriptions: Array<PushNotificationSubscription>;
  vapidPublicKey: Scalars['String']['output'];
};

export type PushNotificationSubscription = {
  __typename?: 'PushNotificationSubscription';
  authKey: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  expirationTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastFailedAt?: Maybe<Scalars['String']['output']>;
  p256dhKey: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  pushNotificationSubscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type PushNotificationSubscriptionDataInput = {
  authKey?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  expirationTime?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAt?: InputMaybe<Scalars['String']['input']>;
  p256dhKey?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  pushNotificationSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationSubscriptionDataResponse = {
  __typename?: 'PushNotificationSubscriptionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PushNotificationSubscription>>>;
};

export type PushNotificationSubscriptionInput = {
  authKey: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  expirationTime?: InputMaybe<Scalars['String']['input']>;
  p256dhKey: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationSubscriptionResponse = {
  __typename?: 'PushNotificationSubscriptionResponse';
  success: Scalars['Boolean']['output'];
};

export type PushNotificationSubscriptionSearchResponse = {
  __typename?: 'PushNotificationSubscriptionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<PushNotificationSubscription>>>;
};

export type Query = {
  __typename?: 'Query';
  bulkUpdateEntitiesProgress: BulkUpdateEntitiesProgressResponse;
  clientGatewayGetActivationFlowConfig?: Maybe<ClientGatewayGetActivationFlowConfigResponse>;
  clientGatewayGetAddress?: Maybe<AddressDataResponse>;
  clientGatewayGetBranding?: Maybe<ClientGatewayGetBrandingResponse>;
  clientGatewayGetClient?: Maybe<ClientDataResponse>;
  clientGatewayGetConversation?: Maybe<ConversationDataResponse>;
  clientGatewayGetConversationMessage?: Maybe<ConversationMessageDataResponse>;
  clientGatewayGetConversationParticipants?: Maybe<ClientGatewayConversationParticipants>;
  clientGatewayGetLandingPage?: Maybe<ClientGatewayGetLandingPageResponse>;
  clientGatewayGetLandingPageCheckoutConfirmation?: Maybe<GetStripeCheckoutConfirmationDataResponse>;
  clientGatewayGetLegalDocument?: Maybe<ClientGatewayLegalDocument>;
  clientGatewayGetPartner?: Maybe<PartnerDataResponse>;
  clientGatewayGetPartnerSettingValue?: Maybe<PartnerSettingValueDataResponse>;
  clientGatewayGetStripeCheckoutConfirmationData: GetStripeCheckoutConfirmationDataResponse;
  clientGatewayGetUploadFileInfo: UploadFileInfo;
  clientGatewayIsPartnerAvailable: Scalars['Boolean']['output'];
  clientGatewayResolveHost?: Maybe<ClientGatewayResolveHostResponse>;
  generateConversationSummary: ConversationSummary;
  getActivationFlowConfig?: Maybe<ActivationFlowConfigDataResponse>;
  getActivationFlowConfigToPrice?: Maybe<ActivationFlowConfigToPriceDataResponse>;
  getActiveMembershipFeature?: Maybe<ActiveMembershipFeatureDataResponse>;
  getActivity?: Maybe<ActivityDataResponse>;
  getActivityFeed: GetActivityFeedResponse;
  getActivityReference?: Maybe<ActivityReferenceDataResponse>;
  getActivityTextTemplate?: Maybe<ActivityTextTemplateDataResponse>;
  getAddress?: Maybe<AddressDataResponse>;
  getAddressFile?: Maybe<AddressFileDataResponse>;
  getAddressSubscription?: Maybe<AddressSubscriptionDataResponse>;
  getAddressSummary?: Maybe<AddressSummaryDataResponse>;
  getAiAgentConversation?: Maybe<AiAgentConversationDataResponse>;
  getAiAgentModelCall?: Maybe<AiAgentModelCallDataResponse>;
  getAiAgentRun?: Maybe<AiAgentRunDataResponse>;
  getAiAgentToolCall?: Maybe<AiAgentToolCallDataResponse>;
  getAiFollowUp: GetAiFollowUpResponse;
  getAiHelpLog?: Maybe<AiHelpLogDataResponse>;
  getAiMessageComposition: GetAiMessageCompositionResponse;
  getAiPrompt?: Maybe<AiPromptDataResponse>;
  getArsPayoutRun?: Maybe<ArsPayoutRunDataResponse>;
  getArsRunReport?: Maybe<ArsRunReportDataResponse>;
  getArsTransfer?: Maybe<ArsTransferDataResponse>;
  getAvailableCustomViews: GetAvailableCustomViewsResult;
  getBackgroundJob?: Maybe<BackgroundJob>;
  getBackgroundJobItems: GetBackgroundJobItemsResponse;
  getBackgroundJobs: GetBackgroundJobsResponse;
  getBehavior?: Maybe<BehaviorDataResponse>;
  getBehaviorConfig: BehaviorConfig;
  getBehaviorSequence?: Maybe<BehaviorSequenceDataResponse>;
  getBlockedEmail?: Maybe<BlockedEmailDataResponse>;
  getBlockedPhoneNumber?: Maybe<BlockedPhoneNumberDataResponse>;
  getBrand?: Maybe<BrandDataResponse>;
  getBrandGroup?: Maybe<BrandGroupDataResponse>;
  getBulkConversationContext: GetBulkConversationContextResponse;
  getBundledActivationFlowConfig?: Maybe<GetActivationFlowConfigResponse>;
  getBundledLandingPageConfig?: Maybe<GetBundledLandingPageConfigResponse>;
  getCallTranscription?: Maybe<CallTranscriptionDataResponse>;
  getCallTranscriptionSegment?: Maybe<CallTranscriptionSegmentDataResponse>;
  getCgCustomDomains: Array<CgCustomDomain>;
  getChildActivityFeed: GetActivityFeedResponse;
  getClient?: Maybe<ClientDataResponse>;
  getClientEmail?: Maybe<ClientEmailDataResponse>;
  getClientEmailLabels?: Maybe<ClientEmailLabelsDataResponse>;
  getClientGatewayUrl: Scalars['String']['output'];
  getClientPhoneLabels?: Maybe<ClientPhoneLabelsDataResponse>;
  getClientPhoneNumber?: Maybe<ClientPhoneNumberDataResponse>;
  getConversation?: Maybe<ConversationDataResponse>;
  getConversationAggregations: GetConversationAggregationsResponse;
  getConversationAssigneeGroup?: Maybe<ConversationAssigneeGroupDataResponse>;
  getConversationAttachment?: Maybe<ConversationAttachmentDataResponse>;
  getConversationAttachmentDistribution?: Maybe<ConversationAttachmentDistributionDataResponse>;
  getConversationChannel?: Maybe<ConversationChannelDataResponse>;
  getConversationChannelType?: Maybe<ConversationChannelTypeDataResponse>;
  getConversationContext?: Maybe<GetConversationContextResponse>;
  getConversationCounter?: Maybe<ConversationCounterDataResponse>;
  getConversationEmail?: Maybe<ConversationEmailDataResponse>;
  getConversationEmailDispatch?: Maybe<ConversationEmailDispatchDataResponse>;
  getConversationLiveTranscription?: Maybe<GetConversationLiveTranscriptionResponse>;
  getConversationMessage?: Maybe<ConversationMessageDataResponse>;
  getConversationMessageDispatch?: Maybe<ConversationMessageDispatchDataResponse>;
  getConversationMessageDraft?: Maybe<ConversationMessageDraftDataResponse>;
  getConversationMessageReaction?: Maybe<ConversationMessageReactionDataResponse>;
  getConversationMessageThread?: Maybe<ConversationMessageThreadDataResponse>;
  getConversationParticipant?: Maybe<ConversationParticipantDataResponse>;
  getConversationParticipantOptions: GetConversationParticipantOptionsResponse;
  getConversationParticipation?: Maybe<ConversationParticipationDataResponse>;
  getConversationSeenState?: Maybe<ConversationSeenStateDataResponse>;
  getConversationSms?: Maybe<ConversationSmsDataResponse>;
  getConversationSmsDispatch?: Maybe<ConversationSmsDispatchDataResponse>;
  getConversationSmsSession?: Maybe<ConversationSmsSessionDataResponse>;
  getConversationSmsSessionRecipient?: Maybe<ConversationSmsSessionRecipientDataResponse>;
  getConversationStatus?: Maybe<ConversationStatusDataResponse>;
  getConversationSummary?: Maybe<ConversationSummaryDataResponse>;
  getConversationTriage?: Maybe<ConversationTriageDataResponse>;
  getConversationTriageRun?: Maybe<ConversationTriageRunDataResponse>;
  getConversationTriageRunAction?: Maybe<ConversationTriageRunActionDataResponse>;
  getConversationTriageRunStep?: Maybe<ConversationTriageRunStepDataResponse>;
  getConversationUrgency?: Maybe<ConversationUrgencyDataResponse>;
  getCtaLabels?: Maybe<GetCtaLabelResponse>;
  getCustomAttributeDefinition?: Maybe<CustomAttributeDefinitionDataResponse>;
  getCustomView?: Maybe<CustomViewDataResponse>;
  getCustomViewAccess?: Maybe<CustomViewAccessDataResponse>;
  getCustomViewConfig: CustomViewConfig;
  getDefaultSignalBusinessHours: DefaultSignalBusinessHoursResponse;
  getDtoolsAuthDetails: DtoolsAuthResponse;
  getDtoolsProjectDetails: GetDtoolsProjectDetailsResponse;
  getDtoolsProjects: GetDtoolsProjectsResponse;
  getEmailCampaign?: Maybe<EmailCampaignDataResponse>;
  getEnabledAiPrompts: GetEnabledAiPromptsResponse;
  getEnabledConversationAssigneeGroups?: Maybe<GetEnabledConversationAssigneeGroupsDataResponse>;
  getEnabledConversationUrgencies?: Maybe<GetEnabledConversationUrgenciesDataResponse>;
  getEnabledMacros: Array<Maybe<Macro>>;
  getEnabledRecordFolders: GetEnabledRecordFolderDataResponse;
  getEntityViewer: GetEntityViewerResult;
  getHealthStatus: GetHealthStatusResponse;
  getIntegrationDriver?: Maybe<IntegrationDriverDataResponse>;
  getLabel?: Maybe<LabelDataResponse>;
  getLabelAssignment?: Maybe<LabelAssignmentDataResponse>;
  getLabelAssociation?: Maybe<LabelAssociationDataResponse>;
  getLabelGroup?: Maybe<LabelGroupDataResponse>;
  getLandingPageConfig?: Maybe<LandingPageConfigDataResponse>;
  getLegalDocument?: Maybe<LegalDocumentDataResponse>;
  getLegalDocumentLinks: LegalDocumentLinks;
  getLegalDocumentSegmentToken: Scalars['String']['output'];
  getLegalDocuments: Array<LegalDocumentView>;
  getMacro?: Maybe<MacroDataResponse>;
  getMacroConfig: MacroConfig;
  getManagementMacros: Array<Maybe<Macro>>;
  getMembership?: Maybe<MembershipDataResponse>;
  getMembershipFeature?: Maybe<MembershipFeatureDataResponse>;
  getMentionOptions: GetMentionOptionsResponse;
  getMyUserGroupSettingValues: Array<UserGroupSettingValue>;
  getNotification?: Maybe<NotificationDataResponse>;
  getNotificationChannel?: Maybe<NotificationChannelDataResponse>;
  getNotificationEvent?: Maybe<NotificationEventDataResponse>;
  getNotificationPreference?: Maybe<NotificationPreferenceDataResponse>;
  getNotificationRole?: Maybe<NotificationRoleDataResponse>;
  getOncallManagementSchedule?: Maybe<OncallManagementScheduleDataResponse>;
  getOriginalEmail: GetOriginalEmailResponse;
  getOvAnnouncementsSlackApp?: Maybe<OvAnnouncementsSlackAppDataResponse>;
  getPartner?: Maybe<PartnerDataResponse>;
  getPartnerBusinessHours?: Maybe<PartnerBusinessHoursDataResponse>;
  getPartnerCustomDomain?: Maybe<PartnerCustomDomainDataResponse>;
  getPartnerDomain?: Maybe<PartnerDomainDataResponse>;
  getPartnerGroup?: Maybe<PartnerGroupDataResponse>;
  getPartnerGroupRule?: Maybe<PartnerGroupRuleDataResponse>;
  getPartnerGroupRuleValue?: Maybe<PartnerGroupRuleValueDataResponse>;
  getPartnerHoliday?: Maybe<PartnerHolidayDataResponse>;
  getPartnerImportErrors: GetPartnerImportErrorsResponse;
  getPartnerInitFileInfo: UploadFileInfo;
  getPartnerInvoices: GetPartnerInvoicesResponse;
  getPartnerNotificationRole?: Maybe<PartnerNotificationRoleDataResponse>;
  getPartnerOnesheet?: Maybe<PartnerOnesheetDataResponse>;
  getPartnerProduct?: Maybe<PartnerProductDataResponse>;
  getPartnerProductPrice?: Maybe<PartnerProductPriceDataResponse>;
  getPartnerSetting?: Maybe<PartnerSettingDataResponse>;
  getPartnerSettingValue?: Maybe<PartnerSettingValueDataResponse>;
  getPhoneCall?: Maybe<PhoneCallDataResponse>;
  getPhoneCallFile?: Maybe<PhoneCallFileDataResponse>;
  getPhoneCallParticipation?: Maybe<PhoneCallParticipationDataResponse>;
  getPlatformEntity?: Maybe<PlatformEntityDataResponse>;
  getPlatformSla?: Maybe<PlatformSlaDataResponse>;
  getPlatformUser?: Maybe<PlatformUserDataResponse>;
  getPlatformUserAvatarUploadInfo: PlatformUserAvatarUploadInfo;
  getPortalioProjectImportPreview: GetExternalProjectImportPreviewResponse;
  getPortalioProposalDetails: GetPortalioProposalDetailsResponse;
  getPortalioProposals: GetPortalioProposalsResponse;
  getPortalioUserAuthDetails: PortalioAuthResponse;
  getPreSignedDeleteUrl: GetPreSignedDeleteUrlResponse;
  getPreSoldMembership?: Maybe<PreSoldMembershipDataResponse>;
  getProject?: Maybe<ProjectDataResponse>;
  getProjectLostReason?: Maybe<ProjectLostReasonDataResponse>;
  getProjectStage?: Maybe<ProjectStageDataResponse>;
  getPublicApiKeys: Array<Maybe<PublicApiKeyItem>>;
  getPublicApiPermissions: GetPublicApiPermissionsResponse;
  getPushNotificationCapability: PushNotificationCapability;
  getPushNotificationSubscription?: Maybe<PushNotificationSubscriptionDataResponse>;
  getRecordFolder?: Maybe<RecordFolderDataResponse>;
  getRecordFolderAssignment?: Maybe<RecordFolderAssignmentDataResponse>;
  getRsmEmail?: Maybe<RsmEmailDataResponse>;
  getSearchableText?: Maybe<SearchableTextDataResponse>;
  getSearchableTextMeta?: Maybe<SearchableTextMetaDataResponse>;
  getSearchableTextReference?: Maybe<SearchableTextReferenceDataResponse>;
  getSidekickAiAgentConversation?: Maybe<SidekickAiAgentConversationDataResponse>;
  getSidekickChatSessions: Array<SidekickChatSession>;
  getSidekickConfiguration?: Maybe<SidekickConfigurationDataResponse>;
  getSidekickRun?: Maybe<SidekickRunDataResponse>;
  getSidekickRunMessage?: Maybe<SidekickRunMessageDataResponse>;
  getSidekickRunResult: SidekickRunResult;
  getSidekickRuns: Array<SidekickRun>;
  getSidekickSessionRuns: Array<SidekickSessionRun>;
  getSidekickSuggestedQuestions: SidekickSuggestedQuestionsResult;
  getSignalBusinessHours?: Maybe<SignalBusinessHoursDataResponse>;
  getSignalIncident?: Maybe<SignalIncidentDataResponse>;
  getSignalIncidentSlackMessage?: Maybe<SignalIncidentSlackMessageDataResponse>;
  getSignalRulesConfig: SignalRulesConfig;
  getSiteContext?: Maybe<GetSiteContextResponse>;
  getSmsSessionLine: GetSmsSessionLineResponse;
  getSortedBehaviors: GetSortedBehaviorsResponse;
  getStoredFile?: Maybe<StoredFileDataResponse>;
  getStripeAccountDashboardLoginUrl: GetStripeAccountDashboardLoginUrlResponse;
  getStripeAccountOnboardStatus: GetStripeAccountOnboardStatusResponse;
  getStripeAccountOnboardUrl: GetStripeAccountOnboardUrlResponse;
  getStripeSubscriptionDetails: GetStripeSubscriptionDetailsResponse;
  getSubscriptionsReport: GetSubscriptionsReportResponse;
  getSupportPolicy?: Maybe<SupportPolicyDataResponse>;
  getSupportPolicyToUserGroup?: Maybe<SupportPolicyToUserGroupDataResponse>;
  getTextInterpolation: Scalars['String']['output'];
  getTriageSettingsPageData: GetTriageSettingsPageDataResponse;
  getTwilioClientPartnerInfo?: Maybe<TwilioClientPartnerInfo>;
  getUploadFileInfo: UploadFileInfo;
  getUserCommunicationPreference?: Maybe<UserCommunicationPreferenceDataResponse>;
  getUserConversationMessageDraft: GetUserConversationMessageDraftResult;
  getUserGroup?: Maybe<UserGroupDataResponse>;
  getUserGroupRule?: Maybe<UserGroupRuleDataResponse>;
  getUserGroupRuleValue?: Maybe<UserGroupRuleValueDataResponse>;
  getUserGroupSettingValue?: Maybe<UserGroupSettingValueDataResponse>;
  getUserLiveTranscription?: Maybe<GetUserLiveTranscriptionResponse>;
  getUserNotificationRole?: Maybe<UserNotificationRoleDataResponse>;
  getUserPresence: GetUserPresenceResult;
  getUserSetting?: Maybe<UserSettingDataResponse>;
  getUserSettingValue?: Maybe<UserSettingValueDataResponse>;
  getVisibleLabels: GetVisibleLabelsDataResponse;
  getWorkflow?: Maybe<WorkflowDataResponse>;
  getWorkflowAssignment?: Maybe<WorkflowAssignmentDataResponse>;
  getWorkflowExecution?: Maybe<WorkflowExecutionDataResponse>;
  getWorkflowExecutionLog?: Maybe<WorkflowExecutionLogDataResponse>;
  getWorkflowStepTypes: GetWorkflowStepTypesResponse;
  getWorkflowVersion?: Maybe<WorkflowVersionDataResponse>;
  importPartnerProgress: ImportPartnerProgressResponse;
};

export type QueryBulkUpdateEntitiesProgressArgs = {
  input: BulkUpdateEntitiesProgressInput;
};

export type QueryClientGatewayGetActivationFlowConfigArgs = {
  input: ClientGatewayGetActivationFlowConfigInput;
};

export type QueryClientGatewayGetBrandingArgs = {
  input: ClientGatewayGetBrandingInput;
};

export type QueryClientGatewayGetClientArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryClientGatewayGetConversationArgs = {
  queryParams?: InputMaybe<ClientGatewayGetConversationParams>;
};

export type QueryClientGatewayGetConversationMessageArgs = {
  queryParams?: InputMaybe<ClientGatewayGetConversationMessageParams>;
};

export type QueryClientGatewayGetConversationParticipantsArgs = {
  conversationId: Scalars['String']['input'];
};

export type QueryClientGatewayGetLandingPageArgs = {
  input: ClientGatewayGetLandingPageInput;
};

export type QueryClientGatewayGetLandingPageCheckoutConfirmationArgs = {
  input: ClientGatewayGetLandingPageCheckoutConfirmationInput;
};

export type QueryClientGatewayGetLegalDocumentArgs = {
  input: ClientGatewayGetLegalDocumentInput;
};

export type QueryClientGatewayGetPartnerArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryClientGatewayGetPartnerSettingValueArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryClientGatewayGetStripeCheckoutConfirmationDataArgs = {
  input: GetStripeCheckoutConfirmationDataInput;
};

export type QueryClientGatewayGetUploadFileInfoArgs = {
  input: UploadFileInfoInput;
};

export type QueryClientGatewayIsPartnerAvailableArgs = {
  input: ClientGatewayIsPartnerAvailableInput;
};

export type QueryClientGatewayResolveHostArgs = {
  input: ClientGatewayResolveHostInput;
};

export type QueryGenerateConversationSummaryArgs = {
  params: GenerateConversationSummaryParams;
};

export type QueryGetActivationFlowConfigArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetActivationFlowConfigToPriceArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetActiveMembershipFeatureArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetActivityArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetActivityFeedArgs = {
  params?: InputMaybe<GetActivityFeedInput>;
};

export type QueryGetActivityReferenceArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetActivityTextTemplateArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAddressArgs = {
  queryParams?: InputMaybe<QueryParamsWithSearch>;
};

export type QueryGetAddressFileArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAddressSubscriptionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAddressSummaryArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAiAgentConversationArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAiAgentModelCallArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAiAgentRunArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAiAgentToolCallArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAiFollowUpArgs = {
  params?: InputMaybe<GetAiFollowUpInput>;
};

export type QueryGetAiHelpLogArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAiMessageCompositionArgs = {
  params: GetAiMessageCompositionInput;
};

export type QueryGetAiPromptArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetArsPayoutRunArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetArsRunReportArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetArsTransferArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetAvailableCustomViewsArgs = {
  params: GetAvailableCustomViewsInput;
};

export type QueryGetBackgroundJobArgs = {
  params: GetBackgroundJobInput;
};

export type QueryGetBackgroundJobItemsArgs = {
  params: GetBackgroundJobItemsInput;
};

export type QueryGetBackgroundJobsArgs = {
  params: GetBackgroundJobsInput;
};

export type QueryGetBehaviorArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetBehaviorSequenceArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetBlockedEmailArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetBlockedPhoneNumberArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetBrandArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetBrandGroupArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetBulkConversationContextArgs = {
  input: GetBulkConversationContextInput;
};

export type QueryGetBundledActivationFlowConfigArgs = {
  input: GetActivationFlowConfigInput;
};

export type QueryGetBundledLandingPageConfigArgs = {
  input: GetBundledLandingPageConfigInput;
};

export type QueryGetCallTranscriptionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetCallTranscriptionSegmentArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetCgCustomDomainsArgs = {
  input: GetCgCustomDomainsInput;
};

export type QueryGetChildActivityFeedArgs = {
  params?: InputMaybe<GetChildActivityFeedInput>;
};

export type QueryGetClientArgs = {
  queryParams?: InputMaybe<QueryParamsWithSearch>;
};

export type QueryGetClientEmailArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetClientEmailLabelsArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetClientGatewayUrlArgs = {
  input: GetClientGatewayUrlInput;
};

export type QueryGetClientPhoneLabelsArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetClientPhoneNumberArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationArgs = {
  queryParams?: InputMaybe<QueryParamsWithSearch>;
};

export type QueryGetConversationAggregationsArgs = {
  input: GetConversationAggregationsInput;
};

export type QueryGetConversationAssigneeGroupArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationAttachmentArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationAttachmentDistributionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationChannelArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationChannelTypeArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationContextArgs = {
  input: GetConversationContextInput;
};

export type QueryGetConversationCounterArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationEmailArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationEmailDispatchArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationLiveTranscriptionArgs = {
  params: GetConversationLiveTranscriptionInput;
};

export type QueryGetConversationMessageArgs = {
  queryParams?: InputMaybe<QueryParamsWithSearch>;
};

export type QueryGetConversationMessageDispatchArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationMessageDraftArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationMessageReactionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationMessageThreadArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationParticipantArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationParticipantOptionsArgs = {
  input?: InputMaybe<GetConversationParticipantOptionsInput>;
};

export type QueryGetConversationParticipationArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationSeenStateArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationSmsArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationSmsDispatchArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationSmsSessionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationSmsSessionRecipientArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationStatusArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationSummaryArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationTriageArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationTriageRunArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationTriageRunActionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationTriageRunStepArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetConversationUrgencyArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetCtaLabelsArgs = {
  input: GetCtaLabelInput;
};

export type QueryGetCustomAttributeDefinitionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetCustomViewArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetCustomViewAccessArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetDtoolsAuthDetailsArgs = {
  params: GetDtoolsAuthDetailsInput;
};

export type QueryGetDtoolsProjectDetailsArgs = {
  params: GetDtoolsProjectDetailsInput;
};

export type QueryGetDtoolsProjectsArgs = {
  params: GetDtoolsProjectsInput;
};

export type QueryGetEmailCampaignArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetEnabledAiPromptsArgs = {
  params: GetEnabledAiPromptsInput;
};

export type QueryGetEnabledConversationAssigneeGroupsArgs = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetEnabledConversationUrgenciesArgs = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetEnabledMacrosArgs = {
  filters?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  partnerId: Scalars['Int']['input'];
  requesterId: Scalars['String']['input'];
};

export type QueryGetEnabledRecordFoldersArgs = {
  area?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type QueryGetEntityViewerArgs = {
  params: GetEntityViewerInput;
};

export type QueryGetIntegrationDriverArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetLabelArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetLabelAssignmentArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetLabelAssociationArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetLabelGroupArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetLandingPageConfigArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetLegalDocumentArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetLegalDocumentLinksArgs = {
  input: GetLegalDocumentLinksInput;
};

export type QueryGetLegalDocumentSegmentTokenArgs = {
  input: GetLegalDocumentSegmentTokenInput;
};

export type QueryGetLegalDocumentsArgs = {
  input: GetLegalDocumentsInput;
};

export type QueryGetMacroArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetManagementMacrosArgs = {
  filters?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  partnerId: Scalars['Int']['input'];
  requesterId: Scalars['String']['input'];
};

export type QueryGetMembershipArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetMembershipFeatureArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetMentionOptionsArgs = {
  params?: InputMaybe<GetMentionOptionsInput>;
};

export type QueryGetNotificationArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetNotificationChannelArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetNotificationEventArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetNotificationPreferenceArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetNotificationRoleArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetOncallManagementScheduleArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetOriginalEmailArgs = {
  params?: InputMaybe<GetOriginalEmailInput>;
};

export type QueryGetOvAnnouncementsSlackAppArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerBusinessHoursArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerCustomDomainArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerDomainArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerGroupArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerGroupRuleArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerGroupRuleValueArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerHolidayArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerImportErrorsArgs = {
  params?: InputMaybe<ImportPartnerInput>;
};

export type QueryGetPartnerInitFileInfoArgs = {
  input: UploadPartnerInitFileInfoInput;
};

export type QueryGetPartnerInvoicesArgs = {
  params: GetPartnerInvoicesInput;
};

export type QueryGetPartnerNotificationRoleArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerOnesheetArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerProductArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerProductPriceArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerSettingArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPartnerSettingValueArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPhoneCallArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPhoneCallFileArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPhoneCallParticipationArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPlatformEntityArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPlatformSlaArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPlatformUserArgs = {
  queryParams?: InputMaybe<QueryParamsWithSearch>;
};

export type QueryGetPlatformUserAvatarUploadInfoArgs = {
  input: PlatformUserAvatarUploadInfoInput;
};

export type QueryGetPortalioProjectImportPreviewArgs = {
  params: ImportPortalioProjectInput;
};

export type QueryGetPortalioProposalDetailsArgs = {
  params: GetPortalioProposalDetailsInput;
};

export type QueryGetPortalioProposalsArgs = {
  params: GetPortalioProposalsInput;
};

export type QueryGetPreSignedDeleteUrlArgs = {
  params: GetPreSignedDeleteUrlInput;
};

export type QueryGetPreSoldMembershipArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetProjectArgs = {
  queryParams?: InputMaybe<QueryParamsWithSearch>;
};

export type QueryGetProjectLostReasonArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetProjectStageArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetPublicApiKeysArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type QueryGetPushNotificationSubscriptionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetRecordFolderArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetRecordFolderAssignmentArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetRsmEmailArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSearchableTextArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSearchableTextMetaArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSearchableTextReferenceArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSidekickAiAgentConversationArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSidekickChatSessionsArgs = {
  params: GetSidekickChatSessionsInput;
};

export type QueryGetSidekickConfigurationArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSidekickRunArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSidekickRunMessageArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSidekickRunResultArgs = {
  params: GetSidekickRunResultInput;
};

export type QueryGetSidekickRunsArgs = {
  params: GetSidekickRunsInput;
};

export type QueryGetSidekickSessionRunsArgs = {
  params: GetSidekickSessionRunsInput;
};

export type QueryGetSidekickSuggestedQuestionsArgs = {
  params: GetSidekickSuggestedQuestionsInput;
};

export type QueryGetSignalBusinessHoursArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSignalIncidentArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSignalIncidentSlackMessageArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSiteContextArgs = {
  input: GetSiteContextInput;
};

export type QueryGetSmsSessionLineArgs = {
  input: GetSmsSessionLineInput;
};

export type QueryGetSortedBehaviorsArgs = {
  filters?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
};

export type QueryGetStoredFileArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetStripeAccountDashboardLoginUrlArgs = {
  params: GetStripeAccountDashboardLoginUrlInput;
};

export type QueryGetStripeAccountOnboardStatusArgs = {
  params: GetStripeAccountOnboardStatusInput;
};

export type QueryGetStripeAccountOnboardUrlArgs = {
  params: GetStripeAccountOnboardUrlInput;
};

export type QueryGetStripeSubscriptionDetailsArgs = {
  params: GetStripeSubscriptionDetailsInput;
};

export type QueryGetSubscriptionsReportArgs = {
  params: GetSubscriptionsReportParams;
};

export type QueryGetSupportPolicyArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetSupportPolicyToUserGroupArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetTextInterpolationArgs = {
  input: GetTextInterpolationInput;
};

export type QueryGetTriageSettingsPageDataArgs = {
  partnerId: Scalars['Int']['input'];
};

export type QueryGetTwilioClientPartnerInfoArgs = {
  input: GetTwilioClientPartnerInfoInput;
};

export type QueryGetUploadFileInfoArgs = {
  input: UploadFileInfoInput;
};

export type QueryGetUserCommunicationPreferenceArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetUserConversationMessageDraftArgs = {
  params?: InputMaybe<GetUserConversationMessageDraftInput>;
};

export type QueryGetUserGroupArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetUserGroupRuleArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetUserGroupRuleValueArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetUserGroupSettingValueArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetUserLiveTranscriptionArgs = {
  params: GetUserLiveTranscriptionInput;
};

export type QueryGetUserNotificationRoleArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetUserPresenceArgs = {
  params: GetUserPresenceInput;
};

export type QueryGetUserSettingArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetUserSettingValueArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetWorkflowArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetWorkflowAssignmentArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetWorkflowExecutionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetWorkflowExecutionLogArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryGetWorkflowVersionArgs = {
  queryParams?: InputMaybe<QueryParams>;
};

export type QueryImportPartnerProgressArgs = {
  params: ImportPartnerInput;
};

export type QueryParams = {
  filters?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  ignorePage?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Array<InputMaybe<SortingInput>>>;
};

export type QueryParamsWithSearch = {
  filters?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  ignorePage?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<SearchInput>;
  sorting?: InputMaybe<Array<InputMaybe<SortingInput>>>;
};

export type RecordFolder = {
  __typename?: 'RecordFolder';
  area: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  recordFolderAssignments?: Maybe<Array<Maybe<RecordFolderAssignment>>>;
  recordFolderId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type RecordFolderAssignment = {
  __typename?: 'RecordFolderAssignment';
  createdAt: Scalars['String']['output'];
  entity: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformEntity?: Maybe<PlatformEntity>;
  recordFolder?: Maybe<RecordFolder>;
  recordFolderAssignmentId: Scalars['String']['output'];
  recordFolderId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type RecordFolderAssignmentDataInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  recordFolderAssignmentId?: InputMaybe<Scalars['String']['input']>;
  recordFolderId?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RecordFolderAssignmentDataResponse = {
  __typename?: 'RecordFolderAssignmentDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<RecordFolderAssignment>>>;
};

export type RecordFolderAssignmentSearchResponse = {
  __typename?: 'RecordFolderAssignmentSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<RecordFolderAssignment>>>;
};

export type RecordFolderDataInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  recordFolderId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type RecordFolderDataResponse = {
  __typename?: 'RecordFolderDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<RecordFolder>>>;
};

export type RecordFolderSearchResponse = {
  __typename?: 'RecordFolderSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<RecordFolder>>>;
};

export type RemoveConversationMessageReactionResponse = {
  __typename?: 'RemoveConversationMessageReactionResponse';
  removed: Scalars['Boolean']['output'];
};

export type ResolveConversationMessageThreadInput = {
  replyConversationMessageId: Scalars['String']['input'];
};

export type ResolveCustomMembershipPriceInput = {
  amountCents: Scalars['Int']['input'];
  intervalCount: Scalars['Int']['input'];
  intervalUnit: CustomSignupBillingIntervalUnit;
  partnerId: Scalars['Int']['input'];
  partnerProductId: Scalars['String']['input'];
};

export type ResolveCustomMembershipPriceResponse = {
  __typename?: 'ResolveCustomMembershipPriceResponse';
  stripePriceId: Scalars['String']['output'];
};

export type ResolveSignalIncidentInput = {
  signalIncidentId: Scalars['String']['input'];
};

export type ResolveSignalIncidentResponse = {
  __typename?: 'ResolveSignalIncidentResponse';
  signalIncident: SignalIncident;
};

export type ResolveTriageActionInput = {
  conversationTriageRunActionId: Scalars['ID']['input'];
  resolution: TriageActionResolution;
};

export type ResolveTriageActionResponse = {
  __typename?: 'ResolveTriageActionResponse';
  appliedAt?: Maybe<Scalars['String']['output']>;
  appliedBy?: Maybe<Scalars['String']['output']>;
  applyError?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payload: Scalars['AWSJSON']['output'];
  status: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type RestoreDeletedAddressInput = {
  addressId: Scalars['String']['input'];
};

export type RestoreDeletedAddressResponse = {
  __typename?: 'RestoreDeletedAddressResponse';
  addressId: Scalars['String']['output'];
};

export type RestoreDeletedClientInput = {
  clientId: Scalars['String']['input'];
};

export type RestoreDeletedClientResponse = {
  __typename?: 'RestoreDeletedClientResponse';
  clientId: Scalars['String']['output'];
};

export type RestoreDeletedConversationInput = {
  conversationId: Scalars['String']['input'];
};

export type RestoreDeletedConversationResponse = {
  __typename?: 'RestoreDeletedConversationResponse';
  conversationId: Scalars['String']['output'];
};

export type RestoreDeletedProjectInput = {
  projectId: Scalars['String']['input'];
};

export type RestoreDeletedProjectResponse = {
  __typename?: 'RestoreDeletedProjectResponse';
  projectId: Scalars['String']['output'];
};

export type RotatePublicApiKeyInput = {
  apiKeyId: Scalars['String']['input'];
  newKeyDescription?: InputMaybe<Scalars['String']['input']>;
  newKeyName?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
};

export type RsmEmail = {
  __typename?: 'RsmEmail';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  rsmEmailId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RsmEmailDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  rsmEmailId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RsmEmailDataResponse = {
  __typename?: 'RsmEmailDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<RsmEmail>>>;
};

export type RsmEmailSearchResponse = {
  __typename?: 'RsmEmailSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<RsmEmail>>>;
};

export type SaveActivationFlowConfigBundleInput = {
  activationFlowConfigId?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  features: Array<SerializedMembershipFeatureInput>;
  options: ActivationFlowOptionsInput;
  partnerId: Scalars['Int']['input'];
  plans: Array<SerializedPlanInput>;
};

export type SaveActivationFlowConfigBundleResponse = {
  __typename?: 'SaveActivationFlowConfigBundleResponse';
  success: Scalars['Boolean']['output'];
};

export type SaveClientWithRelatedDataInput = {
  address?: InputMaybe<AddressDataInput>;
  client: ClientDataInput;
  emails?: InputMaybe<Array<InputMaybe<ClientEmailDataInput>>>;
  participant?: InputMaybe<ConversationParticipantDataInput>;
  partnerId: Scalars['Int']['input'];
  phoneNumbers?: InputMaybe<Array<InputMaybe<ClientPhoneNumberDataInput>>>;
  primaryEmail?: InputMaybe<ClientEmailDataInput>;
  primaryPhoneNumber?: InputMaybe<ClientPhoneNumberDataInput>;
};

export type SaveClientWithRelatedDataResponse = {
  __typename?: 'SaveClientWithRelatedDataResponse';
  client: Client;
};

export type SaveConversationForTwilioPhoneCallRecordingInput = {
  callTo?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  recordingSid: Scalars['String']['input'];
  recordingType?: InputMaybe<Scalars['String']['input']>;
};

export type SaveDraftWorkflowVersionDefinitionInput = {
  definition: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  workflowVersionId: Scalars['String']['input'];
};

export type SaveDraftWorkflowVersionDefinitionOutput = {
  __typename?: 'SaveDraftWorkflowVersionDefinitionOutput';
  errors: Array<WorkflowDefinitionError>;
  /** False when `errors` is non-empty; nothing was written. */
  saved: Scalars['Boolean']['output'];
  /** The version as saved; null when not saved. */
  workflowVersion?: Maybe<WorkflowVersion>;
};

export type SaveLandingPageConfigInput = {
  brandId: Scalars['String']['input'];
  config: Scalars['String']['input'];
  name: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};

export type SaveLandingPageConfigResponse = {
  __typename?: 'SaveLandingPageConfigResponse';
  success: Scalars['Boolean']['output'];
};

export type SaveLegalDocumentInput = {
  bodyHtml: Scalars['String']['input'];
  brandId: Scalars['String']['input'];
  kind: LegalDocumentKind;
  legalDocumentId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type SaveTwilioConversationContentInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  twilioConversationSid: Scalars['String']['input'];
  twilioWorkflowSid: Scalars['String']['input'];
};

export type Schedule = {
  __typename?: 'Schedule';
  cancelsAt?: Maybe<Scalars['String']['output']>;
  phases: Array<Maybe<SchedulePhase>>;
};

export type SchedulePhase = {
  __typename?: 'SchedulePhase';
  coupon?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  phaseType?: Maybe<Scalars['String']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type SearchInput = {
  searchTerm: Scalars['String']['input'];
  targetIdAttributes: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SearchMeta = {
  __typename?: 'SearchMeta';
  id?: Maybe<Scalars['String']['output']>;
  targetIdAttribute?: Maybe<Scalars['String']['output']>;
};

export type SearchQueryParams = {
  filters?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  ignorePage?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchAttributes: Array<InputMaybe<Scalars['String']['input']>>;
  searchTerm: Scalars['String']['input'];
  sorting?: InputMaybe<Array<InputMaybe<SortingInput>>>;
};

export type SearchableText = {
  __typename?: 'SearchableText';
  address?: Maybe<Array<Maybe<Address>>>;
  client?: Maybe<Array<Maybe<Client>>>;
  clientEmail?: Maybe<Array<Maybe<ClientEmail>>>;
  clientPhoneNumber?: Maybe<Array<Maybe<ClientPhoneNumber>>>;
  context?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Array<Maybe<Conversation>>>;
  conversationMessage?: Maybe<Array<Maybe<ConversationMessage>>>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  entity: Scalars['String']['output'];
  entityData: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformEntity?: Maybe<PlatformEntity>;
  platformUser?: Maybe<Array<Maybe<PlatformUser>>>;
  project?: Maybe<Array<Maybe<Project>>>;
  searchableTextId: Scalars['Int']['output'];
};

export type SearchableTextDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SearchableTextDataInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityData?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  searchableTextId?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchableTextDataResponse = {
  __typename?: 'SearchableTextDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SearchableText>>>;
};

export type SearchableTextMeta = {
  __typename?: 'SearchableTextMeta';
  attributeName?: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  platformEntity?: Maybe<PlatformEntity>;
  searchableTextMetaId: Scalars['Int']['output'];
};

export type SearchableTextMetaDataInput = {
  attributeName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  searchableTextMetaId?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchableTextMetaDataResponse = {
  __typename?: 'SearchableTextMetaDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SearchableTextMeta>>>;
};

export type SearchableTextMetaSearchResponse = {
  __typename?: 'SearchableTextMetaSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SearchableTextMeta>>>;
};

export type SearchableTextReference = {
  __typename?: 'SearchableTextReference';
  createdAt: Scalars['String']['output'];
  entity: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  rootEntity?: Maybe<Scalars['String']['output']>;
  rootEntityId?: Maybe<Scalars['String']['output']>;
  searchableTextId?: Maybe<Scalars['Int']['output']>;
  searchableTextReferenceId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SearchableTextReferenceDataInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  rootEntity?: InputMaybe<Scalars['String']['input']>;
  rootEntityId?: InputMaybe<Scalars['String']['input']>;
  searchableTextId?: InputMaybe<Scalars['Int']['input']>;
  searchableTextReferenceId?: InputMaybe<Scalars['String']['input']>;
};

export type SearchableTextReferenceDataResponse = {
  __typename?: 'SearchableTextReferenceDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SearchableTextReference>>>;
};

export type SearchableTextReferenceSearchResponse = {
  __typename?: 'SearchableTextReferenceSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SearchableTextReference>>>;
};

export type SearchableTextSearchResponse = {
  __typename?: 'SearchableTextSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SearchableText>>>;
};

export type SendMembershipEmailInput = {
  addressId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};

export type SendMembershipEmailResponse = {
  __typename?: 'SendMembershipEmailResponse';
  success: Scalars['Boolean']['output'];
};

export enum SerializedBillingCycle {
  Month = 'month',
  Year = 'year',
}

export type SerializedMembershipFeatureInput = {
  defaultContent: Scalars['String']['input'];
  defaultTooltip?: InputMaybe<Scalars['String']['input']>;
  membershipFeatureId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  plans: Array<SerializedMembershipFeaturePlanInput>;
  sortOrder: Scalars['Int']['input'];
};

export type SerializedMembershipFeaturePlanInput = {
  included: Scalars['Boolean']['input'];
  overrideContent?: InputMaybe<Scalars['String']['input']>;
  overrideTooltip?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};

export type SerializedPlanInput = {
  callForPricingEnabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  isMostPopular: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  platformSlaId?: InputMaybe<Scalars['String']['input']>;
  prices: Array<SerializedPlanPriceInput>;
  sortOrder: Scalars['Int']['input'];
};

export type SerializedPlanPriceInput = {
  amountCents: Scalars['Int']['input'];
  billingCycle: SerializedBillingCycle;
};

export type SetCgCustomDomainSegmentsInput = {
  brandIds: Array<Scalars['String']['input']>;
  partnerCustomDomainId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type SetDefaultConversationTriageInput = {
  conversationTriageId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type SetUserPasswordDataInput = {
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type SetUserPasswordDataResponse = {
  __typename?: 'SetUserPasswordDataResponse';
  userId: Scalars['String']['output'];
};

export type SetWorkflowAssignmentInput = {
  partnerId: Scalars['Int']['input'];
  triggerType: Scalars['String']['input'];
  /** Null clears the assignment, restoring the platform default for that trigger. */
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type SetWorkflowAssignmentOutput = {
  __typename?: 'SetWorkflowAssignmentOutput';
  partnerId: Scalars['Int']['output'];
  triggerType: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type SidekickAiAgentConversation = {
  __typename?: 'SidekickAiAgentConversation';
  aiAgentConversation?: Maybe<AiAgentConversation>;
  aiAgentConversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<PlatformUser>;
  ownerId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  sidekickAiAgentConversationId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SidekickAiAgentConversationDataInput = {
  aiAgentConversationId?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  sidekickAiAgentConversationId?: InputMaybe<Scalars['String']['input']>;
};

export type SidekickAiAgentConversationDataResponse = {
  __typename?: 'SidekickAiAgentConversationDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickAiAgentConversation>>>;
};

export type SidekickAiAgentConversationSearchResponse = {
  __typename?: 'SidekickAiAgentConversationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickAiAgentConversation>>>;
};

export type SidekickAiAgentInputItem = {
  message?: InputMaybe<SidekickAiAgentUserMessageInput>;
  toolApprovalResponse?: InputMaybe<SidekickAiAgentToolApprovalResponseInput>;
};

export type SidekickAiAgentReferenceInput = {
  label: Scalars['String']['input'];
  refId: Scalars['String']['input'];
  refType: Scalars['String']['input'];
};

export type SidekickAiAgentToolApprovalResponseInput = {
  approvalId: Scalars['String']['input'];
  approved: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SidekickAiAgentUserMessageInput = {
  references?: InputMaybe<Array<SidekickAiAgentReferenceInput>>;
  text: Scalars['String']['input'];
};

export type SidekickAssistantMessage = {
  __typename?: 'SidekickAssistantMessage';
  html?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SidekickChatSession = {
  __typename?: 'SidekickChatSession';
  createdAt: Scalars['String']['output'];
  previewText?: Maybe<Scalars['String']['output']>;
  sessionRootRunId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SidekickConfiguration = {
  __typename?: 'SidekickConfiguration';
  agentConfig?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  providerConfig: Scalars['String']['output'];
  sidekickConfigurationId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SidekickConfigurationDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SidekickConfigurationDataInput = {
  agentConfig?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  providerConfig?: InputMaybe<Scalars['String']['input']>;
  sidekickConfigurationId?: InputMaybe<Scalars['String']['input']>;
};

export type SidekickConfigurationDataResponse = {
  __typename?: 'SidekickConfigurationDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickConfiguration>>>;
};

export type SidekickConfigurationSearchResponse = {
  __typename?: 'SidekickConfigurationSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickConfiguration>>>;
};

export type SidekickRun = {
  __typename?: 'SidekickRun';
  aiProviderResponseId?: Maybe<Scalars['String']['output']>;
  chunkSequence: Scalars['Int']['output'];
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  previousResponseId?: Maybe<Scalars['String']['output']>;
  sidekickRunId: Scalars['String']['output'];
  sidekickRunMessages?: Maybe<Array<Maybe<SidekickRunMessage>>>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SidekickRunDataInput = {
  aiProviderResponseId?: InputMaybe<Scalars['String']['input']>;
  chunkSequence?: InputMaybe<Scalars['Int']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  previousResponseId?: InputMaybe<Scalars['String']['input']>;
  sidekickRunId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SidekickRunDataResponse = {
  __typename?: 'SidekickRunDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickRun>>>;
};

export type SidekickRunMessage = {
  __typename?: 'SidekickRunMessage';
  contentHtml?: Maybe<Scalars['String']['output']>;
  contentText?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  sidekickRun?: Maybe<SidekickRun>;
  sidekickRunId: Scalars['String']['output'];
  sidekickRunMessageId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SidekickRunMessageDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SidekickRunMessageDataInput = {
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  contentText?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sidekickRunId?: InputMaybe<Scalars['String']['input']>;
  sidekickRunMessageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SidekickRunMessageDataResponse = {
  __typename?: 'SidekickRunMessageDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickRunMessage>>>;
};

export type SidekickRunMessageSearchResponse = {
  __typename?: 'SidekickRunMessageSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickRunMessage>>>;
};

export type SidekickRunResult = {
  __typename?: 'SidekickRunResult';
  aiProviderResponseId?: Maybe<Scalars['String']['output']>;
  assistantMessage?: Maybe<SidekickAssistantMessage>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SidekickRunSearchResponse = {
  __typename?: 'SidekickRunSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SidekickRun>>>;
};

export type SidekickSessionRun = {
  __typename?: 'SidekickSessionRun';
  aiProviderResponseId?: Maybe<Scalars['String']['output']>;
  assistantMessage?: Maybe<SidekickSessionRunMessage>;
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  previousResponseId?: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userMessage?: Maybe<SidekickSessionRunMessage>;
};

export type SidekickSessionRunMessage = {
  __typename?: 'SidekickSessionRunMessage';
  html?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SidekickSuggestedQuestionsResult = {
  __typename?: 'SidekickSuggestedQuestionsResult';
  questions: Array<Scalars['String']['output']>;
};

export type SignalBusinessHours = {
  __typename?: 'SignalBusinessHours';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  signalBusinessHoursId: Scalars['String']['output'];
  timeFrom: Scalars['String']['output'];
  timeTo: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  urgency: Scalars['String']['output'];
  weekDay?: Maybe<Scalars['Int']['output']>;
};

export type SignalBusinessHoursDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  signalBusinessHoursId?: InputMaybe<Scalars['String']['input']>;
  timeFrom?: InputMaybe<Scalars['String']['input']>;
  timeTo?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<Scalars['String']['input']>;
  weekDay?: InputMaybe<Scalars['Int']['input']>;
};

export type SignalBusinessHoursDataResponse = {
  __typename?: 'SignalBusinessHoursDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SignalBusinessHours>>>;
};

export type SignalBusinessHoursSearchResponse = {
  __typename?: 'SignalBusinessHoursSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SignalBusinessHours>>>;
};

export type SignalIncident = {
  __typename?: 'SignalIncident';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['String']['output'];
  conversationUrgency?: Maybe<ConversationUrgency>;
  conversationUrgencyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  notificationLog?: Maybe<Scalars['String']['output']>;
  notificationsTargetType: Scalars['String']['output'];
  notifierId?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  resolvedAt?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  resolver?: Maybe<PlatformUser>;
  signalIncidentId: Scalars['String']['output'];
  slackMessages?: Maybe<Array<Maybe<SignalIncidentSlackMessage>>>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SignalIncidentDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SignalIncidentDataInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationUrgencyId?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  notificationLog?: InputMaybe<Scalars['String']['input']>;
  notificationsTargetType?: InputMaybe<Scalars['String']['input']>;
  notifierId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  resolvedAt?: InputMaybe<Scalars['String']['input']>;
  resolvedBy?: InputMaybe<Scalars['String']['input']>;
  signalIncidentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SignalIncidentDataResponse = {
  __typename?: 'SignalIncidentDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SignalIncident>>>;
};

export type SignalIncidentSearchResponse = {
  __typename?: 'SignalIncidentSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SignalIncident>>>;
};

export type SignalIncidentSlackMessage = {
  __typename?: 'SignalIncidentSlackMessage';
  channelName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  signalIncident?: Maybe<SignalIncident>;
  signalIncidentId: Scalars['String']['output'];
  signalIncidentSlackMessageId: Scalars['String']['output'];
  ts: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SignalIncidentSlackMessageDataInput = {
  channelName?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  signalIncidentId?: InputMaybe<Scalars['String']['input']>;
  signalIncidentSlackMessageId?: InputMaybe<Scalars['String']['input']>;
  ts?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SignalIncidentSlackMessageDataResponse = {
  __typename?: 'SignalIncidentSlackMessageDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SignalIncidentSlackMessage>>>;
};

export type SignalIncidentSlackMessageSearchResponse = {
  __typename?: 'SignalIncidentSlackMessageSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SignalIncidentSlackMessage>>>;
};

export type SignalRulesConfig = {
  __typename?: 'SignalRulesConfig';
  conditionTypes: Array<BehaviorConfigConditionType>;
  conditions: SignalRulesConfigConditions;
  operators: BehaviorConfigOperatorsByUiType;
  version: Scalars['String']['output'];
};

export type SignalRulesConfigConditions = {
  __typename?: 'SignalRulesConfigConditions';
  data: Array<BehaviorConfigDataCondition>;
};

export type SmsSessionParticipation = {
  __typename?: 'SmsSessionParticipation';
  conversationChannelId: Scalars['String']['output'];
  conversationParticipationId: Scalars['String']['output'];
  externalIdentifier: Scalars['String']['output'];
  internalIdentifier: Scalars['String']['output'];
  participantEntity: Scalars['String']['output'];
  participantIdentity: Scalars['String']['output'];
};

export type SmsSessionRecipientInput = {
  /** A number on a client's record; its channel is created when this conversation has none. */
  clientPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  /** A TwilioSMS channel already on this conversation. */
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
  /** A typed number, US/Canada (10 digits or +1 E.164); anything else is refused. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SnoozeConversationInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  snoozeUntil?: InputMaybe<Scalars['String']['input']>;
};

export type SnoozeConversationResponse = {
  __typename?: 'SnoozeConversationResponse';
  conversationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SoftDeleteConversationTriageInput = {
  conversationTriageId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type SoftDeleteWorkflowInput = {
  partnerId: Scalars['Int']['input'];
  workflowId: Scalars['String']['input'];
};

export type SoftDeleteWorkflowVersionInput = {
  partnerId: Scalars['Int']['input'];
  workflowVersionId: Scalars['String']['input'];
};

export type SortingInput = {
  aggFunction?: InputMaybe<Scalars['String']['input']>;
  attribute: Scalars['String']['input'];
  coalesceDefault?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartArsPayoutRunInput = {
  from: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  to: Scalars['String']['input'];
};

export type StartConversationTriageInput = {
  conversationId: Scalars['String']['input'];
  idempotencyId?: InputMaybe<Scalars['String']['input']>;
  userInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type StartConversationTriageResponse = {
  __typename?: 'StartConversationTriageResponse';
  success: Scalars['Boolean']['output'];
};

export type StartDtoolsProjectImportJobInput = {
  dryRun: Scalars['Boolean']['input'];
  partnerId: Scalars['Int']['input'];
  projectIds: Array<Scalars['String']['input']>;
};

export type StartSidekickRunInput = {
  conversationId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  previousResponseId?: InputMaybe<Scalars['String']['input']>;
};

export type StartSmsSessionInput = {
  /** Legacy single pin sent by portal bundles before 1V-6224; `recipients` supersedes it. */
  conversationChannelId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  /**
   * The numbers to text, in To-line order (at most 9); the first founds the session. Absent: the
   * conversation's original SMS channel, else the requester's primary number.
   */
  recipients?: InputMaybe<Array<SmsSessionRecipientInput>>;
};

export type StartSmsSessionResponse = {
  __typename?: 'StartSmsSessionResponse';
  conversationSmsSession: ConversationSmsSession;
  /** Deprecated: the first of smsParticipations, read by portal bundles before 1V-6224. */
  smsParticipation?: Maybe<SmsSessionParticipation>;
  /**
   * Participations this start created, so the first send can name them before the participations
   * cache refreshes.
   */
  smsParticipations: Array<SmsSessionParticipation>;
};

export type StoredFile = {
  __typename?: 'StoredFile';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  fileKey: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  phoneCallFiles?: Maybe<Array<Maybe<PhoneCallFile>>>;
  size?: Maybe<Scalars['Int']['output']>;
  storedFileId: Scalars['String']['output'];
  transcriptions?: Maybe<Array<Maybe<CallTranscription>>>;
  updatedAt: Scalars['String']['output'];
};

export type StoredFileDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StoredFileDataInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  storedFileId?: InputMaybe<Scalars['String']['input']>;
};

export type StoredFileDataResponse = {
  __typename?: 'StoredFileDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<StoredFile>>>;
};

export type StoredFileSearchResponse = {
  __typename?: 'StoredFileSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<StoredFile>>>;
};

export type StripeConnectedBankAccount = {
  __typename?: 'StripeConnectedBankAccount';
  bankName?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SubmitConversationDataChannelInput = {
  channelType?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  internalIdentifier?: InputMaybe<Scalars['String']['input']>;
  participationMode?: InputMaybe<Scalars['String']['input']>;
  useToSendMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitConversationDataInput = {
  activeChannels?: InputMaybe<Array<InputMaybe<ActiveChannelsInput>>>;
  associatedAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conversation: ConversationDataInput;
  enqueue?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreActiveChannelsFor?: InputMaybe<Array<InputMaybe<IgnoreActiveChannelsInfo>>>;
  isNewConversation?: InputMaybe<Scalars['Boolean']['input']>;
  macroActions?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<MessageDataForSubmission>;
  participants?: InputMaybe<Array<InputMaybe<SubmitConversationDataParticipantInput>>>;
  partnerId: Scalars['Int']['input'];
};

export type SubmitConversationDataParticipantInput = {
  channels?: InputMaybe<Array<InputMaybe<SubmitConversationDataChannelInput>>>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityPartnerId?: InputMaybe<Scalars['Int']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  isRequester?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitConversationDataResponse = {
  __typename?: 'SubmitConversationDataResponse';
  conversation: Conversation;
  message?: Maybe<ConversationMessage>;
};

export type SubmitDay1Input = {
  addressId: Scalars['String']['input'];
  cpp?: InputMaybe<CreateSubscriptionScheduleCppInput>;
  day1Date: Scalars['String']['input'];
  membershipSalesNotes?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  projectId: Scalars['String']['input'];
  psm?: InputMaybe<CreateSubscriptionSchedulePreSoldMembershipInput>;
  sendEducationalEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitDay1Response = {
  __typename?: 'SubmitDay1Response';
  address?: Maybe<Address>;
  preSoldMembership?: Maybe<PreSoldMembership>;
  project?: Maybe<Project>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export type SubmitProposalLostInput = {
  addressId: Scalars['String']['input'];
  lostReasonNotes?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  projectId: Scalars['String']['input'];
  projectLostReasonId: Scalars['Int']['input'];
};

export type SubmitProposalLostResponse = {
  __typename?: 'SubmitProposalLostResponse';
  address?: Maybe<Address>;
  project?: Maybe<Project>;
};

export type SubmitProposalWonInput = {
  addressId: Scalars['String']['input'];
  desiredMembership: Scalars['String']['input'];
  estimatedDay1: Scalars['String']['input'];
  membershipSalesNotes?: InputMaybe<Scalars['String']['input']>;
  orgNotes?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  projectId: Scalars['String']['input'];
  sendEducationalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  tosAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  warrantyLength?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitProposalWonResponse = {
  __typename?: 'SubmitProposalWonResponse';
  address?: Maybe<Address>;
  project?: Maybe<Project>;
};

export type SupportPolicy = {
  __typename?: 'SupportPolicy';
  addressIds?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  clientIds?: Maybe<Scalars['String']['output']>;
  clientToAddressIds?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<PlatformUser>;
  description: Scalars['String']['output'];
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  escalationRules?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  pinnedAt?: Maybe<Scalars['String']['output']>;
  supportPolicyId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  urgencyLevel?: Maybe<Scalars['String']['output']>;
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type SupportPolicyDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SupportPolicyDataInput = {
  addressIds?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Scalars['String']['input']>;
  clientToAddressIds?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  escalationRules?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  pinnedAt?: InputMaybe<Scalars['String']['input']>;
  supportPolicyId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  urgencyLevel?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};

export type SupportPolicyDataResponse = {
  __typename?: 'SupportPolicyDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SupportPolicy>>>;
};

export type SupportPolicyForConversationContext = {
  __typename?: 'SupportPolicyForConversationContext';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SupportPolicySearchResponse = {
  __typename?: 'SupportPolicySearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SupportPolicy>>>;
};

export type SupportPolicyToUserGroup = {
  __typename?: 'SupportPolicyToUserGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partnerId: Scalars['Int']['output'];
  partnerViaPartnerIdPartnerId?: Maybe<Partner>;
  supportPolicyId: Scalars['String']['output'];
  supportPolicyViaSupportPolicyIdSupportPolicyId?: Maybe<SupportPolicy>;
  userGroupId: Scalars['String']['output'];
  userGroupViaUserGroupIdUserGroupId?: Maybe<UserGroup>;
};

export type SupportPolicyToUserGroupDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  supportPolicyId?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type SupportPolicyToUserGroupDataResponse = {
  __typename?: 'SupportPolicyToUserGroupDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SupportPolicyToUserGroup>>>;
};

export type SupportPolicyToUserGroupSearchResponse = {
  __typename?: 'SupportPolicyToUserGroupSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<SupportPolicyToUserGroup>>>;
};

export type SyncEmailBrandingCacheInput = {
  partnerIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type SyncEmailBrandingCacheResponse = {
  __typename?: 'SyncEmailBrandingCacheResponse';
  success: Scalars['Boolean']['output'];
};

export type SyncPartnerSlaInput = {
  partnerIds: Array<Scalars['Int']['input']>;
};

export type SyncPartnerSlaResponse = {
  __typename?: 'SyncPartnerSlaResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  syncedCount: Scalars['Int']['output'];
};

export enum TriageActionResolution {
  Dismiss = 'DISMISS',
  Execute = 'EXECUTE',
}

export type TriageTemplate = {
  __typename?: 'TriageTemplate';
  actionConfig: Scalars['String']['output'];
  defaultVisibility: Scalars['String']['output'];
  instructions: Scalars['String']['output'];
  llmConfig: Scalars['String']['output'];
  tools: Array<TriageTool>;
};

export type TriageTool = {
  __typename?: 'TriageTool';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TriggerIterableSyncInput = {
  partnerIds: Array<Scalars['Int']['input']>;
};

export type TriggerIterableSyncResponse = {
  __typename?: 'TriggerIterableSyncResponse';
  success: Scalars['Boolean']['output'];
  triggeredPartnerIds: Array<Scalars['Int']['output']>;
};

export type TriggerPartnerInvoiceGenerationInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TriggerPartnerInvoiceGenerationResponse = {
  __typename?: 'TriggerPartnerInvoiceGenerationResponse';
  arsRunReportId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  lineItemCount?: Maybe<Scalars['Int']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  payoutAmount?: Maybe<Scalars['Int']['output']>;
  payoutCount?: Maybe<Scalars['Int']['output']>;
  payoutFailedCount?: Maybe<Scalars['Int']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
  totalArsFee?: Maybe<Scalars['Int']['output']>;
  totalPsmFee?: Maybe<Scalars['Int']['output']>;
  transferCount?: Maybe<Scalars['Int']['output']>;
};

export type TwilioClientPartnerInfo = {
  __typename?: 'TwilioClientPartnerInfo';
  address_routing_combinedAddress?: Maybe<Scalars['String']['output']>;
  address_routing_serviceLevel?: Maybe<Scalars['String']['output']>;
  address_routing_tosAccepted?: Maybe<Scalars['String']['output']>;
  address_routing_zdOrgId?: Maybe<Scalars['String']['output']>;
  address_sla?: Maybe<Scalars['Int']['output']>;
  addresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignee_email?: Maybe<Scalars['String']['output']>;
  brandGroupName?: Maybe<Scalars['String']['output']>;
  brand_displayName?: Maybe<Scalars['String']['output']>;
  brand_fwdPhoneReroute?: Maybe<Scalars['String']['output']>;
  client_firstName?: Maybe<Scalars['String']['output']>;
  client_is_blocked?: Maybe<Scalars['String']['output']>;
  client_lastName?: Maybe<Scalars['String']['output']>;
  client_primaryEmail?: Maybe<Scalars['String']['output']>;
  client_primaryPhone?: Maybe<Scalars['String']['output']>;
  client_zdUserId?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  displayConversationId?: Maybe<Scalars['String']['output']>;
  is_ah?: Maybe<Scalars['String']['output']>;
  is_sms_closed?: Maybe<Scalars['String']['output']>;
  partner_guruUrl?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['Int']['output']>;
  partner_litsStatus?: Maybe<Scalars['String']['output']>;
  partner_screenPopActive?: Maybe<Scalars['Boolean']['output']>;
  partner_supportEmail?: Maybe<Scalars['String']['output']>;
  partner_supportPhone?: Maybe<Scalars['String']['output']>;
  partner_timeZone?: Maybe<Scalars['String']['output']>;
  partner_zendeskDomain?: Maybe<Scalars['String']['output']>;
  partner_zendeskUrl?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requester_email?: Maybe<Scalars['String']['output']>;
  skippedAddresses?: Maybe<Scalars['Int']['output']>;
  task_id?: Maybe<Scalars['String']['output']>;
  ticket_link?: Maybe<Scalars['String']['output']>;
  ticket_status?: Maybe<Scalars['String']['output']>;
  ticket_subject?: Maybe<Scalars['String']['output']>;
  wav_file_inbound?: Maybe<Scalars['String']['output']>;
  wav_file_name?: Maybe<Scalars['String']['output']>;
  wav_file_outbound?: Maybe<Scalars['String']['output']>;
};

export type UndoBulkUpdateEntitiesInput = {
  jobId: Scalars['String']['input'];
};

export type UndoBulkUpdateEntitiesResponse = {
  __typename?: 'UndoBulkUpdateEntitiesResponse';
  errorCode: BulkUpdateInitErrorCode;
  failedCount: Scalars['Int']['output'];
  jobId: Scalars['String']['output'];
  status: BulkUpdateJobStatus;
  undoIneligibilityCode?: Maybe<BulkUpdateUndoIneligibilityCode>;
  undoIneligibilityMessage?: Maybe<Scalars['String']['output']>;
  undoUsedAt?: Maybe<Scalars['String']['output']>;
  updatedCount: Scalars['Int']['output'];
};

export type UnpauseSubscriptionInput = {
  addressId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type UnresolveConversationMessageThreadInput = {
  conversationMessageId: Scalars['String']['input'];
};

export type UpdateBehaviorSortingParams = {
  behaviorId: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

export type UpdateBehaviorSortingResponse = {
  __typename?: 'UpdateBehaviorSortingResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateConversationAsSeenInput = {
  conversationId: Scalars['String']['input'];
};

export type UpdateConversationAsSeenResponse = {
  __typename?: 'UpdateConversationAsSeenResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateConversationPrivateMessageFileInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdateConversationPrivateMessageInput = {
  newMessage: UpdateConversationPrivateMessageNewMessageInput;
  originalMessage: UpdateConversationPrivateMessageOriginalMessageInput;
};

export type UpdateConversationPrivateMessageNewMessageInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpdateConversationPrivateMessageFileInput>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  editedAt: Scalars['String']['input'];
};

export type UpdateConversationPrivateMessageOriginalMessageInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpdateConversationPrivateMessageFileInput>>>;
  conversationId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type UpdateEntityViewerInput = {
  entity: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};

export type UpdateEntityViewerResult = {
  __typename?: 'UpdateEntityViewerResult';
  success: Scalars['Boolean']['output'];
};

export type UpdatePublicApiKeyInput = {
  allowedOperations: Array<PublicApiAllowedOperationInput>;
  apiKeyId: Scalars['String']['input'];
  partnerId: Scalars['Int']['input'];
};

export type UpdateSupportPolicyWithGroupsInput = {
  id: Scalars['String']['input'];
  supportPolicy: SupportPolicyDataInput;
  userGroupIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UpdateUserActiveStateDataInput = {
  isActive: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserActiveStateDataResponse = {
  __typename?: 'UpdateUserActiveStateDataResponse';
  userId: Scalars['String']['output'];
};

export type UpdateUserPresenceInput = {
  assigneeGroups: Array<InputMaybe<UserPresenceAssigneeGroupInput>>;
  partnerId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  tz: Scalars['String']['input'];
};

export type UpdateUserPresenceResult = {
  __typename?: 'UpdateUserPresenceResult';
  success: Scalars['Boolean']['output'];
};

export type UploadFileInfo = {
  __typename?: 'UploadFileInfo';
  getURL: Scalars['String']['output'];
  putURL: Scalars['String']['output'];
};

export type UploadFileInfoInput = {
  contentType: Scalars['String']['input'];
  fileKey?: InputMaybe<Scalars['String']['input']>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadPartnerInitFileInfoInput = {
  contentType: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertConversationMessageDraftInput = {
  attachments?: InputMaybe<Array<ConversationDraftAttachmentInput>>;
  conversationId: Scalars['String']['input'];
  discardedAt?: InputMaybe<Scalars['String']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  messageHtml?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  sendUnless?: InputMaybe<Scalars['String']['input']>;
  sideEffects?: InputMaybe<Scalars['String']['input']>;
};

export type UserCommunicationPreference = {
  __typename?: 'UserCommunicationPreference';
  communicationChannel: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  priority: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userCommunicationPreferenceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserCommunicationPreferenceDataInput = {
  communicationChannel?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  userCommunicationPreferenceId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserCommunicationPreferenceDataResponse = {
  __typename?: 'UserCommunicationPreferenceDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserCommunicationPreference>>>;
};

export type UserCommunicationPreferenceSearchResponse = {
  __typename?: 'UserCommunicationPreferenceSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserCommunicationPreference>>>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  aiPrompts?: Maybe<Array<Maybe<AiPrompt>>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUsers?: Maybe<Array<Maybe<PlatformUser>>>;
  ruleValues?: Maybe<Array<Maybe<UserGroupRuleValue>>>;
  supportPolicyToUserGroupRecordsViaUserGroupIdUserGroupId?: Maybe<
    Array<Maybe<SupportPolicyToUserGroup>>
  >;
  updatedAt: Scalars['String']['output'];
  userGroupId: Scalars['String']['output'];
  userGroupSettingValues?: Maybe<Array<Maybe<UserGroupSettingValue>>>;
};

export type UserGroupDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupDataResponse = {
  __typename?: 'UserGroupDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroup>>>;
};

export type UserGroupRule = {
  __typename?: 'UserGroupRule';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userGroupRuleId: Scalars['String']['output'];
  userGroupRuleValues?: Maybe<Array<Maybe<UserGroupRuleValue>>>;
};

export type UserGroupRuleDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userGroupRuleId?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupRuleDataResponse = {
  __typename?: 'UserGroupRuleDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroupRule>>>;
};

export type UserGroupRuleSearchResponse = {
  __typename?: 'UserGroupRuleSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroupRule>>>;
};

export type UserGroupRuleValue = {
  __typename?: 'UserGroupRuleValue';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userGroup?: Maybe<UserGroup>;
  userGroupId: Scalars['String']['output'];
  userGroupRule?: Maybe<UserGroupRule>;
  userGroupRuleId: Scalars['String']['output'];
  userGroupRuleValueId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type UserGroupRuleValueDataInput = {
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userGroupRuleId?: InputMaybe<Scalars['String']['input']>;
  userGroupRuleValueId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupRuleValueDataResponse = {
  __typename?: 'UserGroupRuleValueDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroupRuleValue>>>;
};

export type UserGroupRuleValueSearchResponse = {
  __typename?: 'UserGroupRuleValueSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroupRuleValue>>>;
};

export type UserGroupSearchResponse = {
  __typename?: 'UserGroupSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroup>>>;
};

export type UserGroupSettingValue = {
  __typename?: 'UserGroupSettingValue';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userGroup?: Maybe<UserGroup>;
  userGroupId: Scalars['String']['output'];
  userGroupSettingValueId: Scalars['String']['output'];
  userSetting?: Maybe<UserSetting>;
  userSettingId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type UserGroupSettingValueDataInput = {
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userGroupSettingValueId?: InputMaybe<Scalars['String']['input']>;
  userSettingId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupSettingValueDataResponse = {
  __typename?: 'UserGroupSettingValueDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroupSettingValue>>>;
};

export type UserGroupSettingValueSearchResponse = {
  __typename?: 'UserGroupSettingValueSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserGroupSettingValue>>>;
};

export type UserNotificationRole = {
  __typename?: 'UserNotificationRole';
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  notificationPreference?: Maybe<NotificationPreference>;
  notificationPreferenceId?: Maybe<Scalars['String']['output']>;
  notificationRole?: Maybe<NotificationRole>;
  notificationRoleId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  userId: Scalars['String']['output'];
  userNotificationRoleId: Scalars['String']['output'];
};

export type UserNotificationRoleDataInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notificationPreferenceId?: InputMaybe<Scalars['String']['input']>;
  notificationRoleId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userNotificationRoleId?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationRoleDataResponse = {
  __typename?: 'UserNotificationRoleDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserNotificationRole>>>;
};

export type UserNotificationRoleSearchResponse = {
  __typename?: 'UserNotificationRoleSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserNotificationRole>>>;
};

export type UserPresenceAssigneeGroup = {
  __typename?: 'UserPresenceAssigneeGroup';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserPresenceAssigneeGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UserPresenceItem = {
  __typename?: 'UserPresenceItem';
  assigneeGroups: Array<Maybe<UserPresenceAssigneeGroup>>;
  expiresAt: Scalars['Int']['output'];
  lastSeen: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  tz: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserSetting = {
  __typename?: 'UserSetting';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userGroupSettingValues?: Maybe<Array<Maybe<UserGroupSettingValue>>>;
  userSettingId: Scalars['String']['output'];
  userSettingValues?: Maybe<Array<Maybe<UserSettingValue>>>;
};

export type UserSettingDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userSettingId?: InputMaybe<Scalars['String']['input']>;
};

export type UserSettingDataResponse = {
  __typename?: 'UserSettingDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserSetting>>>;
};

export type UserSettingSearchResponse = {
  __typename?: 'UserSettingSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserSetting>>>;
};

export type UserSettingValue = {
  __typename?: 'UserSettingValue';
  createdAt: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  labelAssignments?: Maybe<Array<Maybe<LabelAssignment>>>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  platformUser?: Maybe<PlatformUser>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userSetting?: Maybe<UserSetting>;
  userSettingId: Scalars['String']['output'];
  userSettingValueId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type UserSettingValueDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userSettingId?: InputMaybe<Scalars['String']['input']>;
  userSettingValueId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type UserSettingValueDataResponse = {
  __typename?: 'UserSettingValueDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserSettingValue>>>;
};

export type UserSettingValueSearchResponse = {
  __typename?: 'UserSettingValueSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<UserSettingValue>>>;
};

export type UserToUserGroup = {
  __typename?: 'UserToUserGroup';
  createdAt: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  userGroupId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserToUserGroupDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Viewer = {
  __typename?: 'Viewer';
  expiresAt: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastSeen: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  viewerId: Scalars['String']['output'];
};

export type Workflow = {
  __typename?: 'Workflow';
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  workflowAssignments?: Maybe<Array<Maybe<WorkflowAssignment>>>;
  workflowId: Scalars['String']['output'];
  workflowVersions?: Maybe<Array<Maybe<WorkflowVersion>>>;
};

export type WorkflowAssignment = {
  __typename?: 'WorkflowAssignment';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  triggerType: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  workflow?: Maybe<Workflow>;
  workflowAssignmentId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
  workflowPartnerId: Scalars['Int']['output'];
};

export type WorkflowAssignmentDataInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  triggerType?: InputMaybe<Scalars['String']['input']>;
  workflowAssignmentId?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
  workflowPartnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowAssignmentDataResponse = {
  __typename?: 'WorkflowAssignmentDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowAssignment>>>;
};

export type WorkflowAssignmentSearchResponse = {
  __typename?: 'WorkflowAssignmentSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowAssignment>>>;
};

export type WorkflowDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowDataResponse = {
  __typename?: 'WorkflowDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Workflow>>>;
};

/**
 * One problem in a workflow definition. `nodeId` names the step that caused it; null for problems of
 * the graph as a whole. `field` is a dot path inside the step's `data`, e.g. `waitMenu.maxAttempts`.
 */
export type WorkflowDefinitionError = {
  __typename?: 'WorkflowDefinitionError';
  edgeId?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  nodeId?: Maybe<Scalars['String']['output']>;
};

export type WorkflowExecution = {
  __typename?: 'WorkflowExecution';
  createdAt?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  workflowExecutionId: Scalars['String']['output'];
  workflowExecutionLogs?: Maybe<Array<Maybe<WorkflowExecutionLog>>>;
};

export type WorkflowExecutionDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WorkflowExecutionDataInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  workflowExecutionId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowExecutionDataResponse = {
  __typename?: 'WorkflowExecutionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowExecution>>>;
};

export type WorkflowExecutionLog = {
  __typename?: 'WorkflowExecutionLog';
  createdAt?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  node: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  workflowExecution?: Maybe<WorkflowExecution>;
  workflowExecutionId: Scalars['String']['output'];
  workflowExecutionLogId: Scalars['String']['output'];
};

export type WorkflowExecutionLogDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WorkflowExecutionLogDataInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  node?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  workflowExecutionId?: InputMaybe<Scalars['String']['input']>;
  workflowExecutionLogId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowExecutionLogDataResponse = {
  __typename?: 'WorkflowExecutionLogDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowExecutionLog>>>;
};

export type WorkflowExecutionLogSearchResponse = {
  __typename?: 'WorkflowExecutionLogSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowExecutionLog>>>;
};

export type WorkflowExecutionSearchResponse = {
  __typename?: 'WorkflowExecutionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowExecution>>>;
};

export type WorkflowSearchResponse = {
  __typename?: 'WorkflowSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<Workflow>>>;
};

export type WorkflowStepField = {
  __typename?: 'WorkflowStepField';
  /** For STEP_LIST: the step types allowed in the list. */
  allowedStepTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** For BOOLEAN and BOOLEAN_OR_CONDITION: true when an unset setting runs as on. */
  defaultOn?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** For GROUP: the nested fields. One level deep. */
  fields?: Maybe<Array<WorkflowStepField>>;
  /** Key inside the step's `data`, or inside the parent field for GROUP children. */
  key: Scalars['String']['output'];
  kind: WorkflowStepFieldKind;
  label: Scalars['String']['output'];
  options?: Maybe<Array<WorkflowStepFieldOption>>;
  reference?: Maybe<WorkflowStepFieldReference>;
  required: Scalars['Boolean']['output'];
  requiredUnless?: Maybe<WorkflowStepFieldRequiredUnless>;
  /** For SCALAR: any of STRING, NUMBER, BOOLEAN. */
  valueTypes?: Maybe<Array<Scalars['String']['output']>>;
};

/** How the editor renders and checks a field of a workflow step's `data`. */
export enum WorkflowStepFieldKind {
  Boolean = 'BOOLEAN',
  /** Either a boolean or an If-style condition (operand / operator / value). */
  BooleanOrCondition = 'BOOLEAN_OR_CONDITION',
  Enum = 'ENUM',
  /** An object whose own fields are listed in `fields`. */
  Group = 'GROUP',
  /** A map of names to TEMPLATE values. */
  KeyValue = 'KEY_VALUE',
  Number = 'NUMBER',
  /** Dot path read from the run, e.g. `input.triggerContext.partner.name` or `state.<stepId>`. */
  Path = 'PATH',
  /** A string, number or boolean; `valueTypes` lists which. */
  Scalar = 'SCALAR',
  /** A list of embedded steps; `allowedStepTypes` lists which. */
  StepList = 'STEP_LIST',
  /** Text that may hold `{{input...}}` / `{{state...}}` interpolation. */
  Template = 'TEMPLATE',
  /** A list of { day, startHour, startMinute, endHour, endMinute }. */
  TimeRanges = 'TIME_RANGES',
}

export type WorkflowStepFieldOption = {
  __typename?: 'WorkflowStepFieldOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * The field's value is built from the output of an earlier step of one of `stepTypes`, read at
 * `outputPath` — `{{state.<stepId>.<outputPath>}}`.
 */
export type WorkflowStepFieldReference = {
  __typename?: 'WorkflowStepFieldReference';
  outputPath: Scalars['String']['output'];
  stepTypes: Array<Scalars['String']['output']>;
};

/** The field is required unless its sibling field `key` holds one of `oneOf`. */
export type WorkflowStepFieldRequiredUnless = {
  __typename?: 'WorkflowStepFieldRequiredUnless';
  key: Scalars['String']['output'];
  oneOf: Array<Scalars['String']['output']>;
};

/**
 * An outgoing connection a step offers. `condition` is the value an edge from this output carries in
 * `edge.data.condition` (true / false on `if`); null for the single `next` output of other steps.
 */
export type WorkflowStepOutput = {
  __typename?: 'WorkflowStepOutput';
  condition?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum WorkflowStepResultKind {
  None = 'NONE',
  Object = 'OBJECT',
  Scalar = 'SCALAR',
  Twiml = 'TWIML',
}

export type WorkflowStepType = {
  __typename?: 'WorkflowStepType';
  description: Scalars['String']['output'];
  fields: Array<WorkflowStepField>;
  isTrigger: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  outputs: Array<WorkflowStepOutput>;
  result: WorkflowStepResultKind;
  /** Trigger types this step can run on. */
  triggerTypes: Array<Scalars['String']['output']>;
  /** The `node.type` value. */
  type: Scalars['String']['output'];
  width: WorkflowStepWidth;
};

/**
 * How wide a step's card can be on the canvas, in px. A step stores its own `width` next to `position`;
 * the canvas uses `default` when it has none. Canvas-only: the run time never reads it.
 */
export type WorkflowStepWidth = {
  __typename?: 'WorkflowStepWidth';
  default: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type WorkflowTriggerType = {
  __typename?: 'WorkflowTriggerType';
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WorkflowVersion = {
  __typename?: 'WorkflowVersion';
  createdAt: Scalars['String']['output'];
  definition: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dynamicAttributes?: Maybe<Array<Maybe<DynamicEntityAttribute>>>;
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  workflow?: Maybe<Workflow>;
  workflowId: Scalars['String']['output'];
  workflowVersionId: Scalars['String']['output'];
};

export type WorkflowVersionDynamicAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WorkflowVersionDataInput = {
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicAttributes?: InputMaybe<Array<InputMaybe<DynamicEntityAttributeInput>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
  workflowVersionId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowVersionDataResponse = {
  __typename?: 'WorkflowVersionDataResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowVersion>>>;
};

export type WorkflowVersionSearchResponse = {
  __typename?: 'WorkflowVersionSearchResponse';
  metadata: MetaData;
  records?: Maybe<Array<Maybe<WorkflowVersion>>>;
};

export type GetUserLiveTranscriptionQueryVariables = Exact<{
  params: GetUserLiveTranscriptionInput;
}>;

export type GetUserLiveTranscriptionQuery = {
  __typename?: 'Query';
  getUserLiveTranscription?: {
    __typename?: 'GetUserLiveTranscriptionResponse';
    transcriptionId: string;
    externalTranscriptionId: string;
    partnerId: number;
    userId: string;
    isFinished: boolean;
    cursor?: string | null;
    segments: Array<{
      __typename?: 'LiveTranscriptionSegment';
      role: string;
      timestamp: string;
      transcriptionText: string;
      start?: number | null;
      duration?: number | null;
    } | null>;
  } | null;
};

export type ClientMenu_ClientFragment = ({ __typename?: 'Client'; id?: string | null } & {
  ' $fragmentRefs'?: { UseClientActions_ClientFragment: UseClientActions_ClientFragment };
}) & { ' $fragmentName'?: 'ClientMenu_ClientFragment' };

export type UseClientActions_ClientFragment = {
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  isDeleted: boolean;
  deletedAt?: string | null;
  notes?: string | null;
  marketingOptOut?: boolean | null;
  primaryEmail?: {
    __typename?: 'ClientEmail';
    id?: string | null;
    value: string;
    labelId?: number | null;
  } | null;
  primaryPhoneNumber?: {
    __typename?: 'ClientPhoneNumber';
    id?: string | null;
    value: number;
    labelId?: number | null;
  } | null;
  emails?: Array<{
    __typename?: 'ClientEmail';
    id?: string | null;
    clientEmailId: string;
    value: string;
    labelId?: number | null;
  } | null> | null;
  phoneNumbers?: Array<{
    __typename?: 'ClientPhoneNumber';
    id?: string | null;
    clientPhoneNumberId: string;
    value: number;
    labelId?: number | null;
  } | null> | null;
} & { ' $fragmentName'?: 'UseClientActions_ClientFragment' };

export type UseClientQuickActions_ClientFragment = ({
  __typename?: 'Client';
  id?: string | null;
} & {
  ' $fragmentRefs'?: { UseClientActions_ClientFragment: UseClientActions_ClientFragment };
}) & { ' $fragmentName'?: 'UseClientQuickActions_ClientFragment' };

export type SendMembershipEmailClientsQueryQueryVariables = Exact<{
  params?: InputMaybe<QueryParamsWithSearch>;
}>;

export type SendMembershipEmailClientsQueryQuery = {
  __typename?: 'Query';
  getClient?: {
    __typename?: 'ClientDataResponse';
    records?: Array<{
      __typename?: 'Client';
      id?: string | null;
      clientId: string;
      firstName: string;
      lastName: string;
      fullName: string;
      primaryEmail?: { __typename?: 'ClientEmail'; id?: string | null; value: string } | null;
      emails?: Array<{
        __typename?: 'ClientEmail';
        id?: string | null;
        value: string;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ClientRelatedTabs_ClientFragment = {
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  deletedAt?: string | null;
  primaryEmail?: { __typename?: 'ClientEmail'; id?: string | null; value: string } | null;
} & { ' $fragmentName'?: 'ClientRelatedTabs_ClientFragment' };

export type ClientCard_ClientFragment = ({
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  isDeleted: boolean;
  deletedAt?: string | null;
  notes?: string | null;
  primaryEmail?: {
    __typename?: 'ClientEmail';
    id?: string | null;
    value: string;
    labelId?: number | null;
  } | null;
  primaryPhoneNumber?: {
    __typename?: 'ClientPhoneNumber';
    id?: string | null;
    value: number;
    labelId?: number | null;
  } | null;
  emails?: Array<{
    __typename?: 'ClientEmail';
    id?: string | null;
    value: string;
    labelId?: number | null;
  } | null> | null;
  phoneNumbers?: Array<{
    __typename?: 'ClientPhoneNumber';
    id?: string | null;
    value: number;
    labelId?: number | null;
  } | null> | null;
} & { ' $fragmentRefs'?: { ClientMenu_ClientFragment: ClientMenu_ClientFragment } }) & {
  ' $fragmentName'?: 'ClientCard_ClientFragment';
};

export type SiteShareClientsQueryQueryVariables = Exact<{
  params?: InputMaybe<QueryParamsWithSearch>;
}>;

export type SiteShareClientsQueryQuery = {
  __typename?: 'Query';
  getClient?: {
    __typename?: 'ClientDataResponse';
    records?: Array<{
      __typename?: 'Client';
      id?: string | null;
      clientId: string;
      firstName: string;
      lastName: string;
      primaryEmail?: { __typename?: 'ClientEmail'; id?: string | null; value: string } | null;
    } | null> | null;
  } | null;
};

export type ClientExpandedQueriesQueryVariables = Exact<{
  params?: InputMaybe<QueryParamsWithSearch>;
}>;

export type ClientExpandedQueriesQuery = {
  __typename?: 'Query';
  getClient?: {
    __typename?: 'ClientDataResponse';
    records?: Array<
      | ({ __typename?: 'Client'; id?: string | null } & {
          ' $fragmentRefs'?: { ClientExpanded_ClientFragment: ClientExpanded_ClientFragment };
        })
      | null
    > | null;
  } | null;
};

export type ClientExpanded_ClientFragment = ({
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  primaryEmail?: { __typename?: 'ClientEmail'; id?: string | null; value: string } | null;
} & {
  ' $fragmentRefs'?: {
    ClientWindow_ClientFragment: ClientWindow_ClientFragment;
    ClientSidePanel_ClientFragment: ClientSidePanel_ClientFragment;
  };
}) & { ' $fragmentName'?: 'ClientExpanded_ClientFragment' };

export type ClientLabelQueryQueryVariables = Exact<{
  params?: InputMaybe<QueryParamsWithSearch>;
}>;

export type ClientLabelQueryQuery = {
  __typename?: 'Query';
  getClient?: {
    __typename?: 'ClientDataResponse';
    records?: Array<
      | ({ __typename?: 'Client'; id?: string | null } & {
          ' $fragmentRefs'?: { ClientLabel_ClientFragment: ClientLabel_ClientFragment };
        })
      | null
    > | null;
  } | null;
};

export type ClientLabel_ClientFragment = {
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  partner?: {
    __typename?: 'Partner';
    id?: number | null;
    businessName?: string | null;
  } | null;
} & { ' $fragmentName'?: 'ClientLabel_ClientFragment' };

export type ClientSidePanel_ClientFragment = ({
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  isDeleted: boolean;
  deletedAt?: string | null;
  primaryEmail?: { __typename?: 'ClientEmail'; id?: string | null; value: string } | null;
  partner?: {
    __typename?: 'Partner';
    id?: number | null;
    partnerId: number;
    businessName?: string | null;
    timeZone?: string | null;
    supportPhone?: string | null;
    supportEmail?: string | null;
    membershipEmail?: string | null;
    supportLiveDate?: string | null;
    litsDate?: string | null;
    partnerOnesheet?: Array<{
      __typename?: 'PartnerOnesheet';
      id?: number | null;
      partnerId: number;
      mainOfficePhone?: string | null;
      asTransferForBusinessHoursOnly?: string | null;
      internalSupportNotes?: string | null;
      escalationPolicy?: string | null;
      recentAnnouncements?: string | null;
      whatIsYourEquipmentRepairPolicy?: string | null;
      primaryRsmTool?: string | null;
    } | null> | null;
    brandGroups?: Array<{
      __typename?: 'BrandGroup';
      id?: string | null;
      brandGroupId: string;
      fwdPhonePublished?: number | null;
      fwdPhonePublishedExt?: number | null;
      fwdPhoneSupport?: number | null;
      supportEmail?: string | null;
      membershipEmail?: string | null;
    } | null> | null;
  } | null;
} & {
  ' $fragmentRefs'?: {
    ClientCard_ClientFragment: ClientCard_ClientFragment;
    ClientMenu_ClientFragment: ClientMenu_ClientFragment;
    ClientRelatedTabs_ClientFragment: ClientRelatedTabs_ClientFragment;
    UseClientQuickActions_ClientFragment: UseClientQuickActions_ClientFragment;
  };
}) & { ' $fragmentName'?: 'ClientSidePanel_ClientFragment' };

export type ClientWindowTabContent_ClientFragment = {
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  deletedAt?: string | null;
} & { ' $fragmentName'?: 'ClientWindowTabContent_ClientFragment' };

export type ClientWindow_ClientFragment = ({
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  deletedAt?: string | null;
} & {
  ' $fragmentRefs'?: {
    ClientWindowTabContent_ClientFragment: ClientWindowTabContent_ClientFragment;
    ClientSidePanel_ClientFragment: ClientSidePanel_ClientFragment;
    ClientMenu_ClientFragment: ClientMenu_ClientFragment;
  };
}) & { ' $fragmentName'?: 'ClientWindow_ClientFragment' };

export type DeepLinkTargetMessageQueryQueryVariables = Exact<{
  params?: InputMaybe<QueryParamsWithSearch>;
}>;

export type DeepLinkTargetMessageQueryQuery = {
  __typename?: 'Query';
  getConversationMessage?: {
    __typename?: 'ConversationMessageDataResponse';
    records?: Array<{
      __typename?: 'ConversationMessage';
      id?: string | null;
      conversationMessageId: string;
      parentConversationMessageId?: string | null;
      createdAt: string;
    } | null> | null;
  } | null;
};

export type RegisterConversationDefaultsQueryQueryVariables = Exact<{
  params?: InputMaybe<QueryParamsWithSearch>;
}>;

export type RegisterConversationDefaultsQueryQuery = {
  __typename?: 'Query';
  getClient?: {
    __typename?: 'ClientDataResponse';
    records?: Array<
      | ({ __typename?: 'Client'; id?: string | null } & {
          ' $fragmentRefs'?: {
            RegisterConversationDefaults_ClientFragment: RegisterConversationDefaults_ClientFragment;
          };
        })
      | null
    > | null;
  } | null;
};

export type RegisterConversationDefaults_ClientFragment = {
  __typename?: 'Client';
  id?: string | null;
  clientId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  primaryEmail?: { __typename?: 'ClientEmail'; id?: string | null; value: string } | null;
} & { ' $fragmentName'?: 'RegisterConversationDefaults_ClientFragment' };

export const ClientWindowTabContent_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientWindowTabContent_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientWindowTabContent_ClientFragment, unknown>;
export const UseClientActions_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseClientActions_ClientFragment, unknown>;
export const ClientMenu_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientMenu_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientMenu_ClientFragment, unknown>;
export const ClientCard_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientCard_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientMenu_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientCard_ClientFragment, unknown>;
export const ClientRelatedTabs_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientRelatedTabs_ClientFragment, unknown>;
export const UseClientQuickActions_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseClientQuickActions_ClientFragment, unknown>;
export const ClientSidePanel_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientSidePanel_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportLiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'litsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partnerOnesheet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainOfficePhone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asTransferForBusinessHoursOnly' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'internalSupportNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'escalationPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recentAnnouncements' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'whatIsYourEquipmentRepairPolicy' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryRsmTool' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brandGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublishedExt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhoneSupport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientCard_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientMenu_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientCard_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientSidePanel_ClientFragment, unknown>;
export const ClientWindow_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientWindow_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ClientWindowTabContent_Client' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientSidePanel_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientMenu_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientCard_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientWindowTabContent_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientSidePanel_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportLiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'litsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partnerOnesheet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainOfficePhone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asTransferForBusinessHoursOnly' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'internalSupportNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'escalationPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recentAnnouncements' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'whatIsYourEquipmentRepairPolicy' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryRsmTool' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brandGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublishedExt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhoneSupport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientCard_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientWindow_ClientFragment, unknown>;
export const ClientExpanded_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientExpanded_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientWindow_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientSidePanel_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientWindowTabContent_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientMenu_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientCard_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientSidePanel_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportLiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'litsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partnerOnesheet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainOfficePhone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asTransferForBusinessHoursOnly' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'internalSupportNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'escalationPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recentAnnouncements' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'whatIsYourEquipmentRepairPolicy' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryRsmTool' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brandGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublishedExt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhoneSupport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientCard_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientWindow_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ClientWindowTabContent_Client' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientSidePanel_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientExpanded_ClientFragment, unknown>;
export const ClientLabel_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientLabel_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientLabel_ClientFragment, unknown>;
export const RegisterConversationDefaults_ClientFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterConversationDefaults_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterConversationDefaults_ClientFragment, unknown>;
export const GetUserLiveTranscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserLiveTranscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GetUserLiveTranscriptionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserLiveTranscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'transcriptionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalTranscriptionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFinished' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'segments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'transcriptionText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserLiveTranscriptionQuery,
  GetUserLiveTranscriptionQueryVariables
>;
export const SendMembershipEmailClientsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendMembershipEmailClientsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryParamsWithSearch' } },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'entity' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'name' },
              value: { kind: 'StringValue', value: 'Client', block: false },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullName' },
                        directives: [
                          { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
                        ],
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEmail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'emails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendMembershipEmailClientsQueryQuery,
  SendMembershipEmailClientsQueryQueryVariables
>;
export const SiteShareClientsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SiteShareClientsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryParamsWithSearch' } },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'entity' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'name' },
              value: { kind: 'StringValue', value: 'Client', block: false },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEmail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteShareClientsQueryQuery, SiteShareClientsQueryQueryVariables>;
export const ClientExpandedQueriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientExpandedQueries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryParamsWithSearch' } },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'entity' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'name' },
              value: { kind: 'StringValue', value: 'Client', block: false },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ClientExpanded_Client' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientWindowTabContent_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'marketingOptOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientEmailId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientPhoneNumberId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientMenu_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientCard_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryPhoneNumber' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumbers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelId' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseClientActions_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientSidePanel_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDeleted' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'supportLiveDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'litsDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partnerOnesheet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainOfficePhone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asTransferForBusinessHoursOnly' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'internalSupportNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'escalationPolicy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recentAnnouncements' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'whatIsYourEquipmentRepairPolicy' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryRsmTool' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brandGroupId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhonePublishedExt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fwdPhoneSupport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supportEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'membershipEmail' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientCard_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ClientRelatedTabs_Client' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UseClientQuickActions_Client' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientWindow_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ClientWindowTabContent_Client' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientSidePanel_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientMenu_Client' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientExpanded_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientWindow_Client' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClientSidePanel_Client' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientExpandedQueriesQuery, ClientExpandedQueriesQueryVariables>;
export const ClientLabelQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClientLabelQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryParamsWithSearch' } },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'entity' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'name' },
              value: { kind: 'StringValue', value: 'Client', block: false },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ClientLabel_Client' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientLabel_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientLabelQueryQuery, ClientLabelQueryQueryVariables>;
export const DeepLinkTargetMessageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeepLinkTargetMessageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryParamsWithSearch' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConversationMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationMessageId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentConversationMessageId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeepLinkTargetMessageQueryQuery,
  DeepLinkTargetMessageQueryQueryVariables
>;
export const RegisterConversationDefaultsQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RegisterConversationDefaultsQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryParamsWithSearch' } },
        },
      ],
      directives: [
        {
          kind: 'Directive',
          name: { kind: 'Name', value: 'entity' },
          arguments: [
            {
              kind: 'Argument',
              name: { kind: 'Name', value: 'name' },
              value: { kind: 'StringValue', value: 'Client', block: false },
            },
          ],
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryParams' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'params' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RegisterConversationDefaults_Client' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterConversationDefaults_Client' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullName' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEmail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterConversationDefaultsQueryQuery,
  RegisterConversationDefaultsQueryQueryVariables
>;
